let data = [
    {
      id1: 1,
      title: "'True vs False' Funny Historical Game",
      type: "international",
      groupprice: "274",
      priceadult: "24",
      pricechildren: "20",
      priceinfant: "0",
      ratings: "4.92",
      rating: "(2496)",
      place: "Athens , Greece",
      place2: "Athens ",

      host: " Frank",
      hostimg:
        "https://a0.muscache.com/im/pictures/user/b9a19e5d-27b6-4273-88c6-aa8930076406.jpg?im_w=240",
      images: [
        {
          id: 1,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1710354-active_media/original/dbae932c-bfb7-45ad-96c2-6abf5fedbd7e.jpeg?im_w=320",
        },
        {
          id: 2,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1710354-active_media/original/f2685777-de41-4d2e-a590-0a83376fcae5.jpg?im_w=1200",
        },
        {
          id: 3,
          URL: "https://a0.muscache.com/im/pictures/1af93422-f619-4dd4-911d-456c0521ac5c.jpg?im_w=1200",
        },
        {
          id: 4,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1710354-active_media/original/8f0912e0-e6e4-4c57-9a72-9f47631df2b5.jpg?im_w=1200",
        },
        {
          id: 5,
          URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1710354-active_media/original/a14573d8-e406-4602-abcd-60dfbc4827ff.jpg?im_w=1200",
        },
      ],
      title2: "Online experience hosted by Frank",
      time: "60",
      language: "English",
  
      what1:
        "Book the #1, top rated Airbnb experience for your next team building event. Also fun for friends and family",
      what2:
        "This is not your standard historical experience This is an interactive game with the greatest philosopher of all times Socrates! Amazing facts, bizarre stories and funny gossip from the ancient world. But also some made-up bullsh!t",
  
      what3:
        " Can you spot the True and the False stories ? Call me a liar, take my pulse and try to read my poker face, as I mix bold-faced lies amongst historical truths Fear not, we will separate facts from fiction at the end",
  
      bring1:
        "  ✔️ You'll need a stable internet connection and a device with functioning audio and video  ",
      bring2: "✔️ Bring your lie detector! ",
  
      hostsince: "2014",
      host2:
        "We are Frank and Nikos - the guys that will tell you the bizarre and kinky stuff about ancient Greece that school or movies wouldn't dare. Forget the boring stuff. We handpicked the craziest stories to remember for life.",
  
        date: [
          { date: "25 Aug", time: "3:30" , id:1 },
          { date: "24 Aug", time: "3:30" , id:2  },
          { date: "24 Aug", time: "4:30" , id:3  },
          { date: "24 Aug", time: "5:30" , id:4  },
          { date: "25 Aug", time: "6:30" , id:5  },
          { date: "25 Aug", time: "7:30"  , id:6 },
          { date: "25 Aug", time: "8:30" , id:7 },
          { date: "26 Aug", time: "5:30"  , id:8 },
          { date: "26 Aug", time: "10:30" , id:9  },
          { date: "26 Aug", time: "3:30" , id:10 },
          { date: "27 Aug", time: "9:30" , id:11 },
          { date: "27 Aug", time: "6:30" , id:12 },
          { date: "27 Aug", time: "1:30" , id:13  },
          { date: "28 Aug", time: "3:30" , id:14  },
          { date: "28 Aug", time: "11:30" , id:15  },
          { date: "29 Aug", time: "12:30"  , id:16 },
          { date: "29 Aug", time: "9:30" , id:17  },
        ],
  
      comments: [
        {
          id: 1,
          name: "Jessika",
          date: "August 2022",
          comment:
            "Our team are spread out around the world, but operated on Australian time, which unfortunately was about 4am in Greece, yet the team were very responsive and made",
          URL: "https://a0.muscache.com/im/users/38806076/profile_pic/1437343806/original.jpg?im_w=240",
        },
        {
          id: 2,
          name: "Amy",
          date: "August 2022",
          comment:
            " Nikos was such a great host! We reserved for a team work event and it worked out so well. He kept the game moving and I loved how he started to engage the team. Would definitely recommend!",
          URL: "https://a0.muscache.com/im/pictures/user/68105aa3-e1d0-45c2-a61b-3c5caea08616.jpg?im_w=240",
        },
        {
          id: 3,
          name: "Lorna",
          date: " August 2022",
          comment:
            "Nikos did a magnificent job delivering this game experience! I booked this for my father-in-law's birthday activity so we could share an experience with him on his birthday given that he lives in California while my husband and I live in Florida. I got in touch with Nikos to see if there was any way he could make it family-friendly and he delivered.",
          URL: "https://a0.muscache.com/im/pictures/user/174484d1-7610-48ca-8811-209453ee2f02.jpg?im_w=240",
        },
        {
          id: 4,
          name: "Jason",
          date: "  June 2022",
          comment:
            "Nikos (Socrates) was an amazing host. I learned quite a bit of information and definitely had my share of belly laughs. We did the ‘regular’ version which was tailored more towards adults… pretty dang funny!!!",
          URL: "https://a0.muscache.com/im/pictures/user/6c0860bd-0d15-477b-8990-806de086150a.jpg?im_w=240",
        },
        {
          id: 5,
          name: "Kathleen",
          date: "June 2022",
          comment:
            " My husband and I were both history majors in college and still like reading historical fiction and factual books. Since we have visited Greece twice, our son and his thoughtful wife found the Socrates experience and gave it as a gift for my husband’s birthday. The format was informative, fun to do together, and we learned many interesting facts about ancient Greek culture",
          URL: " https://a0.muscache.com/im/pictures/user/8a4b3479-f40f-43f8-908a-18126e5e8c04.jpg?im_w=240",
        },
        {
          id: 6,
          name: "vera",
          date: "23 aug",
          comment:
            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Porro error iste provident facere exercitationem natus",
          URL: "https://images.pexels.com/photos/12617812/pexels-photo-12617812.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
        },
      ],
    },
  
    {
      id1: 2,
      title: "Make Mexican Street Tacos with a Pro Chef",
      type: "international",
      groupprice: "369",
      priceadult: "37",
      pricechildren: "29",
      priceinfant: "0",
      ratings: "4.98",
      rating: "(4357)",
      place: " Mexico City, Mexico",
      place2: " Mexico City",

      host: " Graciela",
      hostimg:
        "https://a0.muscache.com/im/pictures/user/e62be9c0-98a4-4f48-93a2-6f58782d7f0d.jpg?im_w=240",
      images: [
        {
          id: 1,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1661135-active_media/original/834b9753-83fc-462d-b6d6-ebd892b0ab6e.jpg?im_w=1440",
        },
        {
          id: 2,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1661135-media_library/original/b60dac1a-470b-47e1-bc44-723422c245be.jpeg?im_w=1440",
        },
        {
          id: 3,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1661135-media_library/original/5e20121c-b211-4944-b562-6e935909163f.jpeg?im_w=1440",
        },
        {
          id: 4,
          URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1661135-media_library/original/77bb5b19-a8c2-42a2-86d5-6b400c48b274.jpeg?im_w=1440",
        },
        {
          id: 5,
          URL: "https://a0.muscache.com/im/pictures/2a61d4b0-9202-4c62-b7cd-0d6497c7d44d.jpg?im_w=1440",
        },
      ],
      title2: " Online experience hosted by Graciela",
      time: "90",
      language: "English",
  
      what1:
        "TOP Airbnb Online Experience TOP Airbnb Online Cooking Experience TOP Airbnb Online Mexican Cooking Experience.This online experience offers a unique opportunity to submerge yourself in the authentic Mexican street food culture with a step-by-step taco cooking class! ",
      what2:
        "Learn to cook a true Mexican street taco from scratch and all its parts. In the first half-hour, we will have a small meet and greet and our Mexican taco recipe overview. In the next hour, we will guide you in preparing a traditional red salsa, taco filling, and flour tortillas. Our experience includes practical recipes that you can easily follow at home and cook for your beloved ones. Vegan options are available.",
  
      what3:
        "Planning a unique and different corporate TEAMBUILDING off-site? Is your group larger than the listed max group size for private groups or do you need a specific date, hour, length, or menu? Please send us a message to happily accommodate your request.",
  
      bring1:
        "  Computer, tablet or smartphone with a stable internet connection. Video and sound on. Enough battery to complete the class, external speaker desirable.  ",
      bring2:
        " If you’re not cooking this time, bring your favorite drink and snack to enjoy while you join the class. ",
  
      hostsince: "2016",
      host2:
        "Hola, I am Graciela! I was born and raised in Mexico City. In addition to hosting a TV cooking show, I am a Mexican Chef Ambassador for different worldwide projects. Together with Lorena, Krystel, Gaby and, Pame; we are Aura Cocina Mexicana, a family-inspired cooking studio that creates traditional Mexican cooking experiences. ",
  
      date: [
        { date: "24 Aug", time: "3:30" },
        { date: "24 Aug", time: "3:30" },
        { date: "24 Aug", time: "4:30" },
        { date: "24 Aug", time: "5:30" },
        { date: "25 Aug", time: "6:30" },
        { date: "25 Aug", time: "7:30" },
        { date: "25 Aug", time: "8:30" },
        { date: "26 Aug", time: "5:30" },
        { date: "26 Aug", time: "10:30" },
        { date: "26 Aug", time: "3:30" },
        { date: "27 Aug", time: "9:30" },
        { date: "27 Aug", time: "6:30" },
        { date: "27 Aug", time: "1:30" },
        { date: "28 Aug", time: "3:30" },
        { date: "28 Aug", time: "11:30" },
        { date: "29 Aug", time: "12:30" },
        { date: "29 Aug", time: "9:30" },
      ],
  
      comments: [
        {
          id: 1,
          name: "Larisa",
          date: "August 2022",
          comment:
            "  Lorena was awesome! She was very personable and made each step of the class easy and fun. My tacos were delicious, and I'm definitely going to use my new taco making skills to make more in the future!",
          URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
        },
        {
          id: 2,
          name: "Michael",
          date: "August 2022",
          comment:
            "While I am under no impression I am now a Street Taco expert I now can make them for friends and family while having fun. A great Airbnb Experience that could easily lead to having family and friends over for Street Taco Night! The class was fun, informative, but most of all Lorena was a wonderful Host keeping everyone engaged and making the experience very intimate over Zoom.",
          URL: " https://a0.muscache.com/im/pictures/user/1fd0139c-389e-4498-baa6-9ea241cbdd11.jpg?im_w=240",
        },
        {
          id: 3,
          name: "James",
          date: " August 2022",
          comment:
            "The Taco making experience was great! Super fun, and Graciela did a great job getting conversation going and creating an engaging experience. My team had an amazing time, with delicious results",
          URL: "https://a0.muscache.com/im/pictures/user/174484d1-7610-48ca-8811-209453ee2f02.jpg?im_w=240",
        },
        {
          id: 4,
          name: "Marcos Renato",
          date: "  June 2022",
          comment:
            " Lorena's instruction for making tortillas was awesome. I've made tortillas once or twice before and they were never anywhere close to this good, so the guidance here was a game changer. The class was engaging and fun as well so its a very enjoyable class! Muchisimas gracias Lorena!",
          URL: "https://a0.muscache.com/im/pictures/user/ba23c384-d583-4a86-b177-fbc9e4ef99ac.jpg?im_w=240",
        },
        {
          id: 5,
          name: "John",
          date: "June 2022",
          comment:
            "What a great overview into some of the magic that goes behind making a really good taco. You made it easy for us to follow along and provided helpful tips along the way that we can use in other cooking.",
          URL: " https://a0.muscache.com/im/pictures/user/5cd9d813-6fba-4ecf-a805-f497fa4620ee.jpg?im_w=240",
        },
        {
          id: 6,
          name: "Fanny",
          date: "23 aug",
          comment:
            " Great experience and super fun. I have made tortillas in the past but they weren't very good. She clearly showed the techniques and these tortillas came out so much better than the ones I made. The salsa was so great! Better than anything you could buy and so easy to make. Loved it and will for sure go to a class when we visit Mexico City",
          URL: " https://a0.muscache.com/im/users/680186/profile_pic/1307588257/original.jpg?im_w=240",
        },
      ],
    },
    {
      id1: 3,
      title: " From Paris with Laughs' The Scavenger Hunt",
      type: "international",
      groupprice: "130",
      priceadult: "21",
      pricechildren: "0",
      priceinfant: "0",
      ratings: "4.82",
      rating: "(120)",
      place: " Paris, France",
      place2: " Paris",

      host: " Juli And Léa",
      hostimg:
        "https://a0.muscache.com/im/pictures/user/e6061ba2-2017-429c-8b62-f9b6fb09b288.jpg?im_w=240",
      images: [
        {
          id: 1,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2422459-media_library/original/8262d6c7-f0dc-45f0-9610-53f6577cc380.jpeg?im_w=1200",
        },
        {
          id: 2,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2422459-media_library/original/ac657ee9-5b7e-414c-9218-3e8a2602abbb.jpeg?im_w=1440",
        },
        {
          id: 3,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2422459-media_library/original/e57d6f36-7a1d-47a6-afbc-1cce1811f81a.jpeg?im_w=1440",
        },
        {
          id: 4,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2422459-media_library/original/c6fb36a1-a065-4a90-b99a-8d5f4ef51e56.jpeg?im_w=1440",
        },
        {
          id: 5,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2422459-media_library/original/48938670-d39d-4d84-b56a-6573dfd1893c.jpeg?im_w=1440",
        },
      ],
      title2: "Online experience hosted by Juli And Léa",
      time: "90",
      language: "English",
  
      what1:
        "OH LALA ! Welcome to a unique VIRTUAL game about Paris and France ! Great for Online Corporate events, Team-buildings, birthdays, celebrations, date nights, families. ",
      what2:
        " 5 stars rated by companies such as Microsoft, Amazon, Google, Netflix, LinkedIn, Facebook, EY and many more ! This is an interactive experience: our aim is to make you feel immersed in Paris & France in the most fun way. Our very special scavenger hunts, challenges & riddles will bring you lots of laughs and you will connect to each other !",
  
      what3:
        "  We will talk about food, art, culture and put some french clichés in the spotlight.Come to France... with no need to move from your couch !Explore and learn funny facts about our different regions Play and laugh with us !",
  
      bring1:
        "  Computer, tablet or smartphone with a stable internet connection. Video and sound on. Enough battery to complete the class, external speaker desirable.  ",
      bring2: " a big sense of humor ",
  
      hostsince: "2013",
      host2:
        "Bonjour ! We are Juli, Luli & Léa, we know all the secrets of Paris and France, and love to connect with friends from everywhere ! Let's meet up virtually no matter where you are !",
  
        date: [
          { date: "25 Aug", time: "3:30" , id:1 },
          { date: "24 Aug", time: "3:30" , id:2  },
          { date: "24 Aug", time: "4:30" , id:3  },
          { date: "24 Aug", time: "5:30" , id:4  },
          { date: "25 Aug", time: "6:30" , id:5  },
          { date: "25 Aug", time: "7:30"  , id:6 },
          { date: "25 Aug", time: "8:30" , id:7 },
          { date: "26 Aug", time: "5:30"  , id:8 },
          { date: "26 Aug", time: "10:30" , id:9  },
          { date: "26 Aug", time: "3:30" , id:10 },
          { date: "27 Aug", time: "9:30" , id:11 },
          { date: "27 Aug", time: "6:30" , id:12 },
          { date: "27 Aug", time: "1:30" , id:13  },
          { date: "28 Aug", time: "3:30" , id:14  },
          { date: "28 Aug", time: "11:30" , id:15  },
          { date: "29 Aug", time: "12:30"  , id:16 },
          { date: "29 Aug", time: "9:30" , id:17  },
        ],
  
      comments: [
        {
          id: 1,
          name: "Kelsai",
          date: "August 2022",
          comment:
            "  This was an ok experience. The scavenger hunt was around your own house and not around Paris like the description makes you think. There was very little information provided about Paris or France, which could be related to the size of our team and the time it took us to show our home items from the scavenger hunt portions.!",
          URL: "https://a0.muscache.com/im/pictures/user/a83302f8-d27e-45ec-970c-d4a7ffd62024.jpg?im_w=240",
        },
        {
          id: 2,
          name: "Parker",
          date: "August 2022",
          comment:
            " Fun experience for a virtual grt together for corporate event. Learned a little bit, moved around the house, some laughs with team and friendly competition with a great host in Juli!",
          URL: "  https://a0.muscache.com/im/pictures/user/5cd9d813-6fba-4ecf-a805-f497fa4620ee.jpg?im_w=240",
        },
        {
          id: 3,
          name: "James",
          date: " August 2022",
          comment:
            " This was a great experience for my team! We all had so much Fun! And we were able to relax and laugh together! Learned interesting things about France as well.",
          URL: "https://a0.muscache.com/im/pictures/user/68dc77f3-1507-4f31-882c-186e047fe05f.jpg?im_w=240",
        },
        {
          id: 4,
          name: " Talia",
          date: "  June 2022",
          comment:
            "I enjoyed my From Paris with Laughs experience with my coworkers, hosted by Juli. She had a fun loving , witty personality that made the experience even more enjoyable. I would definitely recommend to a friend.",
          URL: "https://a0.muscache.com/im/pictures/user/ba23c384-d583-4a86-b177-fbc9e4ef99ac.jpg?im_w=240",
        },
        {
          id: 5,
          name: "John",
          date: "June 2022",
          comment:
            " I booked this event for a team bonding experience and our team had a lot of fun, while learning cool facts about France! We had lots of laughs :)",
          URL: " https://a0.muscache.com/im/pictures/user/f1d34076-54f6-421f-b6a5-dce5c4324957.jpg?im_w=240",
        },
        {
          id: 6,
          name: "Donald",
          date: "23 aug",
          comment:
            "Our scavenger hunt was for a birthday celebration and everyone enjoyed it a lot. The trivia questions were good, the “scavenger hunt” aspects were both fun and funny, and Juli did a great job keeping it fun and light. We had three generations represented and it worked well across the board.",
          URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
        },
      ],
    },

    {
      id1: 4,
      title: "Murder Mystery Escape Room Game",
      type: "international",
      groupprice: "152",
      priceadult: "23",
      pricechildren: "20",
      priceinfant: "0",
      ratings: "4.88",
      rating: "(468)",
      place: " Kraków, Poland",
      place2: " Kraków",

      host: " Klaudia",
      hostimg:
        "https://a0.muscache.com/im/pictures/user/e6061ba2-2017-429c-8b62-f9b6fb09b288.jpg?im_w=240",
      images: [
        {
          id: 1,
          URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2340325-media_library/original/599c584e-f401-4f67-958a-18277ee7dd10.png?im_w=1200",
        },
        {
          id: 2,
          URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2340325-media_library/original/491a25d1-1165-4972-871b-0f7ecdbba254.png?im_w=1440",
        },
        {
          id: 3,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2340325-media_library/original/bbf773c6-0126-49a7-bd65-4b12e048cfce.png?im_w=1440",
        },
        {
          id: 4,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2340325-media_library/original/5abd3b83-953c-4a1f-8d53-4c660a57d044.jpeg?im_w=1440",
        },
        {
          id: 5,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2340325-media_library/original/c6c02907-8c18-4dc5-8122-431a377cf8fd.png?im_w=1440",
        },
      ],
      title2: "Online experience hosted by Klaudia",
      time: "60",
      language: "English",
  
      what1:
        "Perfect for Teams! Available for groups up to 200 participants!There was a murder! Oh no! And only You as a group of detectives are able to solve it... Will you make it? ",
      what2:
        "In this murder mystery escape room game, you will become a group of detectives trying to solve a case that we have prepared. We will connect through zoom in a form of a video conference. Then your game master will present you the story of The Psychiatrist - a really mysterious murder case! You will need to collect evidence (sometimes in a form of recordings, pictures, websites), and also solve riddles left at the crime scene! Each riddle will give you a piece of evidence. Because of the level of difficulty (yes, riddles are quite challenging), you will need to cooperate and communicate together! And in the end, you will need to vote: who did it? Who is the killer? ",
  
      what3:
        "  This is a perfect team-building activity! (We designed it thinking about team bondings ;) But also, this is a great experience to have fun with your friends, family, or teammates!The recipe for great detectives? : communication, cooperation, and FUN!You will not only get a challenge from our riddles but also... a funny story, based in Poland! ",
  
      bring1:
        "  Computer, tablet or smartphone with a stable internet connection. Video and sound on. Enough battery to complete the class, external speaker desirable.  ",
      bring2: " your inner SHERLOCK HOLMES ",
  
      hostsince: "2019",
      host2:
        " Hi, we are Klaudia, Jo, Mateusz and Kasia :) For a couple of years now, we are creating, designing, and making scavenger hunts, city games, and escape rooms in Poland :) We are also hosts here on Airbnb (Solve The Mystery, Online Escape Room Game - which is one of the bestsellers!!!).We love riddles! And that's why we have created this experience :) For you to have a small brain workout ( ;) ) and during this to have fun and maybe to get to know something new ;)",
  
        date: [
          { date: "25 Aug", time: "3:30" , id:1 },
          { date: "24 Aug", time: "3:30" , id:2  },
          { date: "24 Aug", time: "4:30" , id:3  },
          { date: "24 Aug", time: "5:30" , id:4  },
          { date: "25 Aug", time: "6:30" , id:5  },
          { date: "25 Aug", time: "7:30"  , id:6 },
          { date: "25 Aug", time: "8:30" , id:7 },
          { date: "26 Aug", time: "5:30"  , id:8 },
          { date: "26 Aug", time: "10:30" , id:9  },
          { date: "26 Aug", time: "3:30" , id:10 },
          { date: "27 Aug", time: "9:30" , id:11 },
          { date: "27 Aug", time: "6:30" , id:12 },
          { date: "27 Aug", time: "1:30" , id:13  },
          { date: "28 Aug", time: "3:30" , id:14  },
          { date: "28 Aug", time: "11:30" , id:15  },
          { date: "29 Aug", time: "12:30"  , id:16 },
          { date: "29 Aug", time: "9:30" , id:17  },
        ],
  
      comments: [
        {
          id: 1,
          name: "Kelsai",
          date: "August 2022",
          comment:
            " If you are looking for a virtual event on escape the room, look no further. This was awesome. Engaging, tricky but with thought we figured it out. I loved the 1:1 support, visuals, links and more that we received. 100% would recommend for team bonding, friends and family!",
          URL: "https://a0.muscache.com/im/pictures/user/a83302f8-d27e-45ec-970c-d4a7ffd62024.jpg?im_w=240",
        },
        {
          id: 2,
          name: "Nataliia",
          date: "August 2022",
          comment:
            "  This was the first time that my team has done a virtual AirBnB experience together and we all had so much fun in our Murder Mystery Escape Room! We had a great time working on the puzzles together and figuring out the mystery. Our host was also very friendly and encouraging, and we would definitely recommend this to other teams!.",
          URL: " https://a0.muscache.com/im/pictures/user/1a593e34-1e02-47e9-967d-e1d7a391248a.jpg?im_w=240",
        },
        {
          id: 3,
          name: "Brenda",
          date: " August 2022",
          comment:
            " The Murder Mystery Escape Room Game was a lot of fun! The case was interesting to solve, and the experience was well adapted from an in-person experience to an online experience. It made for a great team building event with my colleagues, and our host Matthew did a great job at moderating the event. Would highly recommend!",
          URL: "https://a0.muscache.com/im/pictures/user/31a559db-2851-4c9f-8594-1eda805d7359.jpg?im_w=240",
        },
        {
          id: 4,
          name: " Talia",
          date: "  June 2022",
          comment:
            " It was a really fun and great team bonding experience. The puzzles were well thought out, not too easy and not too difficult. I would definitely recommend anyone to try this out.",
          URL: "https://a0.muscache.com/im/pictures/user/ba23c384-d583-4a86-b177-fbc9e4ef99ac.jpg?im_w=240",
        },
        {
          id: 5,
          name: "Elizabeth",
          date: "June 2022",
          comment:
            " This was the first time that my team has done a virtual AirBnB experience together and we all had so much fun in our Murder Mystery Escape Room! We had a great time working on the puzzles together and figuring out the mystery. Our host was also very friendly and encouraging, and we would definitely recommend this to other teams!)",
          URL: "https://a0.muscache.com/im/pictures/user/3faa0b44-5874-4c33-ba94-c3ede237d152.jpg?im_w=240",
        },
        {
          id: 6,
          name: "Jennifer",
          date: "July 2022",
          comment:
            " This was a GREAT team building experience for my team. We had 7 people which worked well and gave everyone the space to share their thoughts and join in on the puzzles. The instructions were great, and Klaudia’s enthusiasm made the mystery very exciting. The tasks were challenging but in a fun way, and Klaudia was very encouraging the whole way through. Would absolutely recommend this for a work group, or for friends! She even took a pic of the team at the end and sent it to us, which was a really nice extra touch.",
          URL: "https://a0.muscache.com/im/pictures/user/e0d72c60-0879-4fb6-96fe-d743605a3742.jpg?im_w=240",
        },
      ],
    },
    {
      id1: 5,
      title: "Pasta with the Grandmas",
      type: "international",
      groupprice: "360",
      priceadult: "48",
      pricechildren: "29",
      priceinfant: "0",
      ratings: "4.98",
      rating: "(3178)",
      place: "Palombara Sabina, Italy",
      place2: "Palombara",

      host: " Chiara & Nonna",
      hostimg:
        "https://a0.muscache.com/im/pictures/user/cf5c2f15-e99e-451b-994f-a29bad0c03fb.jpg?im_w=240",
      images: [
        {
          id: 1,
          URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1610894-poster/original/437c46e2-33d8-4b5c-a6a4-84d6642b2fcc.jpg?im_w=480",
        },
        {
          id: 2,
          URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1610894-media_library/original/83b203b9-f0b4-4070-ae38-c10628bef92f.jpeg?im_w=480",
        },
        {
          id: 3,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1610894-active_media/original/e1c01595-f826-43ff-8370-03846f6c99ea.jpg?im_w=240",
        },
        {
          id: 4,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1610894-active_media/original/cb74ccf9-4e4c-4d64-9fec-e5e64403863c.jpg?im_w=240",
        },
        {
          id: 5,
          URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1610894-active_media/original/1a9f2a4a-e613-4dfe-b871-1a2ec4841f04.jpg?im_w=480",
        },
      ],
      title2: "Online experience hosted by Chiara & Nonna",
      time: "90",
      language: "English and Japnanese",
  
      what1:
        "Need to travel to Italy? Nonna will bring it to your table! Cook Pasta from scratch with grandma, let her share with you her culinary secrets and the traditional authentic pasta technique. Listen to her stories and be ready to be involved in our community. ",
      what2:
        " Nonna Nerina and the other grandmas of our village can’t wait to meet all of you!  Menu  Starting from August 1st: summer taste… handmade Lombrichelli with Pistacchio Pesto!!! Private Exp Everyday: choose your menu (ravioli, fettuccine, gnocchi, lasagne.. we have so many recipes to share with you!) ",
  
      what3:
        " This Experience is great for team-building!  GLUTEN FREE recipes under request  , 4 professional sets with four cameras each for a high quality experience  , How does it work? Just check our calendar, choose your date, and book it! , See you in Nonna's home ;)",
  
      bring1:
        "  Computer, tablet or smartphone with a stable internet connection. Video and sound on. Enough battery to complete the class, external speaker desirable.  ",
      bring2: " your  cooking experiance ",
  
      hostsince: "2014",
      host2:
        " I learned how to make pasta since I was really young by my grandma, Nonna Nerina... she is the true host and the true protagonist of this story. She lived her childhood during the second world war, her mum taught her how to feed children with just 2 ingredients: eggs and flour.  Whenever I sat in her kitchen growing up, she’d make pasta while sharing memories of that time. I soon realized my generation was missing something important: not just the handmade pasta technique but an entire tradition passed down through the ages. I decided to share this gem with the rest of the world. ",
  
        date: [
          { date: "25 Aug", time: "3:30" , id:1 },
          { date: "24 Aug", time: "3:30" , id:2  },
          { date: "24 Aug", time: "4:30" , id:3  },
          { date: "24 Aug", time: "5:30" , id:4  },
          { date: "25 Aug", time: "6:30" , id:5  },
          { date: "25 Aug", time: "7:30"  , id:6 },
          { date: "25 Aug", time: "8:30" , id:7 },
          { date: "26 Aug", time: "5:30"  , id:8 },
          { date: "26 Aug", time: "10:30" , id:9  },
          { date: "26 Aug", time: "3:30" , id:10 },
          { date: "27 Aug", time: "9:30" , id:11 },
          { date: "27 Aug", time: "6:30" , id:12 },
          { date: "27 Aug", time: "1:30" , id:13  },
          { date: "28 Aug", time: "3:30" , id:14  },
          { date: "28 Aug", time: "11:30" , id:15  },
          { date: "29 Aug", time: "12:30"  , id:16 },
          { date: "29 Aug", time: "9:30" , id:17  },
        ],
  
      comments: [
        {
          id: 1,
          name: "Kelsai",
          date: "August 2022",
          comment:
            "We booked this experience to celebrate my Dad's birthday. My brother lives in San Francisco and we are in New England so it was the perfect opportunity to bring everyone together. Angela and Nonna were fantastic!! They interacted with our family and made everything super simple. Needless to say, the food was fantastic. I can't recommend this experience enough!!",
          URL: " https://a0.muscache.com/im/users/44379213/profile_pic/1442445967/original.jpg?im_w=240",
        },
        {
          id: 2,
          name: "Nataliia",
          date: "August 2022",
          comment:
            "My team and I had a great time cooking pasta with Chiara and Nonna! They were wonderful hosts and they set a great atmosphere for the activity. All of us had a great time cooking, even though many of us were not very experienced. Chiara and Nonna really made sure everyone was following along and helped us throughout the process. The end result was delicious, and it was a fun and unique team building activity!",
          URL: " https://a0.muscache.com/im/pictures/user/6cb7f231-1b1b-4f8c-9e0a-41fc3fc58a36.jpg?im_w=240",
        },
        {
          id: 3,
          name: "Craig H",
          date: " August 2022",
          comment:
            "We had most of our office login for a pasta making event, I was one of the few that just wanted to watch and didn't want to cook at the same time (but was only one of 4 who chose not to cook). I found the entire even thoroughly enjoyable, the interactions and the straight-forward instructions. It appeared to be much easier to make, but what made it so enjoyable was the family bond while watching (Nonna and her grandson). ",
          URL: "https://a0.muscache.com/im/pictures/user/d78e7eb9-e358-4743-bc3b-97ba70ab867e.jpg?im_w=240",
        },
        {
          id: 4,
          name: " Jenni",
          date: "  June 2022",
          comment:
            "I booked this experience as part of a corporate event for my team. Nonna and Chiara were absolutely wonderful and personable - we all felt like we were in Italy right next to them, kneading our pasta together. We all learned a lot and had a great bonding time. Hope to have this experience again!.",
          URL: "https://a0.muscache.com/im/pictures/user/5dc75adb-e472-4664-a60d-7716bc80b50e.jpg?im_w=240",
        },
        {
          id: 5,
          name: "Sarah",
          date: "June 2022",
          comment:
            "  I booked this experience as a team bounding activity and it was a success! Everyone had a great time and we all loved the delicious pasta we cooked.  Nonna was super friendly and took time to give everyone advices based on their progress and ingredients they had available",
          URL: "https://a0.muscache.com/im/pictures/user/f4016e4d-8af1-44fc-a867-74bdd345ee54.jpg?im_w=240",
        },
        {
          id: 6,
          name: "Camille",
          date: "July 2022",
          comment:
            " This was an amazing experience! So much encouragement from the beginning to the end, and they make you feel like you are part of the family.This was a wonderful experience with my company, my gnocchi didn’t turn out great but it was so much fun learning something new!",
          URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
        },
      ],
    }, 
 
   {
    id1: 7,
    title: "Follow a Plague Doctor Through Prague",
    type: "international",
    groupprice: "234",
    priceadult: "24",
    pricechildren: "21",
    priceinfant: "0",
    ratings: "4.92",
    rating: "(3295)",
    place: "Prague, Czech Republic",
    place2: "Prague,  ",

    host: "Lucie & David",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/355ffd30-e680-406c-8e34-1ba21ac06b8f.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1658926-poster/original/57e5f8dc-f0fa-4028-89d9-ed9d0e7a92b7.jpeg?im_w=480",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1658926-active_media/original/2fe5ac18-4bf5-455d-8342-fde4200bc3a0.jpeg?im_w=480",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1658926-active_media/original/f0fc78db-7623-4653-a4ae-e856a349c739.jpeg?im_w=240",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1658926-active_media/original/f0fc78db-7623-4653-a4ae-e856a349c739.jpeg?im_w=240",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1658926-active_media/original/b2f640a1-2133-4dfa-a036-b91ce9e20245.jpeg?im_w=480",
      },
    ],
    title2: "Online experience hosted by Lucie & David",
    time: "60",
    language: "English",
  
    what1:
      "As seen by New York Times, Forbes, Wall Street Journal and Vogue we are delighted to welcome you virtually to our experience in Prague during the times of the Black Death. Through video, we'll follow the footsteps of Dr. A. Schamsky, an unknown Czech hero who fought the plague from 1713-1715. From the “PPE” of the time to the deserted landmarks of the city, you’ll immerse yourself in the forgotten history of the pneumonic and bubonic plagues. Our recorded video has no audio as we comment everything live we see. ",
    what2:
      " The movie was shot with a professional movie camera during times of curfew in March 2020 and shows the abandoned old town.We will visit the Charles Bridge, the Old Town Square, and go into the Jewish Quarter to discover hidden gems in the dark streets. We´ll stop by the old St. Francis hospital and conclude the tour at the convent of St. Agnes. So, not only will you traverse time,",
  
    what3:
      "  but you’ll also get the sense of travel—all from the comfort of your home/work place. Interested in our doctor´s edition? We explore the history of medicine and give insights of the plague from the year 1347 to 2022",
  
    bring1:
      "  Computer, tablet or smartphone with a stable internet connection. Video and sound on. Enough battery to complete the class, external speaker desirable.  ",
    bring2: " a big sense of humor ",
  
    hostsince: "2016",
    host2:
      "Hello from Prague! We are group of multinational tour guides who share the passion for the history of Prague. We’ve created a virtual version of our successful tour (https://www.airbnb.com/experiences/1290936) in order to provide a similar experience in your living room during the current travel restriction. We were inspired by the book of the plague doctor Alexander Schamsky, a forgotten hero of Prague. We’re looking forward to sharing the famous spots and hidden jewels of Old Town Prague with you! We will confirm prior the event who of us will do the tour+++This experience can be also booked as a private event and team building up to 500 people+++We have also created vouchers to give this tour as a gift+++ Customized trailers for all private tours",
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "Rachel",
        date: "August 2022",
        comment:
          " Our team really enjoyed the event with David! The host was so kind and welcomed each of us into the experience. This hour was an informative overview of how the plague impacted Prague, and ultimately a great escape from our daily work. I'll be back this Halloween for sure!",
        URL: "https://a0.muscache.com/im/users/13416970/profile_pic/1395612834/original.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Kinkaid",
        date: "August 2022",
        comment:
          "David did a fantastic job setting the scene and giving us the virtual tour. I wasn’t sure what to expect but what we got was a fantastic journey through Prague and a great amount of knowledge. David is an amazing guide - hopefully I can go in person soon!",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
      {
        id: 3,
        name: "Mia",
        date: " August 2022",
        comment:
          "  Our company’s remote team loved this experience! We all learned so much, and we talked about the event long after it was over. Great mix of drama, education, storytelling, etc. Only complaint: We all have travel fever now! ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
      {
        id: 4,
        name: " Carolyn",
        date: "  June 2022",
        comment:
          "This was an incredible experience! I booked the Prague tour for a work bonding session, and every single person absolutely loved it. Great information, great host, great fun! Would definitely recommend.",
        URL: "https://a0.muscache.com/im/users/16658275/profile_pic/1402951439/original.jpg?im_w=240",
      },
      {
        id: 5,
        name: "Ashwini",
        date: "June 2022",
        comment:
          " Wonderful session with David. We are doctors so enjoyed the session. It was exactly what we had expected. David could answer all our questions well. Also we got to see bits of Prague. Would recommend this to others surely.",
        URL: "https://a0.muscache.com/im/pictures/user/9c45c1b8-456a-4d1c-b954-b4accc1008fc.jpg?im_w=240",
      },
      {
        id: 6,
        name: "Vaishali",
        date: "July 2022",
        comment:
          " I booked this experience for a team event and highly recommend it. David is a fantastic storyteller, and he expertly wove in the morbid history of plague into it. Surprisingly the mood of the experience is still upbeat! Thank you Lucie and David!",
        URL: "https://a0.muscache.com/im/pictures/user/04230f50-bcec-4a1e-b3cd-cec4a73a6fdd.jpg?im_w=240",
      },
     ],
   },

   {
    id1: 8,
    title: " Live Virtual Wildlife Safari in South Africa",
    type: "international",
    groupprice: "322",
    priceadult: "33",
    pricechildren: "33",
    priceinfant: "0",
    ratings: "4.91",
    rating: "(594)",
    place: "Stellenbosch Farms, South Africa",
    place2: "Stellenbosch  ",

    host: "Deirdre",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/c4261df7-63f0-4085-90a9-f562a29b35af.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1762373-media_library/original/66ac3d7e-4de9-494a-8719-5dc3b560298f.jpeg?im_w=480",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1762373-media_library/original/6b78e8d7-659e-4c57-8df3-e68e8d8ced33.jpeg?im_w=480",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1762373-media_library/original/eb6a769f-0936-4f9d-875f-b3bcf8ca8a65.jpeg?im_w=240",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1762373-media_library/original/a07e4bae-3fbd-4441-a009-94fefac1466f.jpeg?im_w=240",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1762373-media_library/original/cee26245-7b4a-41f6-9615-57558f1887cd.jpeg?im_w=480",
      },
    ],
    title2: "Online experience hosted by Deirdre",
    time: "60",
    language: "English",
  
    what1:
      "This is an online experience - LIVE (not pre-recorded) - where you will join me from the comfort of your own home or office. We are great for groups, great for teambuilding, and family friendly.",
    what2:
      "We start at the entrance to the 240ha wildlife reserve where we will go in search of a variety of South African wildlife that inhabit the reserve, such as giraffe, zebra, eland, wildebeest, springbuck, waterbuck, bontebok & a variety of birds.",
  
    what3:
      "I will share the history of the farm, teach you about the various types of animals we will encounter and tell you stories about those living in the reserve that I've grown to know. We get close enough to observe free-roaming wildlife in their habitat but we maintain respect for their space at all times and keep a distance they are comfortable with. ",
  
    bring1:
      " Price is per person, not per screen. Minimum group price includes up to 10 people, then billed per person above 10.",
    bring2:
      "If you'd like to enjoy some South African wine from the vineyard responsible for the wildlife sanctuary while on virtual safari with me, Villiera Wines have distributors internationally",
  
    hostsince: "2019",
    host2:
      "Hi, I'm Deirdre. For the last 8 years I have been taking guests on rides through a 240ha wildlife sanctuary that is home to giraffe, zebra, wildebeest, and a variety of South African antelope and birds. I have led first time riders as well as experienced riders, children, couples, families, corporate teams and hosted birthdays, engagements and other celebrations. I am passionate about horses, wildlife and conservation, and love sharing these magical moments with our guests",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "Kirk",
        date: "August 2022",
        comment:
          "Deirdre did a great job taking our team on a virtual safari, providing us with many facts about the animals in the preserve. I would highly recommend the experience!",
        URL: "https://a0.muscache.com/im/pictures/user/d233d633-1721-4a4e-bcaa-b45ec2a1b4e1.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Danny",
        date: "August 2022",
        comment:
          "So much fun seeing the animals, the reserve is beautiful and the animals are cute! Very informative, highly recommend to do with friends!",
        URL: " https://a0.muscache.com/im/pictures/user/0007e96d-0c7e-4118-97c7-3cde6d7949c0.jpg?im_w=240",
      },
      {
        id: 3,
        name: "Chelsea",
        date: " August 2022",
        comment:
          "We loved our online experience with Deirdre. She was so knowledgeable (I don't think there was a question she didn't know the answer to) and passionate about the animals in the reserve. We also loved the stories she shared about the animals. Highly recommend this to other work groups or families looking to connect online. ",
        URL: " https://a0.muscache.com/im/users/19023738/profile_pic/1406545226/original.jpg?im_w=240",
      },
      {
        id: 4,
        name: " Rachel",
        date: "  June 2022",
        comment:
          "What a wonderful experience! A beautiful setting and Deirdre was so knowledgable about the region and the animals! Wonderful to see so many species so close up! Thank you so much!",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
      {
        id: 5,
        name: "Rebecca",
        date: "June 2022",
        comment:
          "Wonderful experience to sit in Texas and ride along to see the animals and hear the great commentary by Deirdre. The giraffes were a favorite of our group!",
        URL: "https://a0.muscache.com/im/pictures/user/775f23a1-cebb-4e5c-a21a-022748b595b7.jpg?im_w=240",
      },
      {
        id: 6,
        name: "Josephine",
        date: "July 2022",
        comment:
          " It was a great experience to be on a virtual Safari tour. It was like I was there too. :) Loved seeing those animals and how they move around the safari. My son would definitely love this ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
    ],
  },

  {
    id1: 9,
    title: " Origami and the Essence of Japan",
    type: "international",
    groupprice: "274",
    priceadult: "39",
    pricechildren: "32",
    priceinfant: "0",
    ratings: "4.97",
    rating: "(435)",
    place: "Koto City, Japan",
    place2: "Koto City",

    host: "Manami", 
    hostimg: " https://a0.muscache.com/im/pictures/user/b57a1604-b570-4c47-b663-db33462ed665.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1675585-media_library/original/bc79f5c1-3613-477e-b82f-a91527837263.jpeg?im_w=480",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1675585-media_library/original/a046c08b-e319-4aba-8322-44fde17490f4.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1675585-media_library/original/22f1be67-28f7-4944-9662-f46d0000014d.jpeg?im_w=240 ",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1675585-media_library/original/552ee3ca-b579-4e84-a915-29a8f4d21e03.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1675585-active_media/original/ff71c629-7e60-4b73-a2cc-38d8d775e6da.jpg?im_w=480",
      },
    ],
    title2: " Online experience hosted by Manami",
    time: " 60 ",
    language: "English",
  
    what1:
      " You can request a date and time if you don't see convenient ones on my calendar.A rare opportunity to learn Origami with cultural backstories from a Tokyo localA creative and fun experience perfect for corporate team building as well as family or friends get together! ",
    what2:
      "Origami is a traditional art of paper crafting from Japan. Precision and dexterousness that are required to fold a piece of paper is CONCENTRATING as well as THERAPEUTIC.This provides you a time to relax and share a common creative experience with people who you care. And you will create cool or lovely shapes by yourself.  ",
  
    what3:
      " You can't get the same experience on YouTube tutorials because Manami shares not only how to make Origami, but also its history as well as Japanese culture and values behind the shapes. ",
  
    bring1:
      "A pair of scissors ",
    bring2:
      " 15cm (6inches)×15cm SQUARE paper 4 sheets. Soft paper such as wrapping paper is preferred, or else origami paper can be easily purchased online",
  
    hostsince: "2019",
    host2:
      "Manami is professional origami instructor from Tokyo, Japan. She started learning origami from her mother when she was 3 years old. She loves Japanese traditional culture and is currently running a few projects in English. Her origami experience is about more than learning skills. She loves to share the stories behind traditional origami and teach about Japanese traditional culture and values.",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Deb",
        date: "Julyy 2021",
        comment:
          "I really enjoyed my origami class. Manama did just the right pace, and just the right difficulty. She was very kind and patient as well",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
      {
        id: 2,
        name: "Laura",
        date: "August 2022",
        comment: "I thoroughly enjoyed this experience. As a group we got to pick four origami designs from an assortment. We then made designs. The instructions were clear and easy to follow, particularly with the point of view camera. This was a really fun class!",
        URL: "  https://a0.muscache.com/im/pictures/user/68bf2ada-eadf-4eb0-8f18-f7344676fea4.jpg?im_w=240",
      },
      {
        id: 3,
        name: "Ashley",
        date: " August 2022",
        comment: " This was a team building activity and I am so happy my firm found Manami! I am already planning to get some of my friends together to schedule a Zoom meeting with Manami again. I was worried I was not going to be able to successfully make the origami, but she made the steps very easy to follow. This experience was informative, fun, and relaxing. She shared information about the Japanese culture and origami which was an added plus! I think this experience would be great for classrooms, homeschooling, summer schools, families, team building, friends...really anyone. So much fun!",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 4,
        name: " Brenda",
        date: "  June 2022",
        comment:
          "My mother and I attended this just for fun via wounded warrior project. It was very fun and brought us both back to when we were children. Had an excellent time, was a quick class and got a lot done in the time we spent. Manami was great and explained things wonderfully. Good time all around.",
        URL: "https://a0.muscache.com/im/pictures/user/1cbf6470-0387-497a-a584-eb32340dac5f.jpg?im_w=240",
      },
      {
        id: 5,
        name: "",
        date: "June 2022",
        comment:"She was very friendly, talkative and engaging, but she barely did 40 mins of origami when it should've been closer to an hour. I understand there's setup, ending social media etc, but she barely did two and when asked if she could do another one she said there wasn't enough time, the issue I had with that was she could've done another one maybe not as complex rather than rushing ti end that session, I will not be using her again. ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
         
      },
      {
        id: 6,
        name: "Katherin",
        date: "June 2022",

        comment:" The experience with Manami was fabulous, the whole team enjoyed it, and we had fun; her guidance was excellent over the entire experience, and she is patient if you have never done this and you get lost during the process. 100% recommended. ",
        URL: "https://a0.muscache.com/im/pictures/user/61225c21-786f-48cf-8014-04507dabfdc8.jpg?im_w=240 ",
      },
    ]
  },
  
  {
   id1: 10,
    title: " Go for Gold Olympic Mindset Tips & Games with Lina Taylor ",
    type: "international",
    groupprice: "721",
    priceadult: "29",
    pricechildren: "28",
    priceinfant: "0",
    ratings: "4.95",
    rating: "(165)",
    place: " Olympian and Paralympian collection",
    place2: " Olympics collection",

    host: " Lina",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/cb40b0ea-6695-49e0-b9ab-83cb5a66ca38.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1780962-media_library/original/65925e67-0603-4089-94f9-6f7fa2c0beaf.jpeg?im_w=480",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1780962-media_library/original/aa7347f4-2126-4049-8d4b-a82c6ce60e69.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1780962-media_library/original/db08b499-2ffe-406e-a27c-60a0d37ed77d.jpeg?im_w=240 ",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1780962-media_library/original/b396e5e5-44f9-431b-a629-f289e8b85274.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/daff6c9b-8f9c-4fa7-8d8f-ae6f3b5aad8c.jpg?im_w=480 ",
      },
    ],
    title2: "Olympian experience hosted by Lina ",
    time: " 60",
    language: "English",
  
    what1:
      "This is a great team building experience with games, stories, and mindset tips to set big goals, overcome obstacles, and achieve success directly from your host - 2x Olympian in beach volleyball, Lina Taylor! ",
    what2:
      " Succeeding against the odds is the theme of this experience! With exercises and games, you will discover actionable tips for success. You'll hear some very personal stories, showing you not only that Olympians have challenges like most of us but more importantly, I'll share with you the steps I take to overcome challenges and achieve big goals",
  
    what3:
      " I've recently shared this experience with companies like Google, Pfizer, Twitter, Intel, Shopify, and many more. Here's what one recent participant had to say: “Probably the best presentation of the year. An amazing personal story, truly inspirational, and real actions we can use to improve our own lives ",
  
    bring1:
      " questions about olympics",
    bring2:
      " a smiling face",
  
    hostsince: "2020",
    host2:
      "I'm a two-time Olympian in beach volleyball, entrepreneur, mentor to elite athletes, and a mother of three. All the success I've had in my life didn't come easy. Through engaging stories, games, and exercises, I share practical takeaways that anyone can apply to turn obstacles into opportunities, deal with change successfully, and achieve big goals.Growing up in communist Bulgaria, I had big dreams but even bigger challenges. Yet, I found a way to higher education in America",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "Zdravko ",
        date: " August 2022",
        comment:
          "We invited Lina to speak to our outgoing co-op students and interns. Her presentation was AWESOME. She imparted some great words of advice, tips and a framework for achieving success that anyone can use at any age. The presentation was fun, engaging, and thoughtful. We’ll for sure book Lina again!!",
        URL: "https://a0.muscache.com/im/pictures/user/9b7844d7-6695-4510-83fe-de2867a7b696.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Emily",
        date: "August 2022",
        comment: " Lina's workshop was interactive and such a valuable hour for our team to learn more about effective goal setting. She did a great job connecting with the team, getting folks to share and facilitated plenty of activities which makes for an amazing virtual space. Her story telling and ability to inspire others is truly powerful. Will 100% use Lina again and have recommended her to our entire company!",
        URL: " https://a0.muscache.com/im/pictures/user/ab5e9b13-24fe-4eaf-91eb-11ee80695fee.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: "Namra",
        date: " August 2022",
        comment: " Loved the session with Lina! It was a very engaging session and the Team came out with a strong will to focus and aim for gold! :)",
        URL: "https://a0.muscache.com/im/pictures/user/03c39f84-aeb2-46f5-983c-d4607af8e650.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "Brett ",
        date: "  June 2022",
        comment:
          "Lina was fantastic, on short notice she put together really inspiring content that our team was energized by. I would recommend using her again and think she is great for bringing a team together.",
        URL: "https://a0.muscache.com/im/users/7351692/profile_pic/1379745619/original.jpg?im_w=240",
      },
      {
        id: 5,
        name: "Gwen",
        date: "June 2022",
        comment:" Lina has an incredible story. The experiences and advice she shared were applicable to everyone in our group. We all loved this event!",
        URL: "https://a0.muscache.com/im/pictures/user/eceb2fa6-3fe0-4e44-8085-b1cf7772170c.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: "Geoffrey",
        date: "July 2017",
        comment:"Lina's presentation to our group of people was a great success. She was able to engage and connect with the audience and share her valuable experience while sharing emotions and making sure everyone had a personal take away. ",
        URL: " https://a0.muscache.com/im/users/4498167/profile_pic/1381997462/original.jpg?im_w=240",
      },
    ],
  },
  
  {
    id1: 11,
    title: "  Magic & Scam for Honest Remote Workers",
    type: "international",
    groupprice: "144",
    priceadult: "25",
    pricechildren: "20",
    priceinfant: "0",
    ratings: "4.89",
    rating: "(269)",
    place: "Lyon, France ",
    place2: "Lyon ",

    host: "Maxime",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/ab78e5a5-88a3-4880-9f27-ea0c780ffeb1.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1708825-media_library/original/f4586551-69d1-4816-85f5-63cc961237ec.jpeg?im_w=720 ",
      },
      {
        id: 2,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1708825-media_library/original/16093380-f984-47e1-b30d-11d2b6861eb2.png?im_w=720",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1708825-media_library/original/d7565d10-be4f-4b42-843d-33765fc3b546.jpeg?im_w=720",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1708825-media_library/original/b998fccd-2dc8-46a4-a9da-f7874b427210.jpeg?im_w=720 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1708825-media_library/original/b3a4640d-fc59-4773-8866-bae2b06f7f76.png?im_w=720",
      },
    ],
    title2: "Online experience hosted by Maxime ",
    time: "60 ",
    language: "English",
  
    what1:
      " I'm NOT proposing you a magic show! (Well, yes, a little, but not completely) Shows are entertaining yes, but after nearly 300 clients in one year I can assert this, this is not what you want for your team as a remote activity.Show keep spectator as … well, as spectators: it does not engage them, it does not connect them with each other, it does not involve them.",
    what2:
      "You could organize a cashew engraving workshop or testing of grilled insects but first, your team is a remote one, and second I’m a magician, so I have something else for you: A participatory magic and scam experience where they participate in every trick, play scams and themselves do tricks to amaze their colleagues. Join me during an hour of magic dedicated to them:",
  
    what3:
      " Play Magic games and scams, Learn Psychology and misdirection, Break the ice between colleagues ,Enjoy professional ticks They'll have fun, participate, learn, and be able to redo what they've learned to their friends and families. ",
  
    bring1:
      " Card deck",
    bring2:
      "Coin ",
  
    hostsince: "2016",
    host2:
      "Magician for 8 years and professional for 5 years, I had the opportunity to officiate for many audiences and events in France and abroad. I did stage magic to, and animated the scene of a TEDx conference by illustrating the history and evolution of this art with effects.",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "Jake ",
        date: " April 2021",
        comment:
          "  Booked Maxime for a company social event. We had a great time and learned some new tricks. We had 9 people on and I think it was a good number to ensure everyone was included without feeling singled out, could definitely bring more as well. Highly recommend!",
        URL: " https://a0.muscache.com/im/pictures/user/7658b942-d16b-4c66-a753-71cb043a8029.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Anna",
        date: "August 2022",
        comment: " Great experience! Maxime did a fantastic job on getting everyone involved and leaving us in awe of his magic talent. Highly recommend this activity for team building!",
        URL: " https://a0.muscache.com/im/users/7619319/profile_pic/1415792019/original.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: "Shenny",
        date: " August 2022",
        comment: " I organised this experience for my work team and we all really enjoyed it. Maxime was very accommodating for our timezone - it was 3am where he was at the time and he happily hosted us! Thank you for a memorable event, Maxime! ",
        URL: " https://a0.muscache.com/im/users/4705717/profile_pic/1358219674/original.jpg?im_w=240",
      },
      {
        id: 4,
        name: "Jorge ",
        date: "  June 2022",
        comment:
          "Maxime was great! We had a very fun time watching and learning magic tricks. He is very engaging and perfect for a group event.",
        URL: " https://a0.muscache.com/im/pictures/user/4d23c1df-e917-4e6b-b841-d79c3e5826af.jpg?im_w=240",
      },
      {
        id: 5,
        name: " Amy",
        date: "June 2022",
        comment:" Maxime was a great host. He was extremely friendly and responsive. Despite being a remote event, Maxime created an environment that was very engaging and fun. It was a wonderful way to bond with each other. Everyone learned some new tricks and enjoyed the show.",
        URL: "https://a0.muscache.com/im/pictures/user/54e033d5-cdd3-400b-a245-168c2370efbf.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: "Tae",
        date: "JAN 2019",
        comment:" Maxime was a magical host and taught us some fun tricks :P We wanted a fun, bonding experience for our group and he delivered. I would recommend this experience! ",
        URL: "https://a0.muscache.com/im/pictures/user/a360e64d-c5ee-41a6-b138-7826e1944ff0.jpg?im_w=240 ",
      },
    ],
  },
  
  {
    id1: 12,
    title: "Glutenfree Dumplings by Chef Sunflower Li  ",
    type: "international",
    groupprice: "135",
    priceadult: "29",
    pricechildren: "18",
    priceinfant: "0",
    ratings: "4.97",
    rating: "(435)",
    place: "Hanoi, Vietnam ",
    place2: "Hanoi ",

    host: "  Li ",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/e5a599be-a303-4829-be69-6be67e4b2975.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-4261820-media_library/original/b0199252-5f9f-4963-bfaf-6337d2afc50d.jpeg?im_w=1200",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-4261820-media_library/original/bd6b70f3-2780-4023-8f4c-1394a4e9702c.jpeg?im_w=1440 ",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-4261820-media_library/original/ff782876-6cc9-47e1-8902-1eeb0ef1c58b.jpeg?im_w=1440",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-4261820-media_library/original/c291e7b4-45e1-4872-ba46-759a08a6eaa9.jpeg?im_w=1440 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-4261820-media_library/original/4d65fd7f-067d-4ed3-aa43-b0b59d80cc49.jpeg?im_w=1440",
      },
    ],
    title2: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-4261820-media_library/original/3a629b03-608e-4ccd-916d-71859ba7084b.jpg?im_w=1440 ",
    time: "120 ",
    language: "English",
  
    what1:
      " Let’s make Gluten Free Dumplings! Today your dreams will come true! Experience Chinese food at its best on this food-focused Beijing Cooking Class. Enjoy informative insights into traditional cuisine from your professional teacher. Your friendly private teacher (Chef Miss Li) will meet you online via Zoom. ",
    what2:
      " Timing and scheduling of your class is very flexible. The time can be changed at any point to suit your schedule and time zone. Once you have scheduled your class, you will receive instructions 3 days ahead of time with the ingredients you will need. All recipes will be made from scratch. ",
  
    what3:
      " Classes are usually 90 minutes to 2 hours in length. Team event, birthday parties, anniversaries, bridal shower. Kids and adults both will have a fabulous time! Book your class today to make some delicious and authentic homemade noodles! We look forward to cooking with you very soon!  ",
  
    bring1:
      "Cooking Ingredients/Meat Lovers ",
    bring2:
      "1 cup white rice flour, 1 cup tapioca starch ",
  
    hostsince: "2015",
    host2:
      "Hi Everyone! I am Beijing Dumplings Pro Chef Sunflower Li. I am passionate about food, people and traveling. I’d love to share our family tradition with you! Discover all varieties of dumplings in China. Learn the knowledge of dumplings from a insightful Chinese family! I have hosted guests from United States( San Jose, New York, L.A, Cleveland, Louisville, Austin), Canada, Brazil, Israel, Australia , UK, Germany, Netherlands, Belgium. Team building event, birthday parties, bridal shower, anniversaries.",
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
        {
          id: 1,
          name: "Kelsai",
          date: "August 2022",
          comment:
            "  Booked this for a team bonding activity, a group of 7. Everyone really enjoyed it and Nick managed to engage every person and different personalities in the group. Nick is super knowledgeable and I would highly recommend him and this experience.",
          URL: "https://a0.muscache.com/im/pictures/user/a83302f8-d27e-45ec-970c-d4a7ffd62024.jpg?im_w=240",
        },
        {
          id: 2,
          name: "Parker",
          date: "August 2022",
          comment:
            " Fun experience for a virtual grt together for corporate event. Learned a little bit, moved around the house, some laughs with team and friendly competition with a great host in Juli!",
          URL: "  https://a0.muscache.com/im/pictures/user/5cd9d813-6fba-4ecf-a805-f497fa4620ee.jpg?im_w=240",
        },
        {
          id: 3,
          name: "James",
          date: " August 2022",
          comment:
            " This was a great experience for my team! We all had so much Fun! And we were able to relax and laugh together! Learned interesting things about France as well.",
          URL: "https://a0.muscache.com/im/pictures/user/68dc77f3-1507-4f31-882c-186e047fe05f.jpg?im_w=240",
        },
        {
          id: 4,
          name: " Talia",
          date: "  June 2022",
          comment:
            "I enjoyed my From Paris with Laughs experience with my coworkers, hosted by Juli. She had a fun loving , witty personality that made the experience even more enjoyable. I would definitely recommend to a friend.",
          URL: "https://a0.muscache.com/im/pictures/user/ba23c384-d583-4a86-b177-fbc9e4ef99ac.jpg?im_w=240",
        },
        {
          id: 5,
          name: "John",
          date: "June 2022",
          comment:
            " I booked this event for a team bonding experience and our team had a lot of fun, while learning cool facts about Dumplings! We had lots of laughs :)",
          URL: " https://a0.muscache.com/im/pictures/user/f1d34076-54f6-421f-b6a5-dce5c4324957.jpg?im_w=240",
        },
        {
          id: 6,
          name: "Donald",
          date: "23 aug",
          comment:
            " I took part in this experience with my work for an online team event. Nick involved everyone in the group and was very energetic. Great team bonding, highly recommend!",
          URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
        },
      ],
  },
  
  {
    id1: 13,
    title: " Chocolate Origins & Create with a Maker ",
    type: "international",
    groupprice: "101",
    priceadult: "22",
    pricechildren: "22",
    priceinfant: "0",
    ratings: "4.91",
    rating: "(1301)",
    place: " Kingston, Jamaica",
    place2: " Kingston",

    host: "Nick ",
    hostimg:
      " https://a0.muscache.com/im/users/10849423/profile_pic/1403140475/original.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1701766-poster/original/c3e5df3a-91b6-4f0d-8f9b-ea1349a82fc0.jpeg?im_w=480 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1701766-active_media/original/cb030738-ef3a-475c-8cd2-c0b8cf95679d.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1701766-media_library/original/dd39a037-419a-4872-981b-8ac8c0790971.jpeg?im_w=240 ",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1701766-media_library/original/ef0c0f45-5319-4807-919d-a8ad241077ee.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1701766-active_media/original/0673c2c0-ff8a-4f85-81ce-369a9577a67f.jpeg?im_w=480",
      },
    ],
    title2: " Online experience hosted by Nick",
    time: "60 ",
    language: "English,Catalan and Spanish",
  
    what1:
      "On this experience you’ll learn the true story of how chocolate becomes the world’s favourite sweet, a bitter sweet tale of hard work, artisanship and how business can be a force for good. I’ll tell you about how I went from a BBC Correspondent to a chocolate maker before I explain how we go from the raw ingredients to the finished yummy product. I’ll show you how to hand temper chocolate, from our original development kitchen using a bowl, a table and a spatula.  ",
    what2:
      " We start with our special welcome to Jamaica. We’re located on the edge of the Blue Mountains overlooking Kingston. ",
  
    what3:
      "We’ll look down across the city towards the harbour as I give a brief history of the island and the historical use of cacao.   ",
  
    bring1:
      " Some chocolate that can be melted in a microwavable bowl ",
    bring2:
      " Moulds to pour chocolate into, they can even be tupperware lids, I'll give you a lists of other common items which can be used. ",
  
    hostsince: "2013",
    host2:
      "I'm a former BBC News foreign correspondent, my parents are Jamaican and when I discovered the amazing cacao here on the island, I decided to start my own chocolate factory! We've since won a number of international awards for our bars and work alongside chocolate companies from around the world on sourcing the best fine flavour cacao across the Caribbean.",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Gautam",
        date: "August 2022",
        comment:
          " Booked this for a team bonding activity, a group of 7. Everyone really enjoyed it and Nick managed to engage every person and different personalities in the group. Nick is super knowledgeable and I would highly recommend him and this experience.",
        URL: " https://a0.muscache.com/im/pictures/user/15787901-68d0-4e93-90ed-d3bd039f60d2.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Megane",
        date: "August 2022",
        comment: "I took part in this experience with my work for an online team event. Nick involved everyone in the group and was very energetic. Great team bonding, highly recommend!",
        URL: "https://a0.muscache.com/im/users/15771230/profile_pic/1414688098/original.jpg?im_w=240  ",
      },
      {
        id: 3,
        name: "Victor",
        date: " August 2022",
        comment: " Nick was engaging, full of life, and was able to create an environment where collaboration was still possible in our virtual world. 100% recommend ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 4,
        name: "Matthew ",
        date: "  June 2022",
        comment:
          "I highly recommend this interesting and inclusive chocolate experience with Nick. Great stories and visual representation. Great camera set up, nice view of Kingston, great camera overlooking utensils and chocolate to clearly show the process. Thanks again Nick :)",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
      {
        id: 5,
        name: "Jess",
        date: "June 2022",
        comment:" My group had so much fun! Nick was incredibly engaging, knowledgable, and fun to listen to. You could really tell he loves talking about chocolate. Plus I tempered chocolate successfully for the first time in my life!",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
      {
        id: 6,
        name: "Rose",
        date: "June 2022",
        comment:" My team & I booked this for our quarterly team hangout, and it was by far the best experience we've done in the nearly 2 years I've been here! Nick is such a delight to be around and is incredibly knowledgeable & passionate about his chocolate expertise. I couldn't recommend this more, we all made some pretty spectacular chocolate creations. ",
        URL: "https://a0.muscache.com/im/pictures/user/36b2a356-a54f-476a-847a-43fcb4ebbb24.jpg?im_w=240 ",
      },
    ],
  }  ,   

  {
    id1: 14,
    title: " Mezcal & Tequila Cocktail Masterclass ",
    type: "international",
    groupprice: "470",
    priceadult: "47",
    pricechildren: "26",
    priceinfant: "0",
    ratings: "4.97",
    rating: "(1219)",
    place: "Mexico City, Mexico ",
    place2: "Mexico City ",

    host: "Katri & Hardey ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/165e97e5-1665-472b-8036-e307b9a1565f.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1671671-active_media/original/6013f041-5cca-4a48-83fb-4cc8ca1e28e0.jpg?im_w=1440",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1671671-active_media/original/61db75fd-5b19-435f-97d8-feb9de18036d.jpg?im_w=1440 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1671671-active_media/original/61db75fd-5b19-435f-97d8-feb9de18036d.jpg?im_w=1440 ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1671671-active_media/original/2cabd074-0206-450d-8a37-80f542a44402.jpg?im_w=1440",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1671671-active_media/original/2a14da99-4d62-47c8-ac7d-2ff5eec4e864.jpg?im_w=1440 ",
      },
    ],
    title2: "Online experience hosted by Katri & Hardey ",
    time: " 90",
    language: "English and Spanish",
  
    what1:
      "This is about more than just cocktails, it's about taking a sensory journey to the heart of Mexico's artisan spirit culture. You'll be guided through the creation of 2 to 3 distinctive mezcal/tequila cocktails whilst learning about layering flavours and the cultural significance of the ingredients you'll be using. If you like your cocktails with a kick, this is for you. With the same ingredients, we can also cater for those who prefer a delicious alcohol-free mocktail instead :) ",
    what2:
      " This is a unique opportunity to have charismatic, knowledgable bartenders in the privacy of your own home with our team of world-class, award-winning, bilingual mixologists; Ana, Sade and Ximena. ",
  
    what3:
      " Our class is fantastic for private groups looking to gather virtually whether you're celebrating with family, friends or co-workers, we'd love to host your get-together.  ",
  
    bring1:
      " 80ml/6oz Mezcal or Tequila p/person (any 'blanco' which is the transparent variety)",
    bring2:
      " A handful of raspberries (or mixed berries)",
  
    hostsince: "2012",
    host2:
      "We are Hardey & Katri, co-founders of Gente de Mezcal and together with our in-house award-winning mixology team, led by our Brand Ambassador, Ana Herrera, we have 15+ years of experience in the spirits industry. Ana created our own bespoke cocktail menus for our 3 intimate venues in Mexico City; El Salón, Los Románticos and Salón Rosario where we pride ourselves on offering our clients unique spirit tasting experiences found nowhere else in the city. ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "Stacey ",
        date: "August 2022",
        comment:
          "This experience exceeded my expectations by far. I have done a mixology class in person, I didn't think that virtual would have the same impact. But, the bartender's delivery was so amazing, she did!! Although we all have been working for the same company for more than a year on the same team, it was the first we all met each other in person! It was an amazing team building activity and a wonderful experience.",
        URL: "https://a0.muscache.com/im/pictures/user/e0d3d2a6-3a60-4de9-bd6c-d05c362f1b07.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Mike",
        date: "August 2022",
        comment: "The best online experience of its kind that I have had to date. I was pleasantly surprised with how good my cocktails turned out, which really are in part due to the instructions given by Sade. She was great company and made the entire experience what it was. Highly recommend!",
        URL: " https://a0.muscache.com/im/pictures/user/11d1281c-7c5b-4f59-9b26-0f601899e514.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: "Ericka",
        date: " August 2022",
        comment: "This was my first Airbnb experience and it exceeded my expectations! OMG our mixologist Sade was incredible. I enjoyed it so much because of her. So welcoming, engaging and entertaining. Thank you! ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 4,
        name: "Vaishali ",
        date: "  June 2022",
        comment:
          "I booked this session for a team bonding activity. Ximena was a great host! She was engaged and involved the team during the course of the event. She was thoughtful to suggest substitutions and ingredients to mix and match to curate different drinks. Ximena was kind enough to have the team complete making the drinks even though we were up on time. Appreciate the hosts being accommodating to flexible time requests and involving the team throughout the session. My team really enjoyed it and got a head start to our Friday happy hou",
        URL: "https://a0.muscache.com/im/users/3921559/profile_pic/1350668965/original.jpg?im_w=240",
      },
      {
        id: 5,
        name: "Edie",
        date: "June 2022",
        comment:"This was so lovely - I'm not (usually) a fan of tequila and I'm a very novice cocktail maker. This was so fun and opened up a whole set of possibilities I hadn't thought of ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
      {
        id: 6,
        name: "Ciaran",
        date: "",
        comment:"Great knowledge, and experience, doesnt just show you how to make a few drinks, but teaches you how to build layers of flavour in to your creations. Really well paced, best hour and a half I've spent online in a while!  ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
    ],
  },

  {
    id1: 15,
    title: " Drawn from Within with a New York Artist ",
    type: "international",
    groupprice: "181",
    priceadult: "29",
    pricechildren: "22",
    priceinfant: "0",
    ratings: "4.98",
    rating: "(908)",
    place: "New York, United States ",
    place2: "New York ",

    host: "Ben ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/42921b2e-becd-4666-8ecf-14dfabaea770.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1655361-active_media/original/0e611e0d-deab-41b8-a103-b8568f0fe717.jpeg?im_w=1440 ",
      },
      {
        id: 2,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1655361-active_media/original/5f2f4aa7-6af6-4d4f-a16c-ecdcf890d634.jpg?im_w=1440",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1655361-media_library/original/17decbbd-573a-419e-9532-74e81f049558.jpeg?im_w=1440",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1655361-media_library/original/5d1c7ca9-8397-4884-91c1-c5eb0fea7dff.jpg?im_w=1440 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1655361-media_library/original/5d1c7ca9-8397-4884-91c1-c5eb0fea7dff.jpg?im_w=1440",
      },
    ],
    title2: "Online experience hosted by Ben ",
    time: "60 ",
    language: "English",
  
    what1:
      "Experience creativity from the inside-out. No art background necessary. No drawing skills required!  Perfect for team-building, off-sites & enhancing group dynamics through remote connection or from back at the office.Message Ben to request a specific time not already listed on the calendar or ask about longer 1.5 hr experiences & please let me know if you have any difficulty booking- I am always here to help :) ",
    what2:
      " This is not a technical drawing exercise but an exercise in enlivening the imagination & accessing the creative capacity of body & mind.  As experienced by team Google, Apple, Facebook, Netflix, YouTube, NPR, Amazon, Linkedin, Twitter, Spotify, Cisco, Mind/Body Online. Featured in Travel & Leisure, Mercury News, & Downtown Magazine. Check out Ben's recent interview in Cultbytes online. ",
  
    what3:
      "   Drawn from Within explores the way in which drawing enhances the relationship between inside & outside & allows us to see familiarity with renewed curiosity. The experience provides entry into the creative mind & distills creative principles that can be applied to other areas. ",
  
    bring1:
      " pencil or pen and 1-5 sheets of paper",
    bring2:
      " your artistic senses",
  
    hostsince: "2016",
    host2:
      "Ben Ponté is a New York based artist who specializes in distilling creative principles within an organizational context. Ben holds a Masters of Fine Arts in Painting & Drawing & has exhibited in solo & group exhibitions in New York & internationally. Previous clients include Google, Apple, Nike, Netflix, Amazon, Spotify, Linkedin & Cisco.",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Jarret",
        date: "August 2022",
        comment:
          "Our team of 19 enjoyed the experience. It was a very different way for our team to come together, and the program provided some relatable, enlightening moments.",
        URL: "https://a0.muscache.com/im/pictures/user/ad60c5aa-dc96-4cc9-9327-f1804be05f42.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Prithvi",
        date: "August 2022",
        comment: "Good experience. Ben is a great host and guides in teaching a bit about art and how the same art can be done in different ways",
        URL: " https://a0.muscache.com/im/pictures/user/9743e972-bd05-4fd1-9419-fca4c789ff60.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: "Brenna",
        date: " August 2022",
        comment: " Our group had a great time painting with Ben. He is an excellent teacher with a calm, lighthearted approach and our corporate group loved being able to get creative in such a unique and approachable way.",
        URL: "https://a0.muscache.com/im/pictures/user/6edb7042-f928-413f-9b61-e133090373bc.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "Brady ",
        date: "  June 2022",
        comment:
          "Ben was a gracious, outgoing, and creative host. Our small team enjoyed spending an hour with him on a journey into drawing. Everyone, regardless of their skill level, had an enjoyable time. Ben's topics inspired thought, engaged the group, and encouraged easy-going participation. Thanks again Ben! I'd recommend this for team building and doing something different for a remotely located group.",
        URL: "https://a0.muscache.com/im/users/959446/profile_pic/1415501619/original.jpg?im_w=240",
      },
      {
        id: 5,
        name: "Melati",
        date: "June 2022",
        comment:" Ben’s experience surprises you with the depth of thought - he does not simply share an insight he leads you to discover it yourself. Just wonderful!",
        URL: " https://a0.muscache.com/im/users/10229078/profile_pic/1426709401/original.jpg?im_w=240",
      },
      {
        id: 6,
        name: "Bhagya",
        date: "",
        comment:" This was an amazing experience and it taught us to think outside the box. We did it as a team event for work and everyone had a great time. I highly recommend. ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
    ],
  },

  {
    id1: 16,
    title: "Plan The Perfect New York Vacation",
    type: "international",
    groupprice: "73",
    priceadult: "35",
    pricechildren: "20",
    priceinfant: "0",
    ratings: "4.99",
    rating: "(147)",
    place: " New York, United States",
    place2: " New York",

    host: "Ben ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/f6feffed-9bcb-4dcb-8819-91c3feeafdfa.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2496585-active_media/original/71f6c8fe-048e-4d71-b89e-bc083245b653.jpeg?im_w=1440",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2496585-active_media/original/bdf59668-883e-433e-96f8-1db2de46d7ac.jpg?im_w=1440 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2496585-active_media/original/f116dc6f-955a-4648-836b-4903540c1c46.jpg?im_w=1440 ",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2496585-active_media/original/8d64c46c-96ee-4509-bc94-51c61d61d742.jpg?im_w=1440 ",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2496585-active_media/original/981d1a41-f846-4266-bbed-ad3c19893beb.jpg?im_w=1440 ",
      },
    ],
    title2: "Online experience hosted by Ben ",
    time: " 30",
    language: "English",
  
    what1:
      "Hi, I'm Ben, the #1 reviewed Airbnb Experience Host in New York. I specialize in food and drink experiences in NYC, such as (all available on Airbnb): The New York Sandwich Tour The Sandwich Masterclass (online) The Beers Burgers and Buns Experience   But I also know about much more than just food and drink in New York City. So if you are organizing a trip to NYC for yourself or a group then let’s chat about it.  ",
    what2:
      "  By booking this Online Experience you will save hours of research by discussing local secrets of New York with me, and receiving a list of personal recommendations about NYC to take home after we chat. ",
  
    what3:
      " On this experience, I will share food and drink recommendations, accommodation suggestions, cultural events and hidden gems you won't find in a guide book so that you to enjoy the city like a local, and not as a tourist.  ",
  
    bring1:
      "Please send me your NYC questions ahead of our session so I can prepare the best answers possible. ",
    bring2:
       " laptop with stable internet connection ",
  
    hostsince: "2015",
    host2:
      "As a veteran Airbnb Experience Host, I’ve created many successful NYC food and drink Experiences, hosting over 19,000 guests on my Experiences: 'A Sandwich Masterclass,' 'New York Sandwich Tour', 'The Beers, Burgers and Buns Experience,' and more. As a passionate traveler (50+ countries and counting so far!), I’ve searched the globe for the best food and drink—the best sandwiches, in particular. Documenting my adventures, I’ve published articles, podcasts, and spoken on panels all about my love of food",
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
    comments: [
      {
        id: 1,
        name: "Trang ",
        date: "Ben is great host: energetic, funny and have lots of information about NY city. It’s always good to have a local introduce the city you’re going to.",
        comment:
          "",
        URL: "https://a0.muscache.com/im/pictures/user/f68b96df-1411-4695-8bcb-e3c686fa1ea1.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Jason",
        date: "August 2022",
        comment: "This was a great experience to take as a visitor or local NYer. Ben has awesome knowledge of the city and lots of off beat secrets which I always look for. I highly recommend.",
        URL: " https://a0.muscache.com/im/users/334099/profile_pic/1317328710/original.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: "Ashley",
        date: " August 2022",
        comment: " This was an amazing experience and totally worth it! Don’t go to NYC until you chat with Ben! I’m so glad I did this for our family of 5. I’ve been to NYC for years and multiple times. Doing this experience helped me plan a 3 day trip and on a family budget. And gave us countless ideas! I can’t wait for his next experience. Ben was incredible",
        URL: "https://a0.muscache.com/im/pictures/user/d4b2ab15-9837-4a06-a160-5b3bd019e2a0.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "Andrés ",
        date: "  June 2022",
        comment:
          "Very knowledgeable and charismatic host. He knows how to adapt the message to his guests. Loved meeting Ben, thank you for all the tips, see you in NYC, Andrés",
        URL: "https://a0.muscache.com/im/pictures/user/5a1aa9de-b66b-4c0b-8718-5e58128f63ca.jpg?im_w=240",
      },
      {
        id: 5,
        name: "Marie",
        date: "June 2022",
        comment:"I really enjoyed my experience planning a trip to New York with Ben. He is thoughtful and helpful and works to create an itinerary that makes coming to New York even more exciting. Very worthwhile. ",
        URL: "https://a0.muscache.com/im/pictures/user/ec714326-6393-4972-abc9-6d6541f01149.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: "Angela",
        date: "June 2022",
        comment:"  Great experience! I was happy that Ben wanted to know some info beforehand to make good use of our time. The information I received was very worthwhile, and I am super excited to visit NYC!",
        URL: "https://a0.muscache.com/im/pictures/user/4517e779-23d9-4ecb-a81a-1df3f850ff9b.jpg?im_w=240 ",
      },
    ],
  },

  {
    id1: 17,
    title: " Harry Potter Magic in Edinburgh Tour ",
    type: "international",
    groupprice: "255",
    priceadult: "26",
    pricechildren: "26",
    priceinfant: "0",
    ratings: "4.9",
    rating: "(1275)",
    place: " Edinburgh, United Kingdom",
    place2: " Edinburgh ",

    host: " David",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/9a4a00eb-18e3-4520-8eb7-65cb5575d334.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1694230-poster/original/8259e8da-b4ab-4cec-a211-eede827e8699.jpeg?im_w=1200 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1694230-active_media/original/61cc8260-8c5e-47f0-9afb-fc96aac93dba.jpeg?im_w=1440 ",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1694230-media_library/original/915a9eda-830f-4bf2-a74e-99b2cdca119e.jpeg?im_w=1440",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1694230-active_media/original/a6e1558c-76f3-43e1-9644-1f3a3f29e0b4.jpeg?im_w=1440 ",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1694230-media_library/original/0244a2c6-4338-4678-9ca3-030c2e1eaf84.jpeg?im_w=1440 ",
      },
    ],
    title2: "Online experience hosted by David ",
    time: " 60",
    language: "English",
  
    what1:
      "Join David, Jule, Eden and Maria as we see the beautiful Scottish city of Edinburgh through the eyes of J.K Rowling. From her poor beginnings to a billionaire author. Our tour is brilliant for solo travellers, families, birthday parties, children's parties, team building, and corporate events. For high profile events, ask about our premium tour. ",
    what2:
      "We'll start our tour of Edinburgh using moving images to keep the action fluid and accessible to people will all internet speeds. We'll show you the places where J.K Rowling drew her inspiration, such as the school believed to be the inspiration for Hogwarts, the shops that found their way into Diagon Ally, the graveyard where she got her characters' names and much, much more! ",
  
    what3:
      " Along the way, we'll tell you about the inspiration for some of the most loved characters, and we'll finish with the final quiz to see which Hogwarts house wins.  We also give extra house points to those who show up in costume.   Please message if you can’t find a suitable time. ",
  
    bring1:
      " If you come in costume you'll receive a point for your Hogwarts House",
    bring2:
      " I'll also give an extra point to whoever has the best costume!",
  
    hostsince: "2013",
    host2:
      " David  The creator and a muggle-born Slytherin, I have been a tour guide in Edinburgh for 8 years. This experience joins my deep love for both Harry Potter and Edinburgh. Jule A pureblood Ravenclaw, born in Germany, I became a tour guide after finishing my Masters’s degree at the University of Edinburgh. I love this city and want to share that love. Edinburgh is a truly magical place.",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Julie",
        date: "August 2022",
        comment:
          "My children 6, 8 & 10 & I loved this experience. It was fun, very interactive & David was professional, knowledgeable & fun.",
        URL: "https://a0.muscache.com/im/pictures/user/e10b1a2c-7c45-421d-98f2-d5e0e0e4f983.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Nicole",
        date: "August 2022",
        comment: "The virtual tour was fantastic! David (our guide) made it super interactive with trivia during the tour, and made sure we were sorted into our houses beforehand. He did well making sure that everyone got to participate too, not just those with quicker reflexes to answer the questions ",
        URL: "https://a0.muscache.com/im/pictures/user/fed5ad4e-64c8-47aa-81e8-c8c9a9db5832.jpg?im_w=240",
      },
      {
        id: 3,
        name: "Divya",
        date: " August 2022",
        comment: "I booked the experience as birthday gifts for two of my potterhead friends. They enjoyed the experience quite a lot. One of them is wondering how it would actually feel like to walk around in Edinburgh. ",
        URL: "https://a0.muscache.com/im/pictures/user/b2e7582c-59b2-46b1-ab6d-d441fa667682.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: " Xinmei",
        date: "  June 2022",
        comment:
          "Fun and informative experience! I really want to visit Edinburgh now! David was really knowledge about Harry Potter too and we loved the quiz",
        URL: "https://a0.muscache.com/im/pictures/user/c6d894fd-e0dc-42a9-b0b6-da8edd9c2d0b.jpg?im_w=240",
      },
      {
        id: 5,
        name: "Erica",
        date: "June 2022",
        comment:"This was such a fun and interactive experience! I booked this as a team event for my company and many attendees brought friends and family to join in. As a non-HP fan *gasp* I still enjoyed this a ton. There is so much history and behind the scenes info that makes this a fascinating event for all. ",
        URL: "https://a0.muscache.com/im/pictures/user/9b1a8c27-5da1-487f-9c67-daa5c9880198.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: "Kimberly",
        date: "",
        comment:"funny. he explained funny things about scottish history and jk rowling. i liked her potty joke/tweet. i liked how he talked about jk's mother w/ms and her teacher who offered her job where she can work whenever she was able to. (ie) harry potter's connections to edinburgh. the inspirations for hogwarts, dumbledore, and he asked a lot of questions for us to answer. he sorts us into a hogwarts house, too. i like the funny bathroom picture ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
    ],
  },
  
  {
    id1: 18,
    title: "Wellness and happiness for teams  ",
    type: "international",
    groupprice: "420",
    priceadult: "75",
    pricechildren: "60",
    priceinfant: "0",
    ratings: "4.96",
    rating: "(23)",
    place: "Playa del Carmen, Mexico ",
    place2: " Mexico ",

    host: " Ana",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/005ec25d-283c-4827-ad8c-62a4812668ba.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-3506135-media_library/original/50dda410-6621-4934-94ea-9b9190697bdc.jpeg?im_w=1200 ",
      },
      {
        id: 2,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-3506135-active_media/original/300bb8f4-f007-404e-914c-5da035a812d4.jpeg?im_w=1440",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-3506135-active_media/original/fcc99af5-7ad7-4912-abef-4fb7d0436a45.jpeg?im_w=1440 ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-3506135-media_library/original/7fbaa071-6228-48cc-9427-aa4795d0fa7b.jpeg?im_w=1440",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-3506135-active_media/original/2d922039-842b-4c67-a828-51026e1557f9.jpeg?im_w=1440",
      },
    ],
    title2: " Online experience hosted by Ana",
    time: "45 ",
    language: " English and Spanish",
  
    what1:
      " Don't have time to take care of your well-being? Do you lose focus or concentration while you are working? Does your back hurt from working so many hours? Perhaps you know many techniques to keep your life in balance, do you practice them every day? why you don't practice them? ",
    what2:
      "  To sowing an intention for the day Breathing techniques to relax, increase concentration and energize A 1 minute meditation for busy people Exercises to rest your eyes from the use of screensStretching exercises while you work Gratitude to increase productivity and performance The importance of aromas while you work 5 tips for working from home",
  
    what3:
      "We probably forget about our well-being while working, due to multiple factors. All these practices and habits can be done in a tiny fraction of time. Give yourself a few minutes of calm and well-being!  ",
  
    bring1:
      "A glass of pure water ",
    bring2:
      "Sticky notes ",
  
    hostsince: "2014",
    host2:
      "My life changed due to a car accident while going to the office, that day I had only slept 3 hours and my working hours were more than 12 hours a day. Back then, I didn't have the tools I have today.  I worked for more than 18 years in global agencies and decided to take a radical turn in my life, I left the corporate world. I obtained several certifications such as: Coach in Change of Habits, Certified Meditation guide, and Spiritual, Holistic and Happiness coach.",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Caron",
        date: "April 2019",
        comment:
          "This was the perfect teambuilding experience for a virtual, work from home team. We learned great tips for staying present and intentional during our workday and the whole team left feeling energized to use the techniques Ana taught us on a daily basis.",
        URL: "https://a0.muscache.com/im/pictures/user/2d5c1bee-b133-491e-9882-79a828da5305.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Joy",
        date: "August 2022",
        comment: "The techniques and the way they were presented are just what our team needed and will continue to help the team stay refreshed, focused, and clear-headed. Highly recommended for those that are busy as she teaches you techniques that take only a tiny fraction of the time one has in a day",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 3,
        name: "Terry",
        date: " August 2022",
        comment: "Ana is such a delight, and has the most soothing voice. I thoroughly enjoyed the experience, and so appreciate Ana giving me 45 minutes of peace in what is sometimes a chaotic world. She really delivers a mindful approach on how to improve your inner peace, with some easily appliable techniques ❤️ ",
        URL: "https://a0.muscache.com/im/pictures/user/6826feb1-4c42-4b0d-bd1f-6604ade8698d.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: " Felix Javier",
        date: "  June 2022",
        comment:
          "Ana is a genius at what she does. Would definitely recommend her services for those (like me) who don't have time to take care of ourselves on a daily basis. Thanks, Ana!!!!",
        URL: " https://a0.muscache.com/im/pictures/user/c6d894fd-e0dc-42a9-b0b6-da8edd9c2d0b.jpg?im_w=240",
      },
      {
        id: 5,
        name: "Steve",
        date: "June 2022",
        comment:" I enjoyed the presentation. The speaker was friendly. I found some of the tips she gave actually work, a few a i knew, and one was not my thing. But the ones i liked i still do. Its like buying a cookbook, you get a couple good recipes and it was well worth it ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 6,
        name: "Ashley",
        date: "",
        comment:"  Ana's experience was awesome! She packs the 45 minutes with so many easily implementable takeaways, yet you still leave the experience feeling relaxed and refreshed!",
        URL: "https://a0.muscache.com/im/pictures/user/ac87fff8-984e-43e1-a155-29665d796ffe.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 19,
    title: "  Golden Milk/ Turmeric Latte Master Class - Vegan Friendly",
    type: "india",
    groupprice: "231",
    priceadult: " 20",
    pricechildren: "0 ",
    priceinfant: " 0",
    ratings: "4.89",
    rating: "(123)",
    place: " Jaipur, India ",
    place2: " Jaipur  ",

    host: "  Jd",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/315d0137-292f-4ef2-88dd-7729528a951a.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2989049-media_library/original/06559407-39d3-4abf-a4aa-dd92a2ddcec2.jpeg?im_w=480 ",
      },
      {
        id: 2,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2989049-media_library/original/68177057-e678-4ffc-ae60-45ce3e652b80.png?im_w=480",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2989049-media_library/original/c8922ee1-5b81-4ffb-bffd-c90c385fbdc6.jpeg?im_w=240",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2989049-media_library/original/8bcc4fe6-920d-4148-a46d-50bac020ec4a.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2989049-media_library/original/d3a40744-8d09-4c43-a8c5-7d767f4de13f.png?im_w=480",
      },
    ],
    title2: "Online experience hosted by Jd  ",
    time: " 30 mins ",
    language: " English ",
  
    what1:
      "  Golden Milk aka Haldi Doodh or Turmeric milk or Turmeric latte is a comforting drink made with milk, turmeric and warm spices. ✅ Anyone can make Golden Milk (Even a BEGINNER) ✅VEGAN Friendly ✅This Experience is GREAT for TEAM-BUILDING to reconnect with your colleagues while working from home. Book a private experience for your group. I can host groups up to 500 guests. ",
    what2:
      " Turmeric's anti-inflammatory properties makes it a perfect drink to have when you are under the weather or just when need a little pick-me-up! A classic comforting, warm, and boldly spiced turmeric milk recipe with a hint of sweetness. Commonly consumed in India during the harsh winters to prevent and treat cold, congestion, clear up phlegm from the airways inside the lungs and to help sleep better. ",
  
    what3:
      "Turmeric or haldi as we call it in Hindi is an integral part of Indian cooking. It’s one of those core spices without which you can’t cook Indian food. It’s added to pretty much everything in India from lentils to veggies to pickles, rice – you name it! ",
  
    bring1:
      "Cow Milk / For Vegan use Oat, Almond, Coconut, soya, Milk  ",
    bring2:
      " Turmeric Powder,Ground Black Pepper ",
  
    hostsince: "2017 ",
    host2:
      " I'm Jd a true Delhi-ite . My family have a restaurant since 3 generations (since 1956). I grew up in a big, Punjabi family that was always eating or planning the next meal. Every holiday meant hours around the table. Cooking and eating together was how I learned to show love and to share happiness. Eating and Sharing my cuisine and making connections with people that I love the most, this love took to start cooking classes and food tours. I've been organizing cooking classes and food tours in Delhi for past 6 years.",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Stephanie ",
        date: " June 2022",
        comment:
          " This was such a fun class!! Loved learning how to make REAL turmeric milk and I learned SO much from JD! The host is what makes these experiences and JD was fantastic!",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
      {
        id: 2,
        name: "Felicia ",
        date: "June 2022 ",
        comment: " Very nice experience making tumeric latte with JD. He's a very warm and friendly host and my latte turned out to be tasty. Thank you for the experience!",
        URL: " https://a0.muscache.com/im/users/24336626/profile_pic/1417386512/original.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: " Tim",
        date: " August 2022",
        comment: " Great experience, my wife and I enjoyed learning a new (and fantastic!) recipe, along with the history behind the recipe and ingredients. Look forward to attending JD’s other experiences as well! ",
        URL: " https://a0.muscache.com/im/pictures/user/9b75ff0a-1268-4b8b-a4bf-574c3a4d4d23.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "  Thaise  ",
        date: "  June 2022",
        comment:
          "Wow is all I can say! I booked this experience as part of my birthday celebration. From the very beginning, Jd is very inviting,and makes you feel like you’re talking to an old friend.I loved hearing about his Indian culture, and some great info on the drink we were making. I will define back for another experience with Jd. ",
        URL: " https://a0.muscache.com/im/pictures/user/3bccc79e-05a7-451f-9312-67fd3a8cb16e.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: "Tuyen ",
        date: "June 2022",
        comment:" JD is a wonderful host who makes everyone in the room feel welcomed and included. The 30 minute class was to the point and the haldi doodh turned out delicious.  ",
        URL: " https://a0.muscache.com/im/pictures/user/cc360c11-e3ba-4e96-900a-91436e58bad5.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Jason",
        date: "June 2022",
        comment:" The Golden Milk experience with Jd was fantastic. I had read all the reviews, so was expecting something good and he didn't let us down. Very warm and personable guy, as everyone came online, he was quick to say hello and have a chat, he was very helpful and patient with me as it took me a while to organise, everyone had a great time making the drink and we all had a huge laugh afterwards doing some Bollywood moves. Would absolutely recommend this to anyone. Oh and the drink was delicious (and apparently cured someones ski allergy later that day !) ",
        URL: "  https://a0.muscache.com/im/pictures/user/3cdbcf97-9f72-4e21-8950-98848d74874c.jpg?im_w=240",
      },
    ],
  },
  { 
    id1: 20,
    title: " The Wonder That Is The Taj Mahal & The Moguls ",
    type: "india",
    groupprice: "159 ",
    priceadult: " 23",
    pricechildren: "17 ",
    priceinfant: " ",
    ratings: " 4.98",
    rating: "( 242)",
    place: "  Bengaluru, India ",
    place2: "  Bengaluru  ",

    host: "Praveen  ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/fdf9bf7f-23be-4125-b5ca-ac0a8a49d1b4.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1694651-media_library/original/3ff237fe-a5f3-43f3-9a3b-4d71704a5a48.jpeg?im_w=480 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1694651-media_library/original/a7b5cbee-d948-49aa-9eae-d49f9aa655e5.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1694651-media_library/original/e775f70c-caba-4de6-8263-19ae8406425a.jpeg?im_w=240 ",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1694651-media_library/original/9ff3eed6-d4f3-4dd8-a1fe-120277554a92.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1694651-media_library/original/cb3e295f-932a-4312-84d1-a8d4ae2aad85.jpeg?im_w=480 ",
      },
    ],
    title2: " Online experience hosted by Praveen ",
    time: " 60 ",
    language: " English ",
  
    what1:
      " Is the worlds greatest monument to love, the Taj Mahal on your bucket list? If your answer is yes, then do not miss this experience. This is not a boring historical lecture - it is fully interactive with riveting tales, enchanting views and a fun light-hearted trivia game about the Taj Mahal and the folks who built it, the Moguls. ",
    what2:
      " Did you know, the Mogul Sultans held sway over the wealthiest and largest economy of the world in the 1600s? Come, discover such fun facts even as we explore their astonishing architecture, terrific artwork, fine music, food and fashion - a rich legacy throbbing and alive to this day. The hour-long experience has something for everyone and creates unforgettable memories. ",
  
    what3:
      " Great for corporate teams, dispersed families & friends, birthday parties, date nights and solo explorers too.  Happy to host on a date and time convenient for you. Just ask! "  ,
  
    bring1:
      " Great for corporate teams, dispersed families & friends, birthday parties, date nights and solo explorers too. ",
    bring2:
      " Happy to host on a date and time convenient for you. Just ask! ",
  
    hostsince: " 2015",
    host2:
      " Hi, I run a top-rated Experiential Tourism and Events company based out of Bangalore, India. Feel free to book any of our three highly-rated Online Experiences if you are looking for something exceptional and out of the ordinary. ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Sneha ",
        date: " June 2022",
        comment:
          " My family and I had a lot of fun participating in this experience. The pictures and shots of the Taj were gorgeous, and we learnt so much about that time in history and its continuing influence today. ",
        URL: " https://a0.muscache.com/im/pictures/user/27790fde-1ddb-40b8-8033-d6017015dae3.jpg?im_w=240",
      },
      {
        id: 2,
        name: " Kuki",
        date: "June 2022 ",
        comment: "Truly educational, but in a subtle and entertaining setting. I was skeptical at first but I was glued through out the experience. Highly recommend it! ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 3,
        name: "Sachin ",
        date: " August 2022",
        comment: " Amazing tour. I can imagine how it must be hard to set these things up, as usually tours are in person. Wonderful experience and I very much enjoyed learning about the hidden gems of the Taj and its surrounds ",
        URL: " https://a0.muscache.com/im/pictures/user/58e8a0be-67d5-477a-89f0-66f49d36c8c2.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: " Virginia Marian   ",
        date: "  June 2022",
        comment:
          " This is a fantastic experience to virtually travel to the Taj Mahal. A wonderful way to feel inside the Taj and learn about the history. Thank you!!!",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 5,
        name: " Zsofi",
        date: "June 2022",
        comment:"  The experience with Praveen was an absolute joy! Extremely informative and ejoyable. We loved the way Praveen included references to our day to day life to be able to bring 400-600 year old history / culture closer to us. Well worth the price, the atmosphere was also great, - with him sitting in a beautiful garden- I full heartedly recommend this experience. Thank you Praveen! ",
        URL: " https://a0.muscache.com/im/pictures/user/4c40fa24-bdc5-435d-96e4-c1bd892b3f28.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Jennifer",
        date: "June 2022",
        comment:" We did this experience for a work event and everyone really enjoyed it! It was interesting and informative and the quizzes were fun. Praveen is a great storyteller and had time to answer all our questions. Would highly recommend this! ",
        URL: " https://a0.muscache.com/im/pictures/user/31911067-51f6-4bee-a479-456ae0955dfb.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 21,
    title: " Interactive Indian cooking class with us ",
    type: "india",
    groupprice: " 220",
    priceadult: "27 ",
    pricechildren: "23 ",
    priceinfant: " 0",
    ratings: "4.99 ",
    rating: "( 774)",
    place: " Jaipur, India",
    place2: " Jaipur ",

    host: " Monty & Harshita ",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/f190d31e-cf8c-4799-8e24-324fa91ae0dd.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1679851-media_library/original/193f8bd7-088f-4b16-90a3-0e28218e446c.jpeg?im_w=480 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1679851-media_library/original/0ad1a70e-de25-46fa-97ea-acf956863a5f.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1679851-active_media/original/0968ebdc-9bd9-4c26-93a4-eaf22bb1b81e.jpeg?im_w=240 ",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1679851-media_library/original/2a5f4ecc-78a5-445f-8cc6-7f614dfc241c.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1679851-media_library/original/9d27f2cf-3483-4e23-9a0d-93b6977166ef.jpeg?im_w=480 ",
      },
    ],
    title2: " Online experience hosted by Monty & Harshita ",
    time: " 120 ",
    language: " English ",
  
    what1:
      " This Experience is great for team-building, great for private groups, corporate team, birthday parties & other events. Book a private experience for your group. Is your group larger than my listed max group size for private groups? Send me a message! We change our menu often & below dates are as per IST (Time Zone) - we are ahead of USA/Canada. Please write us to avoid any confusion. If you don't see a time that suits your needs, contact us so we can find a new date/time that works for you ",
    what2:
      "Welcome to our home in Jaipur, India. We are very excited to share our culture, traditions and the fine art of Indian cooking, following traditional recipes on this live session. We will travel together through the steps of each recipe & its history. The food menu is listed below:  ",
  
    what3:
      "  ",
  
    bring1:
      " all the cooking ingredents  ",
    bring2:
      " all cooking utensils",
  
    hostsince: " 2016",
    host2:
      " Hi! We are Monty & Harshita. Our major asset is our compassion for others. I (Monty) have worked as a cultural & culinary tour guide throughout India & Nepal for more than 14 years and received the world guide award hosted by wanderlust magazine in 2015, London. Harshita grew up in a very traditional Hindu family & learnt cooking from her mum & grandma, we have been giving cooking classes for a few years & enjoy sharing our culture so we decided to provide online cooking lessons. ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Mikayla ",
        date: " June 2022",
        comment:
          "Monty was so helpful and patient with us! We learned so much about the food, culture, and his family. Thank you so much! ",
        URL: "https://a0.muscache.com/im/pictures/user/a2055b06-4287-4713-9058-b4f04e2dff85.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: " Daniel",
        date: "June 2022 ",
        comment: "An amazing experience! Monty helped my friends and I to set up a private cooking experience. Not only did it mean a lot to us to be able to connect virtually and share an evening together, but I also learned so much about Indian cuisine from Monty. He has some excellent stories and is clearly very passionate about both cooking and meeting new people. Would recommend this to anyone! ",
        URL: "  https://a0.muscache.com/im/pictures/user/59b77eab-e570-413d-ac5d-f87f07515cf5.jpg?im_w=240",
      },
      {
        id: 3,
        name: "Shaan ",
        date: " August 2022",
        comment: " Fun and entertaining cooking class! We enjoyed hearing Monty’s stories and he breaks it down step by step so it isn’t overwhelming. Definitely recommend. ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240  ",
      },
      {
        id: 4,
        name: " Lydia   ",
        date: "  June 2022",
        comment:
          "Great class that is well paced to the needs of the student. The saag and aloo both turned out delicious. It was lovely learning about Monty's culinary journey. ",
        URL: " https://a0.muscache.com/im/pictures/user/7b40529d-3b2b-4343-9027-9579b0586486.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: "Silke ",
        date: "June 2022",
        comment:"  What's not to love about chickpeas! My kitchen always smells wonderful and my stomach is very happy. :) A great choice for a dinner in. ",
        URL: "https://a0.muscache.com/im/pictures/user/fe4b6ade-6533-432c-9e03-887565bb6fd4.jpg?im_w=240  ",
      },
      {
        id: 6,
        name: "Mikayla ",
        date: "June 2022",
        comment:"  This has been a great and fun cooking session. The food has been delicious and we had such a wonderful time doing this experience. Anytime again!",
        URL: " https://a0.muscache.com/im/users/8890250/profile_pic/1379424772/original.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 22,
    title: "Tarot Reading and Meditation Spiritual Guidance  ",
    type: "india",
    groupprice: " 147",
    priceadult: "20 ",
    pricechildren: " 20",
    priceinfant: " ",
    ratings: "4.98 ",
    rating: "(778 )",
    place: " Dubai, United Arab Emirates",
    place2: " Dubai ",

    host: " Shilpa  ",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/7902ef18-a8aa-4a26-9f57-6aa7a763a0db.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1677605-media_library/original/526c576c-8007-43c3-8e04-d332e154d58f.jpeg?im_w=1440 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1677605-media_library/original/b253ddc9-ba56-4c0e-b2d0-e727956db7bf.jpeg?im_w=1440 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1677605-media_library/original/a944864b-e6fa-4300-9238-a42f7169f1e8.jpeg?im_w=1440 ",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1677605-media_library/original/e46ada76-3abc-4bc0-8dd9-d4573669875b.jpeg?im_w=1440 ",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1677605-media_library/original/39e57411-02c3-44d7-8bff-2b83ace0bf82.jpeg?im_w=1440 ",
      },
    ],
    title2: "Online experience hosted by Shilpa  ",
    time: "  60",
    language: " English and Hindi ",
  
    what1:
      " We will begin with a meditation to quiet our minds and make it receptive and highly tuned to the unseen world, where I will teach you how to connect to your intuition.Then we will learn how to decipher the cards, with a brief lesson on tarot cards, to understand the basics and how to combine your intuition with the picture and story the tarot is showing you, connecting to a higher realm of consciousness. ",
    what2:
      " During the session I will do a reading which will give clarity and lead to an understanding of what the tarot is conveying about your present, past and future. This Experience is excellent for TEAM BUILDING and CORPORATE EVENTS! It is also wonderful for FAMILY and FRIENDS to gather and bond online! :D For larger groups, I will extend the time over 45 minutes. ",
  
    what3:
      " My clients include PFIZER, GOOGLE, AMAZON, INSTACART, INSTAGRAM, TIK TOK, FACEBOOK, TWITTER, SNAPCHAT, SEPHORA, DW, SALES FORCE, SUMMERSALT, DUOLINGO, CAPITAL ONE, COLUMBIA UNI and more! You can also book JUST TAROT READINGS with me for PARTIES and GROUPS!  Look forward to meeting you all! :D ",
  
    bring1:
      " Pen and paper, incase you would like to write down the thoughts and impressions you get during the session. ",
    bring2:
      " Tarot deck if you have one.",
  
    hostsince: " 2015",
    host2:
      "I am an Intuitive tarot reader, healer, a certified counsellor and life coach. I have been reading cards and doing healing work for 10 years now.  Love connecting with people on a soul level, and hearing your stories, sharing the techniques I have learned along my journey, and i'm sure learning from you too! The Tarot has been such a blessing to me and to the people I have read for ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Danielle ",
        date: " June 2022",
        comment:
          "I loved Shilpa’s reading from start to finish. She has such a beautiful energy and enthusiasm for life, it’s contagious! I received the reading for my birthday and then gifted a reading to a friend who also adored the experience and described it as so positive & loving. Since having the reading I’ve made so many little and big changes. Thanks Shilpa x ",
        URL: "https://a0.muscache.com/im/pictures/user/ff765b6b-603c-4ea1-9d4f-767946de5ca3.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: "Matt",
        date: "June 2022 ",
        comment: "Shilpa was just amazing. Her energy is wonderful and her reading was so on point and accurate. I got a lot of clarity from doing this reading. Will definitely do it again. ",
        URL: " https://a0.muscache.com/im/pictures/user/45b7e6bb-397f-473f-bd32-6d9137431d0f.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: "Lucas ",
        date: " August 2022",
        comment: " This is a fun, engaging and informative experience that is easy to do with a team from work or with friends. Shilpa will inform and energize you! ",
        URL: "  https://a0.muscache.com/im/pictures/user/ecb8b7ed-04aa-4d27-be9a-5c7f067cb4da.jpg?im_w=240",
      },
      {
        id: 4,
        name: "   Taylor ",
        date: "  June 2022",
        comment:
          "Shilpa made for an amazing experience. I love doing tarot, so I was a little unsure of how it would be on a computer, but Shilpa exceeded my expectations. We did a reading with four of us. Shilpa took the time to explain the tarot deck, started with a calming and cleansing meditation, then gave us each ur own reading and personalized time. If you had a further question, she was happy to pull another card or discuss further. I can't speak for everyone, but I felt my reading was spot on! My only wish is that we had more time with her. Book Shilpa and you will not regret it, she is magical. ",
        URL: " https://a0.muscache.com/im/pictures/user/4f141701-be91-4889-8bbb-c9800a7a1efd.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: " Miru",
        date: "June 2022",
        comment:" Shilpa was just amazing. Her energy is wonderful and her reading was so on point and accurate. I got a lot of clarity from doing this reading. Will definitely do it again.  ",
        URL: "https://a0.muscache.com/im/pictures/user/62263347-3de9-42e8-a7cf-782dd1bce7cc.jpg?im_w=240  ",
      },
      {
        id: 6,
        name: " Kristina ",
        date: "June 2022",
        comment:"  Shilpa's warm energy was a delight! I joined the event with my mom and sister. The readings for each of us were really good, her interpretation of the past and present was spot on- let's hope the future is true**",
        URL: "  https://a0.muscache.com/im/pictures/user/9dbea02d-5731-4eb5-b25e-a27af8482661.jpg?im_w=240",
      },
    ],
  },
  {
    id1: 23,
    title: " Teams making Curry with Dancing Indian Chef ",
    type: "india",
    groupprice: "256 ",
    priceadult: " 32",
    pricechildren: "30 ",
    priceinfant: "0 ",
    ratings: " 5.0",
    rating: "(13 )",
    place: "  Berlin, Germany  ",
    place2: "  Berlin   ",

    host: "Nistha  ",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/e8b61083-466a-4f0a-b270-0da55dfd9fa0.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2265310-media_library/original/5e0e2652-c390-4c5e-8943-3ef45b731fef.jpg?im_w=480 ",
      },
      {
        id: 2,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2265310-media_library/original/59b7190a-18b9-40bd-8438-ff7d61b3454b.jpeg?im_w=480",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2265310-media_library/original/1d8e93ab-62d9-4111-83c3-6b79f5df06a1.jpg?im_w=240 ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2265310-media_library/original/d8c558ba-7067-4fcd-b030-2fb2ca2c3286.jpg?im_w=240",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2265310-media_library/original/1ba4441b-9e84-4fdb-bd23-8e78dec69e83.jpg?im_w=480",
      },
    ],
    title2: " Online experience hosted by Nistha ",
    time: " 60 ",
    language: "  English ",
  
    what1:
      " Looking forward to a fun cooking event with your team?   Then, what are you waiting for? Join me, put your aprons on, grab your pans & twirl your spoons to prepare India's most loved curry - Butter Masala, and alongside dance to the Indian music beats! ",
    what2:
      " So bid your favorite Indian restaurants adieu & make this handmade love a part of your menu!  Teams from Microsoft, Amazon, Facebook, SAP, HP & many others have already cooked & danced with us. We have also been rated 5 stars for this curry on my other event called Spice It Up with Dancing Indian Chef. ",
  
    what3:
      " To spend some quality time with your team members, Butter Masala Curry is a great option. We will make this nutty creamy curry from scratch & explore its subtle nuances that will make all the differences. ",
  
    bring1:
      " Simple ingredients as per the recipe that you can find anywhere ",
    bring2:
      "Pots and Pans ",
  
    hostsince: " 2019",
    host2:
      "Nistha, the founder of Kitty Party is an Indian chef, corporate event planner and team building event host, and a food connoisseur who has a vast knowledge of spices. She’s genuine, caring and wants to ensure that every guest feels looked after.   She loves her work, and she is passionate about it. She truly makes sure everything is catered to the customer’s needs. She’s also a foodie herself, and she can dance all night without getting tired. She enjoys styling her food. She believes that food and dance are the best ways to liven up the energy. She uses her business skills to host the biggest companies from all across the world. ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "  Verena",
        date: " June 2022",
        comment:
          "Nistha was the best host for our big team event. She has a such a positive energy. It was super fun and enjoyable. Thank you!! ",
        URL: " https://a0.muscache.com/im/users/16099594/profile_pic/1402640622/original.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Annie ",
        date: "June 2022 ",
        comment: "Fun mix of dancing, cooking, and learning! It was a great way to take a step away from work and bond with co-workers. Thank you! ",
        URL: "https://a0.muscache.com/im/pictures/user/195055c5-d155-488b-bf0d-d1798856e0ab.jpg?im_w=240  ",
      },
      {
        id: 3,
        name: "Jamye ",
        date: " August 2022",
        comment: " This was such a fun activity to do with my work team! The pace was perfect and it was easy to follow along with the cooking, and she filled the less active minutes with music, dancing, and storytelling. A couple of people didn't have access to a kitchen for the call, and they were still super involved and engaged because she made such a point to include them. And afterward, we all had a delicious lunch ready to eat! I highly recommend this experience. It was such a cool and unique way to bond with my team! ",
        URL: " https://a0.muscache.com/im/pictures/user/adfa6e18-42b6-42f6-957b-affa461fb949.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: " Arianne   ",
        date: "  June 2022",
        comment:
          "Nistha is a superb host with great attention for detail. I really appreciate that she took the time even before the event to connect and discuss preferences. The event itself went by smoothly, and we all had a wonderful time learning how to make curry (with dancing and music to boot!). Definitely recommend this for team events :) ",
        URL: "  https://a0.muscache.com/im/pictures/user/105ca762-0c8d-4bd1-8833-009d9ee31ad2.jpg?im_w=240",
      },
      {
        id: 5,
        name: " John",
        date: "June 2022",
        comment:"  This was a fun event and the curry turned out so yummy! It was great to learn more about the spices and best practices as well during the process. Nistha was so friendly and helpful throughout the process and such a great host. ",
        URL: "  https://a0.muscache.com/im/pictures/user/f14a7460-d5bc-4a14-b48b-8a5a9d424bd5.jpg?im_w=240",
      },
      {
        id: 6,
        name: "Carly ",
        date: "June 2022",
        comment:"  Loved Nistha's energy and passion for cooking! Wasn't expecting a little garden tour and view of Berlin. She made our team building activity really fun!",
        URL: " https://a0.muscache.com/im/pictures/user/3174d042-86ef-4ef5-b3e6-f12f9f8c14fd.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 24,
    title: "  Plan a trip to Taj Mahal with guidance from a local expert",
    type: "india",
    groupprice: " 200",
    priceadult: " 25",
    pricechildren: "20 ",
    priceinfant: " 0",
    ratings: "4.25 ",
    rating: "( 256)",
    place: " Agra, India ",
    place2: " Agra",

    host: "Asif  ",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/5aee370d-812a-4505-859b-9d36f7dc8721.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-3237790-media_library/original/1110124c-e16d-4578-9200-e1521a21ed06.jpeg?im_w=480 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-3237790-media_library/original/7a33f9b3-27e7-43bd-9481-5179bcd615bf.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-3237790-media_library/original/3e38185a-3a82-4c27-91a5-fe58d831fa3f.jpeg?im_w=240",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-3237790-media_library/original/37c46e9d-373d-4ab1-9709-a08178befb0a.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-3237790-media_library/original/b56b27ba-63c3-4914-9c0a-47cc5a984b4c.jpeg?im_w=480",
      },
    ],
    title2: " Online experience hosted by Asif",
    time: "  60",
    language: "english  ",
  
    what1:
      "Planning a trip to Taj Mahal? And have questions Like.  What airline should I fly with to India?  Do Indians speak any English or is it impossible to talk to them?  What port should I fly into to get to the Taj Mahal?  Do I need travel insurance or are hospitals cheap? And many more……  On this one-hour virtual session get all your questions answered and reserve yourself for the most amazing days to come.  ",
    what2:
      " On this live interaction I will share my secret on how to cut the cost of your tour by getting the best accommodation and transportation in a very reasonable price.  You will get the first hand information by an expert and local on where to Stay, Places to Eat? Things to Do? What to Wear, Places to See Around the Taj Mahal and learn how to greet in local language, what to wear and the tipping rules. Know how to arrange transportation, guide or hotels. ",
  
    what3:
      " My professional and local recommendations on hidden gems, and city secrets that will make your visit a memorable one. If you want a one-on-one customized itinerary, please book a private class. Otherwise, we’ll speak more generally in this group session. ",
  
    bring1:
      " questions about india and tajmahal ",
    bring2:
      " internet connection",
  
    hostsince: "2020 ",
    host2:
      " A competent professional with 11 years of experience in guiding FIT's and group tours. Have a lifelong fascination with history, particularly India’s colorful past and indigenous history. Always enjoyed in passing on my knowledge and passion for the Indian outback to visitors, ensuring they have the opportunity to experience the best our country has to offer in safety and comfort  and to promote sustainable, environmentally friendly tourism with enthusiasm and in a way that connects with as many people as possible.",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "  Verena",
        date: " June 2022",
        comment:
          "Nistha was the best host for our big team event. She has a such a positive energy. It was super fun and enjoyable. Thank you!! ",
        URL: " https://a0.muscache.com/im/users/16099594/profile_pic/1402640622/original.jpg?im_w=240",
      },
      {
        id: 2,
        name: "Annie ",
        date: "June 2022 ",
        comment: "Fun mix of dancing, cooking, and learning! It was a great way to take a step away from work and bond with co-workers. Thank you! ",
        URL: "https://a0.muscache.com/im/pictures/user/195055c5-d155-488b-bf0d-d1798856e0ab.jpg?im_w=240  ",
      },
      {
        id: 3,
        name: "Jamye ",
        date: " August 2022",
        comment: " This was such a fun activity to do with my work team! The pace was perfect and it was easy to follow along with the cooking, and she filled the less active minutes with music, dancing, and storytelling. A couple of people didn't have access to a kitchen for the call, and they were still super involved and engaged because she made such a point to include them. And afterward, we all had a delicious lunch ready to eat! I highly recommend this experience. It was such a cool and unique way to bond with my team! ",
        URL: " https://a0.muscache.com/im/pictures/user/adfa6e18-42b6-42f6-957b-affa461fb949.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: " Arianne   ",
        date: "  June 2022",
        comment:
          "Nistha is a superb host with great attention for detail. I really appreciate that she took the time even before the event to connect and discuss preferences. The event itself went by smoothly, and we all had a wonderful time learning how to make curry (with dancing and music to boot!). Definitely recommend this for team events :) ",
        URL: "  https://a0.muscache.com/im/pictures/user/105ca762-0c8d-4bd1-8833-009d9ee31ad2.jpg?im_w=240",
      },
      {
        id: 5,
        name: " John",
        date: "June 2022",
        comment:"  This was a fun event and the curry turned out so yummy! It was great to learn more about the spices and best practices as well during the process. Nistha was so friendly and helpful throughout the process and such a great host. ",
        URL: "  https://a0.muscache.com/im/pictures/user/f14a7460-d5bc-4a14-b48b-8a5a9d424bd5.jpg?im_w=240",
      },
      {
        id: 6,
        name: "Carly ",
        date: "June 2022",
        comment:"  Loved Nistha's energy and passion for cooking! Wasn't expecting a little garden tour and view of Berlin. She made our team building activity really fun!",
        URL: " https://a0.muscache.com/im/pictures/user/3174d042-86ef-4ef5-b3e6-f12f9f8c14fd.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 25,
    title: " ॐ ( OM ) - Vedik Sanskrit Mantra Meditation ",
    type: "india",
    groupprice: " 65",
    priceadult: "20 ",
    pricechildren: "15 ",
    priceinfant: " 0",
    ratings: "4.99 ",
    rating: "( 145)",
    place: " Delhi, India ",
    place2: " Delhi ",

    host: " Roopak  ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/daf7713b-e0fd-49c0-8a27-e67a4e3073ac.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2416656-media_library/original/d382c14a-025e-47d3-9742-a4043fb531c1.jpeg?im_w=480 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2416656-media_library/original/9dace328-1fa1-462a-887d-55ae7089dea5.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2416656-media_library/original/2bfecc0c-78e1-492e-b030-03edcc526e27.jpeg?im_w=240 ",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2416656-active_media/original/8f0c5f84-1246-46c1-bf8f-1d300990798b.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2416656-media_library/original/6832c091-4afc-4617-a876-7702b11a38da.jpeg?im_w=480 ",
      },
    ],
    title2: " Online experience hosted by Roopak ",
    time: " 30 ",
    language: "English",
  
    what1:
      " ॐ ॐ ॐ ॐ ॐ ॐ (OM) is the oldest Vedic Sanskrit Mantra - said to be one of the most powerful Mantras of all times. Today, ॐ (OM) is a globally popular spiritual symbol.  ॐ (OM) is the basic sound of the universe. ॐ (OM) Chanting symbolically and physically tunes us into that sound and acknowledges our connection to everything in the Universe. The rhythmic pronunciation & vibrations of ॐ (OM) Chanting will – ",
    what2:
      "   Have a calming effect on bodyReduce the stress Increase the concentration Give peace of mindTreat depression Let go off the negativity Feel more energized Align mind, body & soul Regulate the sleep cycle Improve the health",
  
    what3:
      "In this online experience, a brief introduction shall be given on ॐ (OM). Thereafter, ॐ (OM) Chanting shall be taken up by the Host at a stretch for 108 Times. The Guests can either listen to ॐ (OM) Chanting or can participate with the Host. Guests shall be free to ask Questions they might have after the ॐ (OM) Chanting ends.  ",
  
    bring1:
      " complete attention  ",
    bring2:
      " rudraksh if you have",
  
    hostsince: " 2018",
    host2:
      "I am living in Delhi for last 13 years with my family consisting of my wife & two grownup children.  In June 2020, I curated an online Experience on HINDU CULTURE during the lock-down period. To understand all about Hinduism, this is a must see online Experience which is having 250+ Reviews on Airbnb. ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Karen ",
        date: " June 2022",
        comment:
          " That was my second session with Roopak. He is very attentive and helps you through the vibes of meditation. I highly recommend his sessions ! Namaste 🙏",
        URL: " https://a0.muscache.com/im/pictures/user/4b90d0a2-7448-4c31-841c-fa565a7a9d83.jpg?im_w=240",
      },
      {
        id: 2,
        name: " Astrid",
        date: "June 2022 ",
        comment: "This was an amazing experience! I've never tried this kind of meditation before. We learnt more about the OM sign and how to pronounce correctly to feel the vibrations in your body. It looks like a short session but actually is not. You will have the theory and then some practice. I really recommend it ! ",
        URL: "https://a0.muscache.com/im/pictures/user/04d76a67-c23e-48d5-9856-064a236f7d6d.jpg?im_w=240  ",
      },
      {
        id: 3,
        name: " Wendy",
        date: " August 2022",
        comment: " Very informative session. Learnt a lot about the powerful symbol & we ended with a mediation session which was great for putting our knowledge into practice. ",
        URL: " https://a0.muscache.com/im/pictures/user/2a8d341e-0031-4988-9e94-81dd1e1c7de8.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "  Joe  ",
        date: "  June 2022",
        comment:
          " Some people bring light to your life, Roopak is such a person. Thank you Roopak for making my mum smile and making Sundays memorable creating memories 🙏 forever grateful for your kindness.",
        URL: " https://a0.muscache.com/im/pictures/user/91955842-09a4-4500-b1d3-c4328bcc8efc.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: " Owtsar",
        date: "June 2022",
        comment:" Roopak is accommodating and he make sures everyone is involved in the session. You'd learn a lot from his topic and will enjoy the interactive part where you have to do the chant along with him and the group. Keep it up, Roopak!  ",
        URL: " https://a0.muscache.com/im/pictures/user/5e6939d9-2825-4636-ab85-823c6f953ed9.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Jennifer",
        date: "June 2022",
        comment:"This was a really cool experience. I learned a lot of new information and also feel like my meditations have become a lot easier using the simple technique that Roopak taught us.  ",
        URL: " https://a0.muscache.com/im/pictures/user/adc3482f-207b-4aad-918a-cea3c374f40f.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 26,
    title: " Hidden Gems of Pink City, Jaipur ",
    type: "india",
    groupprice: "56 ",
    priceadult: " 25",
    pricechildren: "20 ",
    priceinfant: " 0",
    ratings: "4.99 ",
    rating: "(119 )",
    place: " Jaipur, India ",
    place2: " Jaipur ",

    host: " Ajay ",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/20cf1894-3c76-4f75-ba9d-6e3c42e7ccf1.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-639251-media_library/original/af30c34a-a5f8-405d-978b-e23565e84d01.jpeg?im_w=480 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-639251-media_library/original/ae01252c-e2cf-4be6-8d4c-704261423f28.jpeg?im_w=240 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-639251-media_library/original/70d64af4-c141-40f3-871c-1141898861fe.jpeg?im_w=240 ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-639251-media_library/original/2c78936b-8b26-4025-8ffe-d48db3363235.jpeg?im_w=480",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-639251-media_library/original/2a061edf-8003-40da-8213-f65401ca8dbf.jpeg?im_w=1440",
      },
    ],
    title2: "Experience hosted by Ajay  ",
    time: " 120 ",
    language: " English ",
  
    what1:
      " Top 10 things which make our tour the best tour of Jaipur in one day  1. Amber Palace : World Heritage Sight, Excellent photography. 2. Panna - Meena Kund : Most beautiful Step well from Jaipur.  3. Water Palace - Summer Retreat of Jaipur Royal Family. 4. Hawa Mahal : Most beautiful & popular sight of Jaipur. The Hawa Mahal or Wind Palace.  5. City Palace : The Current residence of Jaipur King. ",
    what2:
      " 6. Janter - Manter : The most well Preserved Observatory from the Country. A World Heritage Sight. Take a look at the World's Largest Sun Dial. 7. Albert Hall : Wait.... Wait.... Wait.. We are not moving to London. Jaipur Albert Hall will make you speechless. We will stop here for the photography.  8. Patrika Gate : A popular sight for a great photography. Instagram and facebook.  9. Gaitor : Majestic, Intricately Carved Royal Cremation.  ",
  
    what3:
      " Let's have an interesting chat with me and I will answer all your questions like..  Why Cows are Holy Why Cows are on the Streets Arrange Marriages, Cast System in India, Why Ganesha is symbol of GoodLuck Indian Politics, Sati, Child marriages, Education System, Karma, etc. Modern Jaipur Secrets of Local Spices Explore the Bazaar Helpful Tips : For the first time Visitors to India. ",
  
    bring1:
      "  ",
    bring2:
      " ",
  
    hostsince: " 2019",
    host2:
      " My name is Ajay Singh and I belong to a traditional Hindu Rajput family from Jaipur.  I am a big travel enthusiast & I love traveling across the globe and during all those days of traveling, I have maintained a good network of friends overseas. The largest share of credit of why I decided to disclose the hidden Gems of Pink City, Jaipur goes to my friends who encouraged me to share local treasury of my own city with people. The pink city with vibrant culture, traditions, religion, opulent palaces, cuisine and royalty would spare no chance to surprise you with its charm.",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Darina ",
        date: " June 2022",
        comment:
          "The communication with Ajay before the trip was excellent and he made sure I felt safe as a solo female traveler. During the tour there are many things to see and Ajay points them all and knows a lot. I would definitely reccomend taking this tour with Ajay, because it feels professional, well organised and like a full coverage of Jaipur. And plus: you have many amazing photos in the end of the day.. with you on them! ",
        URL: "https://a0.muscache.com/im/pictures/user/ee3562b0-2261-4c08-9168-3e6f22f757c0.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: " Krishna",
        date: "June 2022 ",
        comment: "Ajay’s tour of Jaipur is great! He greeted me with flowers and water and it was nice to ride in an air conditioned car on such a hot day! Ajay is an expert on Jaipur and will share a lot of information about the history of the city as well as Indian culture. He is also a great photographer and knows all the great places to take pics! I am a solo female traveler and Ajay’s tour was a great way to feel safe and comfortable while touring the city ",
        URL: "  https://a0.muscache.com/im/pictures/user/774b2912-70cc-42c9-9068-fec3cfeecd41.jpg?im_w=240",
      },
      {
        id: 3,
        name: " Anant",
        date: " August 2022",
        comment: " The guide took good photos and shared interesting stuff about the locations. He let me know that we could stay longer in certain locations if I wanted. ",
        URL: " https://a0.muscache.com/im/pictures/user/2d767e9a-d008-4a15-b0ba-fb8a1b76c098.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: " Kimberley   ",
        date: "  June 2022",
        comment:
          "Wonderful experience! Ajay was a gentleman. He patiently took us around the city and had in depth knowledge of the history and the culture of the city. If you want to explore the city then I would highly suggest Ajay over everyone else listed on Airbnb. ",
        URL: " https://a0.muscache.com/im/pictures/user/fd0ba232-6464-49c0-8979-91e9fb8afb76.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: "Katelyn ",
        date: "June 2022",
        comment:" This was a very great trip with Ajay. From the time I met Ajay, he welcomed me in traditional way and as well as our driver. Ajay is easy going and easy person to talk and get along with. He makes sure you are ok and had water and snacks in the car. He knows a lot about Jaipur history and the culture here in Rajasthan. Lots of knowledge. I would didn’t plan to get a tour with anyone but after reading his reviews I booked and got exactly what everyone else said  ",
        URL: " https://a0.muscache.com/im/pictures/user/4f09e819-ed88-43c7-b8e1-40433546d426.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Jahleel",
        date: "June 2022",
        comment:"Ajay is the best tour guide you can book in Jaipur. Not only a tour guide with knowledge and experience but also a great photographer. He showed me all gems of Jaipur in a magical way and I can’t recommend his tour enough. Just book it and explore yourself. Great help with booking taxi on arrival in Jaipur, too. He goes above & beyond for his clients. Recommended tour  ",
        URL: " https://a0.muscache.com/im/pictures/user/b4293912-d277-42ab-a754-40a1eac31a39.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 27,
    title: " Enjoy Home Cooking with us ",
    type: "india",
    groupprice: " 210",
    priceadult: " 35",
    pricechildren: "30 ",
    priceinfant: " 0",
    ratings: " 4.97",
    rating: "(65 )",
    place: " Jaipur, India ",
    place2: " Jaipur  ",

    host: " Monty & Harshita ",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/f190d31e-cf8c-4799-8e24-324fa91ae0dd.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/ba7ec4f1-27a3-40be-acee-6933bb8910da.jpg?im_w=480 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-724137-media_library/original/10262c7e-f6fd-4738-aae4-8325048238a5.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/55ea6668-3f05-4ac3-9fd4-f4a1a364c29e.jpg?im_w=240",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/d0202018-3a62-4212-a712-4d0188a897a9.jpg?im_w=240 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/60a44893-6e43-4c3d-aa58-af0aec602c4e.jpg?im_w=480",
      },
    ],
    title2: " Cooking experience hosted by Monty & Harshita ",
    time: " 90  ",
    language: "  English",
  
    what1:
      "You’ll be welcomed into our kitchen to master the fine art of cooking, following my mom's recipes. Using only the freshest ingredients I'll show how I prepare and make our traditional food. We’ll enjoy Indian drinks, some starters and a delicious meal together whilst I give you insight into some of the oldest recipes in the world.  ",
    what2:
      " We’ll welcome you to our home and serve you one of our traditional Indian drinks (chai, lassi, lemon soda, fresh seasonal juice, etc.). The class will begin with an introduction to the spices, herbs and ingredients that we will be using in the recipes.",
  
    what3:
      " We’ll focus in more details on the North Indian cuisine which includes dishes like chapati, paratha (Indian breads), seasonal vegetable curries (garlic bhindi, aloo gobhi, dal, pumpkin curry, carrot curry, paneer masala, tinda curry, eggplant masala, baigan bharta, and gutaa curry).  ",
  
    bring1:
      " crockery ",
    bring2:
      " veggies ",
  
    hostsince: " 2016",
    host2:
      "My name is Monty, I was born and brought up in India and I have been working in the travel industry for almost 14 years now. I am a people person, I like travelling, love food and enjoy meeting likeminded travellers. My wife Harshita and I love to cook so we decided to provide cooking lessons for our international guests travelling through India. During this class, we'll walk you through the culture and history of Indian cooking and we'll eat what we cook together. It's a hands-on immersive experience, and always a lot of fun!  ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "  Imraan",
        date: " June 2022",
        comment:
          "Awesome experience. Food tastes amazing and great to feel that you cooked it yourself. Warm, gracious and very hospitable was Monty and his wife and their new entrant to the family. Highly highly recommended ",
        URL: "https://a0.muscache.com/im/pictures/user/a4325db1-5507-46f8-ad61-9211f5b15d6a.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: "Eliza ",
        date: "June 2022 ",
        comment: " Awesome experience. Food tastes amazing and great to feel that you cooked it yourself. Warm, gracious and very hospitable was Monty and his wife and their new entrant to the family. Highly highly recommended",
        URL: "https://a0.muscache.com/im/pictures/user/91d0f9ca-a9fd-442b-8c38-2d9dd6142dbc.jpg?im_w=240  ",
      },
      {
        id: 3,
        name: " Vanessa",
        date: " August 2022",
        comment: " Highly recommend this experience. Monty has many years of experience in tourism and he told us stories all evening long. Harshita is so friendly that it feels like hanging out with a friend and making supper. If you are in Jaipur, don’t miss this! ",
        URL: " https://a0.muscache.com/im/pictures/user/5ae79057-87cc-4691-bc90-4d1e80123507.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: " Kevin   ",
        date: "  June 2022",
        comment:
          " Monty and Hashita were very welcoming hosts who thought us about local cuisine but also shared their cultural knowledge that helped us improve our understanding of the country if India",
        URL: " https://a0.muscache.com/im/users/9292100/profile_pic/1381185909/original.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: " Cat",
        date: "June 2022",
        comment:"Wow, where to start. Monty and Harshita are such warm and welcoming people. They invited us into their home and shared their knowledge and passion for Indian food with us. Before the experience started, they were very responsive to our concerns about my partners severe allergy to all nuts (dry fruits) and seafood. They provided reassurance that this wouldn't be a problem and it wasn't. Throughout the cooking process, they were clear on what ingredients were being used and made us feel completely at ease. The cooking process was really fun and the end result was delicious! Monty and Harshita are very open and welcome any and every question on their culture and lives. They even shared their wedding video with us which was so special and a spectacle to be seen! If you're in Jaipur and want to do a cooking class, I couldn't recommend this experience enough.   ",
        URL: " https://a0.muscache.com/im/users/21676124/profile_pic/1411473854/original.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Kitri",
        date: "June 2022",
        comment:" My husband and I found ourselves with one extra day in Jaipur and nothing to do before our evening flight home. Harshita and Monty welcomed us into a their beautiful home very last minute and showed us how to create a great feast of several different local dishes. They were careful to customize the dishes based on our allergies and preferences (replacing peanut oil due to my husbands nut allergy, and leaving out the cilantro on my portion because, ew). Both were so friendly and welcoming and happy to let us get hands-on practice and answer questions. It was wonderful to get a taste of food that is made on a daily bases by so many families in the region rather than just eating restaurant food again. We would absolutely recommend this class to anyone visiting Jaipur. ",
        URL: "https://a0.muscache.com/im/pictures/user/f7391624-3c99-4edb-bde6-36ca6700d3fd.jpg?im_w=240  ",
      },
    ],
  },
  {
    id1: 28,
    title: " Day-hiking with TheBangaloreGuy ",
    type: "india",
    groupprice: "250 ",
    priceadult: " 35",
    pricechildren: "30 ",
    priceinfant: " 0",
    ratings: " 4.95",
    rating: "(156 )",
    place: " Bengaluru, India ",
    place2: " Bengaluru ",

    host: "Siddarth  ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/d2b51f56-9052-41d8-adc2-a0ff97cd428c.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-3376933-media_library/original/4edd9f1e-2029-42aa-89d7-d09468c80902.jpg?im_w=480 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-3376933-media_library/original/010cf174-62aa-4dd0-82d7-31e40f60b2ad.jpg?im_w=480 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-3376933-media_library/original/d36fe61e-aaca-4006-839c-f594c6ea3fc9.jpg?im_w=240 ",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-3376933-media_library/original/5ff46cb7-1a72-44ef-91ef-1c6473b4baf2.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-3376933-active_media/original/a9806766-437d-4f21-8689-91360ef36ecd.jpeg?im_w=480 ",
      },
    ],
    title2: " Experience hosted by Siddarth ",
    time: " 240 ",
    language: " English and Hindi  ",
  
    what1:
      " This experience will teleport you from Bangalore traffic to PEACE.  The trek is easy and you'll enjoy it. Don't believe me? Check reviews :')  LIST OF TOP 20 TREKS AT BOTTOM. Scroll down for list. Where will we go?  It’s different every week. But our hiking destination always has a spectacular view and breeze. ",
    what2:
      "  This experience will teleport you from Bangalore traffic to PEACE.  The trek is easy and you'll enjoy it. Don't believe me? Check reviews :')  LIST OF TOP 20 TREKS AT BOTTOM. Scroll down for list. Where will we go?  It’s different every week. But our hiking destination always has a spectacular view and breeze. ",
  
    what3:
      " This experience will teleport you from Bangalore traffic to PEACE.  The trek is easy and you'll enjoy it. Don't believe me? Check reviews :')  LIST OF TOP 20 TREKS AT BOTTOM. Scroll down for list. Where will we go?  It’s different every week. But our hiking destination always has a spectacular view and breeze.  ",
  
    bring1:
      " Highly recommended: water bottle, full pants and sports/trekking shoes ",
    bring2:
      "Good-to-have: Sunscreen, chocolates/fruits, umbrella, cap, jacket. ",
  
    hostsince: "2015 ",
    host2:
      " I’m passionate about hiking and nature. I got introduced to treks during my school days & since then, I haven’t found a better way to connect with the nature.  Feeling the fresh oxygen in my lungs, the wind on my face and the green around me makes me forget all the things about the city’s traffic and hustle. From my experience, I’ve learnt that the best way to move in nature, is by respecting it with the rule of three Cs. Compassion (for other living and non-living creatures)  Cleanliness (of the surrounding) Caution (Respect the nature and its boundaries)",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],

    comments: [
      {
        id: 1,
        name: " Pravidhi ",
        date: " June 2022",
        comment:
          " It was an amazing experience. Met some awesome people on this trek. Siddharth is a great host who is very friendly and considerate. He has this energy that keeps you motivated to keep going even on the hardest patches of the trek.",
        URL: "https://a0.muscache.com/im/pictures/user/9627cf80-c4e6-4252-846b-00b28a22f7a2.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: " Karan",
        date: "June 2022 ",
        comment: " it was a really nice experience. we did a nice hike and also cleaned up the trash thrown by people on the way down. so we got the feeling of doing a scenic hike and fulfilling feeling of doing something good.",
        URL: " https://a0.muscache.com/im/pictures/user/33fca22a-77de-4982-9bbf-a2dea4c3077b.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: " Manthan",
        date: " August 2022",
        comment: "  Handi Gundi Betta trek, as strange as it might sound, the experience of the trek was next level. Being my first trek, Siddharth was super helpful when it came to guiding and helping with what we were not supposed to do at that location. The location was top notch, and the history behind it was even better, and the approach uphill to experience the beauty of the location was a challenging thing to do (for newbies like me :) ) but each and everything was worth it. Thanks very much Siddharth for making the experience worthwhile.",
        URL: " https://a0.muscache.com/im/pictures/user/a1155589-b4fa-4082-b839-9c94f106b90a.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "  Steven  ",
        date: "  June 2022",
        comment:
          "Epic! While I knew it would be a hike, I didn't mentally prepare for the terrain to be a bit slippery because of all the rain last night & days prior. This made it a bit more physically demanding and challenged me to be extra careful. Sid was very encouraging asking the group to take it nice and slow so as to avoid any accidents. ",
        URL: "  https://a0.muscache.com/im/pictures/user/a970f7a3-52db-4900-9f34-fd06cc3b39d3.jpg?im_w=240",
      },
      {
        id: 5,
        name: "Gopal ",
        date: "June 2022",
        comment:"  It was a good experience, going on this hike with Sid. The location he took us was not at all a crowded one, so that was a plus point. ",
        URL: "https://a0.muscache.com/im/users/24927892/profile_pic/1418892338/original.jpg?im_w=240  ",
      },
      {
        id: 6,
        name: " Keval",
        date: "June 2022",
        comment:" Location: Handi gutti betta It was a great and epic one day trek with amazing people. Our host Siddharth is very helpful for everything during the trip. The breakfast location was very nice and tasty food. overall I would like to say that it was a great experience.! ",
        URL: " https://a0.muscache.com/im/pictures/user/8ad89cc6-8d99-4a73-9528-3beb0b069956.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 29,
    title: "  Authentic Apple Crepe with a Indian chef",
    type: "india",
    groupprice: "264 ",
    priceadult: "35 ",
    pricechildren: "25 ",
    priceinfant: "0",
    ratings: "4.98 ",
    rating: "(1569 )",
    place: " Delhi , India ",
    place2: " Delhi  ",

    host: " Emma ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/0a2f4edb-a923-448e-bd02-dffc1bd4c187.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1683137-media_library/original/9832213c-1351-4201-957f-855ac9b7a735.jpeg?im_w=480 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1683137-media_library/original/63a803c0-b0f5-42be-839f-34983530d624.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1683137-media_library/original/d6ad86eb-8cbe-4869-9ddb-539c7b1c60fb.jpeg?im_w=240",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1683137-media_library/original/0b884631-e219-4b30-a495-ac73837d2cc7.jpeg?im_w=240",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1683137-media_library/original/c801df83-6e68-4d11-b140-5c7eedfc085b.jpeg?im_w=480",
      },
    ],
    title2: "  Online experience hosted by Emma",
    time: " 60 ",
    language: " English ",
  
    what1:
      " Explore French flavors with a French chef and learn how to make the best authentic crepe recipe ever.  In this interactive online experience, I’ll teach you how to make a French crepe. Once I walk you through this recipe step by step, you’ll be able to re-create this dish to wow your family and friends in the future. We’ll go through the basic recipes, and we will improve the standard dish to give it your own unique (and soon-to-be signature!) flavor.  ",
    what2:
      "   You could do this recipe in family, with friends, or even for a team-building event. It's a good anniversary present. It's a way to spend some time with family or friends who are living far from you. Not only that, but it's having a fun moment with people you never met before from all around the world. Furthermore, it's a way to not have a boring day! ",
  
    what3:
      " I hope that you will join me on my best authentic crepe recipe with apples and after this cooking class you're willing to do my other cooking classes experiences like the authentic French Baguette, Onion soup, Ratatouille, Magic cake, tarte tatin French Quiche, and my foolproof Macaron..  ",
  
    bring1:
      " ingredents  ",
    bring2:
      " utensils ",
  
    hostsince: " 2015",
    host2:
      "  Over the past 2 years, I've hosted many guests around my table for French breakfast and brunch via Airbnb, receiving thousands of 5-star reviews. Some of my guests have even told me that I need a TV show to share my French cuisine with the world. Guess what? Airbnb has created an even better opportunity for me. With online experiences, I can bring my cooking to you and prepare delicious dishes with you in real time, no matter where you are in the world. Let's cook French food together!",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "  Eduardo",
        date: " June 2022",
        comment:
          "This was such a fun event. Emma was such an engaging story teller and did a great job including everyone in the activity. I just tried the recipe with my kids helping and they loved cooking it and lived even more eating it This recipe will become a new favorite of my family. ",
        URL: "https://a0.muscache.com/im/users/5652738/profile_pic/1438141763/original.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: " Jason",
        date: "June 2022 ",
        comment: "By the end of the experience I had made an incredible apple crepe! It really impressed my wife. I served her breakfast in bed for the first time in years. I felt as if I had traveled to France and received a personal cooking lesson from a top chef! ",
        URL: "https://a0.muscache.com/im/pictures/user/89551587-3252-4a09-8fbb-6ff13f4786c1.jpg?im_w=240  ",
      },
      {
        id: 3,
        name: " Rebecca",
        date: " August 2022",
        comment: " By the end of the experience I had made an incredible apple crepe! It really impressed my wife. I served her breakfast in bed for the first time in years. I felt as if I had traveled to France and received a personal cooking lesson from a top chef! ",
        URL: " https://a0.muscache.com/im/users/1855662/profile_pic/1361947420/original.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "  Janny  ",
        date: "  June 2022",
        comment:
          " Super fun for our team bonding activity! Emma was energetic and funny. At the end of it, you get to have a delicious crepe to enjoy.",
        URL: "https://a0.muscache.com/im/pictures/user/d91ec843-7767-46a3-b534-00e238a7b44c.jpg?im_w=240  ",
      },
      {
        id: 5,
        name: "Kayla ",
        date: "June 2022",
        comment:"Emma is very experienced with online cooking classes and is able to cater to participants using american measuring (eg. cups) in addition to metric or grams. She's also knowledgeable about substitutions, which ones work and which don't. I did use gluten free baking flour for my crepes and it turned out perfectly! She has great energy, a warm smile, and a lot of practical tips. I would definitely take another class with her.   ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 6,
        name: "Mary ",
        date: "June 2022",
        comment:" Emma was a fantastic host for our work event! Our group ranged in cooking skills and she was able to accommodate us. I highly recommend her for any and all future cooking classes. ",
        URL: " https://a0.muscache.com/im/users/6747060/profile_pic/1413944016/original.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 30,
    title: "  The Wonder That is India ",
    type: "india",
    groupprice: "550 ",
    priceadult: " 75",
    pricechildren: " 50",
    priceinfant: " 0",
    ratings: " 4.98",
    rating: "( 254)",
    place: "Bengaluru, India  ",
    place2: "Bengaluru  ",

    host: " Praveen  ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/fdf9bf7f-23be-4125-b5ca-ac0a8a49d1b4.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-424786-media_library/original/3c033e1f-bbe1-4e39-bcd2-9d9f49b3be23.jpeg?im_w=480 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-424786-media_library/original/07a5fe2d-b85f-43e3-bc6f-3cb6af564b62.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-424786-media_library/original/4a8158db-f1e7-413f-933d-bfe065870c17.jpeg?im_w=240",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-424786-media_library/original/a0852a78-02ad-4d70-aa9d-8d2bdd05b28e.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-424786-media_library/original/ccd38ab1-117b-413a-8811-8d4b65a9291f.jpeg?im_w=480 ",
      },
    ],
    title2: " Online experience hosted by Praveen ",
    time: " 60 ",
    language: "  English  ",
  
    what1:
      " Beware! This experience is likely to transform your perception of the country forever. It is a visual and storytelling feast. I will take you through over three dozen spectacular locations that showcase the variety and diversity of this vast ancient land. Fun polls will determine what you get to see and hear. You are in the driver's seat! ",
    what2:
      " India is one of those rare places where you can go skiing in the mountains in the morning, sight wild tigers and elephants in evergreen forests and 1000-year-old monuments by afternoon and sun tan yourself on a tropical beach by the end of the day. ",
  
    what3:
      " Great for team building and corporate events and large groups. The host has been rated 5-stars by companies such as Amazon, Google, Meta, Cisco, Linkedin, Salesforce, Tesco, Airbnb and several ivy league and global Universities. Happy to host a session on a date and time convenient for you.  ",
  
    bring1:
      " laptop with strong internet conection ",
    bring2:
      " questions about India ",
  
    hostsince: "2018 ",
    host2:
      " Hi, I am a passionate history and culture buff running a boutique experiential tourism and events firm for several years in Bangalore, India It has been rated top notch by 1000s of guests from all over the world. ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "Kerrie  ",
        date: " June 2022",
        comment:
          "We did a Teambuilding exercise with a host from India (Praveen) on Airbnb. This was a first for me and super cool! Praveen was very pleasant, had a great route (with optional variants), and amazing pictures and videos to share! He encouraged group interaction and participation with poll questions. Made me want to go visit India tomorrow! ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 2,
        name: "Shelby ",
        date: "June 2022 ",
        comment: " Praveen was very personable and kept us engaged throughout the tour. He showed us so many things that you would not expect to see in India and told us the history behind it. Thank you again Praveen!",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 3,
        name: " Pinky Tham ",
        date: " August 2022",
        comment: "Great experience exploring India with Praveen. Such a wholesome experience and learn so much about the diverse wonderful places in India. Thanks so much Praveen! I look forward going to those places in person!  ",
        URL: " https://a0.muscache.com/im/users/10720610/profile_pic/1387506078/original.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "  Heather  ",
        date: "  June 2022",
        comment:
          "Praveen is wonderful and knows his stuff! He is clearly used to working with audiences who are unfamiliar with all that India has to offer. He kept us on schedule moving at a great pace. I loved seeing the maps to show us which region we were in, along with videos and images. Highly recommend this tour ",
        URL: " https://a0.muscache.com/im/users/10720610/profile_pic/1387506078/original.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: "Sharon ",
        date: "June 2022",
        comment:" I did this as a team building. In this time that we can’t travel as much, this is a great way to introduce people to the world. And wow! India did not disappoint. Praveen was so accommodating! ",
        URL: " https://a0.muscache.com/im/pictures/user/9f60ace2-bc10-4d9d-8424-27feb5fa6e64.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Ilia",
        date: "June 2022",
        comment:" What an interesting insight into what India has to offer! We discovered many sites and cities that we had no idea of, and while we didn't book plane tickets immediately we certainly want to do it in the future! ",
        URL: " https://a0.muscache.com/im/pictures/user/87631c43-487a-44b9-bb37-e654ec2dd11f.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 31,
    title: "  Plan a trip to amazing Austin",
    type: "popular",
    groupprice: " 118",
    priceadult: "37 ",
    pricechildren: "37 ",
    priceinfant: " 0",
    ratings: "4.98 ",
    rating: "( 189)",
    place: "  Austin, New York, United States ",
    place2: "  New York  ",

    host: " Kat ",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/11b82a0c-ee36-4314-9cd1-b04ef6e5df54.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: "  https://a0.muscache.com/im/pictures/lombard/MtTemplate-3134396-active_media/original/bdc8c92f-dc25-465f-af0f-0307647e31dd.jpg?im_w=720 "	
   	
        
      },
      {
        id: 2,
        URL: 
        "https://a0.muscache.com/im/pictures/lombard/MtTemplate-3134396-active_media/original/94552f35-e37d-486c-95bc-644823b77a28.jpg?im_w=720",
      },
      {
        id: 3,
        URL: "      https://a0.muscache.com/im/pictures/lombard/MtTemplate-3134396-active_media/original/01ba2db5-1151-443e-8906-ed865ec91176.jpg?im_w=720",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-3134396-active_media/original/40f326f8-703f-4fe3-953f-8581882cd2af.jpg?im_w=720 ",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-3134396-active_media/original/beb36a9e-4723-4cf3-986d-7e3f751e9133.jpg?im_w=720 ",
      },
    ],
    title2: "  Online experience hosted by Kat",
    time: "60  ",
    language: "english  ",
  
    what1:
      " Join Kat for a taste of Austin and all its charm! This former teacher and CEO of a global custom event design company will take you on a fun deep dive into the culture, food, shopping, landmarks, parks, traditions, festivals, vibes, whimsy, history, art, and/or quirks that make Austin one of the leading travel destinations ",
    what2:
      " Kat will greet you enthusiastically and get to know you and your interests, travel goals and priorities. Her southern hospitality is catching! She will provide personalized recommendations on things to see and do while in the amazing Bat City! ",
  
    what3:
      "   Kat can even help you create a custom itinerary! Come find out why Austin has always been one of the friendliest cities and also why people say, “I wasn’t born here, but I got here as quickly as I could!” Then get ready to do the same! ",
  
    bring1:
      " queations about austin ",
    bring2:
      " laptop with shtong internet connection",
  
    hostsince: "2011 ",
    host2:
      " Kat is thrilled to introduce you to her favorite city, her chosen home. She is the founder of a global event design company, Alley Kat Adventures. She hosts many city wide scavenger hunts throughout North America.  She also hosts a successful series of virtual team building games. She has welcomed corporate teams from Facebook to Amazon and so many others. Her company has been featured in dozens of press, including Business Insider, Good Housekeeping, etc. Her Houston hunt was featured in a Greyhound commercial.",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "  Veronica",
        date: " June 2022",
        comment:
          "If you are planning on going to Austin and want to take the best out of your time, this is definitely the best way to get prepared! ",
        URL: "https://a0.muscache.com/im/pictures/user/78bf37a6-7aee-48df-8c6c-138ff91de848.jpg?im_w=240	 ",
      },
      {
        id: 2,
        name: "Katie ",
        date: "June 2022 ",
        comment: " Kat is so fun and such an amazing wealth of information!! It was so fun to see Austin in a different way and find some new places I didn’t know about!! I would highly recommend this!!",
        URL: " https://a0.muscache.com/im/pictures/user/1ef7062a-4409-4a4c-9929-10289ee2da3b.jpg?im_w=240	",
      },
      {
        id: 3,
        name: "Vashti ",
        date: " August 2022",
        comment: " This was a cool and unique experience we did with our team at work! Fun way to virtually explore the city! ",
        URL: " https://a0.muscache.com/im/pictures/user/d1f94494-ed40-4781-8cbb-ad56b97ce7dc.jpg?im_w=240	  ",
      },
      {
        id: 4,
        name: " Hendrik   ",
        date: "  June 2022",
        comment:
          " We were so lucky to be the first participants ever for this event. Kat was super accommodating. She had a deck prepared that was well structured and had plenty of information on Austin that you would not find anywhere else.",
        URL: " https://a0.muscache.com/im/users/8379727/profile_pic/1406375274/original.jpg?im_w=240	 ",
      },
      {
        id: 5,
        name: " Lakaya",
        date: "June 2022",
        comment:" This was a great experience I learned sooo much about the city and made my over all trip in the following days much more enriching! Was able to learn about local unique attractions including museums and restaurants and the best places for unique photo ops (the girlies loved that!) and even fun activities for my young kids to enjoy!  ",
        URL: " https://a0.muscache.com/im/pictures/user/05cf14e4-5b52-497c-a9af-2921fb9a0ab5.jpg?im_w=240	 ",
      },
      {
        id: 6,
        name: " Caroline",
        date: "June 2022",
        comment:" Lovely experience and very informative!  ",
        URL: "https://a0.muscache.com/im/pictures/user/76a2f172-03ab-4be3-82b6-0d10b573765a.jpg?im_w=240  ",
      },
    ],
  },
  {
    id1: 32,
    title: " New Zealand Nature Highlights ",
    type: "popular",
    groupprice: " 579",
    priceadult: "78 ",
    pricechildren: " 70",
    priceinfant: " 0",
    ratings: " 4.87",
    rating: "(917)",
    place: " Palmerston North, New Zealand  ",
    place2: " Palmerston ",

    host: " Arthur ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/19fc5ef1-96a8-4257-ba57-f6b94b3e6bac.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: "  https://a0.muscache.com/im/pictures/lombard/MtTemplate-1722226-media_library/original/76003968-f54b-43c5-8ce9-66b3ca1012f0.jpeg?im_w=1440",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1722226-media_library/original/40136b46-0fa8-45b1-9ceb-b6ed70d760a7.jpeg?im_w=720 ",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1722226-active_media/original/a1661258-4989-4fce-9df7-fadbd64022c4.jpeg?im_w=320",
      },
      {
        id: 4,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1722226-media_library/original/e0cfccbe-6ebb-4682-a135-05888e655db4.jpeg?im_w=320 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1722226-media_library/original/76003968-f54b-43c5-8ce9-66b3ca1012f0.jpeg?im_w=1440",
      },
    ],
    title2: " Online experience hosted by Arthur ",
    time: " 90 ",
    language: "  English and Chinese (Simplified) ",
  
    what1:
      " The experience is live-streamed from the lifestyle farm and will start with an introduction of New Zealand. The animals are rotated around the different paddocks (pastures), but there is a good chance you will get to see ewes (sheep), kunekune pigs and chickens. ",
    what2:
      " The camera will be projected onto the paddocks where I will take you on a walking tour. Along the way, I will explain things that go on around the farm, share interesting facts about my sustainable lifestyle and ecosystems, and you will have the opportunity to ask questions. ",
  
    what3:
      " You could be joining from your office or from the comforts of your home or be part of a group. If you prefer, you could organize your own private session with family, friends or colleagues. The perfect teambuilding or family bonding opportunity and 'travel' to to Aotearoa New Zealand during the upcoming festive season.",
  
    bring1:
      "  questions about live stock ",
    bring2:
      "  questions about Newzeland",
  
    hostsince: "2015 ",
    host2:
      " I relocated from Singapore to Aotearoa (New Zealand) in 1996. Since 2012 I have been living on a lifestyle block in the city of Palmerston North, which is about 2 hours north of Wellington, capitol of New Zealand.  This is my piece of heaven, and I absolutely adore the great outdoors it offers - the green fields, majestic sunrise and sunset, and of course, my farm animals.  Friends and acquaintances from all over the world have joined the experience. What my guests enjoy the most, is the opportunity to see the beauty that New Zealand offers.",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Rubini ",
        date: " June 2022",
        comment:
          "Arthur is very knowledgable and showed us around his farm animals, sheep and chicken. Beautiful pastures too! It is a nice experience to see and get to know New Zealand more! ",
        URL: "https://a0.muscache.com/im/pictures/user/8d2fb4dc-2ea5-4d42-bd6c-ea096b02b549.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: " Joyce",
        date: "June 2022 ",
        comment: "Arthur is amazing! He gave us an unforgettable online experience, showing us his farm and explaining the operation. It was so much fun seeing the lovely animals Arthur has. Would love to go to Arthur's farm someday in the future to meet him and his animals in person! ",
        URL: "  https://a0.muscache.com/im/pictures/user/56109eeb-7aa4-4e2d-847d-02a0b71ed9d5.jpg?im_w=240",
      },
      {
        id: 3,
        name: " Samantha",
        date: " August 2022",
        comment: " First I have to say how absolutely GORGEOUS it was on the farm- if you want to see some lovely landscapes and happy animals, I can absolutely recommend this experience! Arthur, the host, was very kind and entertaining, with an amazing energy and was more than happy to answer all of our questions. ",
        URL: "  https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
      {
        id: 4,
        name: " Akanksha   ",
        date: "  June 2022",
        comment:
          "Great experience for remote friendly things to do! Highly recommend it to everyone who wants a glimpse of NZ life at its best.. Keep up with the good work Arthur, great to hear about your transition journey and visiting you farm and understanding a life of a farmer. ",
        URL: "  https://a0.muscache.com/im/pictures/user/c25f8b72-4889-47f7-8228-86db3ba6fe50.jpg?im_w=240",
      },
      {
        id: 5,
        name: " Crystal",
        date: "June 2022",
        comment:" Arthur was part of our hybrid team event after being the top choice amongst several other experiences, and he did not disappoint! Arthur brings a ton of experience and a wealth of knowledge to this experience that he presents in a very calm, friendly, and easy to understand manner.  ",
        URL: "https://a0.muscache.com/im/pictures/user/882f94af-8b9b-4962-b772-0a1fb855cca0.jpg?im_w=240  ",
      },
      {
        id: 6,
        name: " Mallory",
        date: "June 2022",
        comment:" 100% recommend. Arthur is friendly and engaging, the views of the farm and surrounding areas are beautiful, and the animals are adorable. The experience was very educational and fun. ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240  ",
      },
    ],
  },
  {
    id1: 33,
    title: "  Tiramisù, ice cream & sorbet, all secrets",
    type: "popular",
    groupprice: " 230 ",
    priceadult: "  52",
    pricechildren: " 45 ",
    priceinfant: " 0",
    ratings: "4.23 ",
    rating: "( 558 )",
    place: "   Milano, Italy ",
    place2: "   Milano  ",

    host: " Bruna  ",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/7b9049ae-b50d-4afd-84d0-0902d1d42cf4.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1721143-media_library/original/52fe9ec9-3813-4a9b-9ab4-76bf828d1063.jpeg?im_w=480  ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1721143-media_library/original/5f1e35cc-aca4-4ec4-9ffd-48c6d2639e24.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1721143-media_library/original/26428def-00ce-4b72-a26d-fb28f41ee7f8.jpeg?im_w=240  ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1721143-media_library/original/06a96571-505d-4e26-a817-2d032c3c7a04.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1721143-media_library/original/3a46b435-b7b0-4f83-aabc-76c5b089ed43.jpeg?im_w=480 ",
      },
    ],
    title2: "Online experience hosted by Bruna   ",
    time: "60   ",
    language: "  English and Italian  ",
  
    what1:
      " This Experience is great for team-building,family, anniversary, birthday or bachelorette party and kids. . Book a private experience for your group, till 100 persons, send me a message!  If you don't see a date that works for you, pls send me a message. It will take around one hour to prepare a Tiramisù, Gelato and sorbet (fruit and coffee) , that will remind you of Italy, the sea, art and our tasty cuisine.  ",
    what2:
      "Italian gelato is the best in the world and it is incredibly easy to prepare and tiramisù is a Italian treasure  You only need a freezer and a mixer, a lot of delicious fruit, chocolate (or cream for the creams lovers, on request ",
  
    what3:
      "  And let's take some time to find out the secret of the classic tiramisù, a family recipe, that follows the one of its creator: soft, sweet, delicious and unique. ",
  
    bring1:
      "After you book the experience you'll receive the list of ingredients and tools that you'll need  ",
    bring2:
      " laptop with internet connection ",
  
    hostsince: "2015 ",
    host2:
      " Follow me live on line: only 1 h hour to discover the secrets of icecream, sorbet and tiramisù with us, directly from YOUR kitchen.  My name is Bruna and I’ve always travelled a lot: when a was little thank to my father’s diplomatic passport and when I grew up thanks to my job. My passion for cooking and the family recipes passed down through generations have been refined in the best Italian and international cooking schools, including the Paul Bocuse Institute (3* Michelin) in the beautiful Ecully castle. ",
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "   Andrew",
        date: " June 2022",
        comment:
          "  Bruna was a great host! Super friendly and simple instructions that were easy to follow. Definitely recommend prepping your tools and ingredients ahead of time though.",
        URL: "  https://a0.muscache.com/im/pictures/user/38b9ba46-0ff1-4fd9-8873-7b7bc4a54084.jpg?im_w=240",
      },
      {
        id: 2,
        name: " Brittany ",
        date: "June 2022 ",
        comment: " Bruna was amazing, her story telling behind every recipe made the experience for my team and I wonderful! Definitely will be coming back for more lessons! ",
        URL: " https://a0.muscache.com/im/pictures/user/8c9f0ac8-be43-457a-bc59-b6903afbe9e3.jpg?im_w=240",
      },
      {
        id: 3,
        name: " Cassie ",
        date: " August 2022",
        comment: " We really enjoyed our Airbnb experience w/ Bruna. She was very sweet and we made some great desserts. For someone who never makes desserts, it was easy to follow along. Bruna was very helpful along the way and our team loved her Pro tip - measure out ingredients beforehand b/c it is easy to fall behind ",
        URL: "https://a0.muscache.com/im/users/5136242/profile_pic/1361338992/original.jpg?im_w=240  ",
      },
      {
        id: 4,
        name: "  Jay   ",
        date: "  June 2022",
        comment:
          " Bruna is an excellent host. She brings a lot of energy and positivity, and encourages participation during the event! Preparing your ingredients and utensils before the session will help stay organized during. ",
        URL: "  https://a0.muscache.com/im/pictures/user/b542a232-a61e-4b53-bcde-42567a71de22.jpg?im_w=240",
      },
      {
        id: 5,
        name: "  Ailing",
        date: "June 2022",
        comment:"We thoroughly enjoyed Bruna's session. She's very kind to impart her knowledge and also made the session felt so enjoyable and lively! Will highly recommend her session to all.   ",
        URL: "  https://a0.muscache.com/im/pictures/user/cb236129-a912-4a67-9585-fe6d238005b7.jpg?im_w=240",
      },
      {
        id: 6,
        name: " Rachel ",
        date: "June 2022",
        comment:"Bruna's class was a blast! We made 4 desserts in an hour and 15 mins. She was great at sharing instructions and keeping everyone engaged. The recipes were simple and fun to make.  ",
        URL: " https://a0.muscache.com/im/pictures/user/3c41c6fe-418f-407c-a342-38670d6dcfad.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 34,
    title: " Healing concert by Kuniatsu",
    type: "popular",
    groupprice: " 550  ",
    priceadult: " 50 ",
    pricechildren: "25  ",
    priceinfant: " 0",
    ratings: " 4.87",
    rating: "( 256 )",
    place: "  大阪市, Japan ",
    place2: "  Japan ",

    host: "   Kuniatsu",
    hostimg:
      " https://a0.muscache.com/im/users/25152659/profile_pic/1423833182/original.jpg?im_w=1440 ",
    images: [
      {
        id: 1,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2038668-media_library/original/bfc211eb-8496-4828-a106-2b2992a374e1.jpeg?im_w=1440 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2038668-media_library/original/7a505318-a9f2-4321-92b7-b98e973edcfe.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2038668-media_library/original/8ba0f562-198c-456d-b359-ed4e64c93679.jpeg?im_w=480 ",
      },
      {
        id: 4,
        URL: "  https://a0.muscache.com/im/pictures/lombard/MtTemplate-2038668-media_library/original/18afb32d-079e-47a3-899a-b044f626a739.jpeg?im_w=240",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2038668-media_library/original/21b69e3e-7eb6-43ca-9bd1-ee0e9bb1d189.jpeg?im_w=480 ",
      },
    ],
    title2: " Online experience hosted by Kuniatsu  ",
    time: "  60 ",
    language: "  English  ",
  
    what1:
      " Healing session is not only passive but also interactive. Japanese monk with Professional Cellist   ( 9 USD slot , higher rate ) Japanese monk sutra chanting etc. solo performance ( 7 USD slot ) ",
    what2:
      " 30 minutes for normal sessions. 45 minutes for private group if whole slot booking.",
  
    what3:
      " I will ask you to mute your mic while listening sounds, and do humming or breathing out. You will learn how much it is more effective in your body.  Don't forget humming or breathing out while listening.  You can learn not only cello and sutra chanting, but also feel the vibration to heal yourself with your body.  one more to note, better high-speed Internet connection. ",
  
    bring1:
      " preferably ... headphones ",
    bring2:
    "  laptop with internet connection ",

  
    hostsince: "2015 ",
    host2:
      " I am a Japanese Buddhist monk who provide ANOTHER airbnb on-line experiences. MEDITATION WITH A JAPANESE BUDDHIST MONK   it is quite popular.  voice and cello , this type of sound , the vibration can heal those who like music.  but how do we interact through online ?   you shall breath out slowly or humming  with our sound vibration.  many guests who joined my meditation say  my voice is very soothing while chanting mantra.  so why not chanting sutra !  ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Gillian  ",
        date: " June 2022",
        comment:
          "  This was a wonderful mindful experience. A half hour committed to soothing music and chants as well as breath work. As anxious as I am, this experience helped me feel a bit more at peace in my body. Would highly recommend if you’ve got the time.",
        URL: " https://a0.muscache.com/im/pictures/user/5ef86a3c-53dd-44a2-9d9c-b00994c16b69.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: " Robin ",
        date: "June 2022 ",
        comment: " Kuniatsu-san & Dorette are so talented, and the experience was very unique. The team was delighted by it and I'd recommend it for every team out there that wants to stop and recharge. Great job! ",
        URL: " https://a0.muscache.com/im/pictures/user/5ef86a3c-53dd-44a2-9d9c-b00994c16b69.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: " Isaac ",
        date: " August 2022",
        comment: "I feel so wonderful after this half hour of music and chanting! I meditate and I am a Reiki practitioner. Their healing concerts are indeed healing. The ability to hum or intone along with them both, in the privacy of my own home, allows me to have a very deep, relaxing, rejuvenating experience  ",
        URL: " https://a0.muscache.com/im/pictures/user/b199ee44-1655-4ad4-8c2c-1edb08c137dc.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "  Tae   ",
        date: "  June 2022",
        comment:
          "I highly recommend this experience to anyone who needs some spiritual cleansing! Their music helped me hit the reset button and regain focus and clarity.  ",
        URL: " https://a0.muscache.com/im/pictures/user/585e6fd7-2966-4794-a037-11f3dfa54dbb.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: " Robin",
        date: "June 2022",
        comment:"    What a wonderful experience! I felt absolutely renewed afterward. It was so wonderful to be able to vocalize / hum / follow the tones while listening to the beautiful cello music and the chanting of sutras. I felt my whole being was vibrating to the pure tones!",
        URL: " https://a0.muscache.com/im/pictures/user/5ef86a3c-53dd-44a2-9d9c-b00994c16b69.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Derek ",
        date: "June 2022",
        comment:" The music is soothing, it brings calmness to the participants. I was breathing with the healing music, I enjoyed the heart and soul of this concert.  ",
        URL: " https://a0.muscache.com/im/users/14499432/profile_pic/1400699116/original.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 35,
    title: "  Plan the perfect trip to sunny Miami",
    type: "popular",
    groupprice: " 125 ",
    priceadult: " 56 ",
    pricechildren: "50  ",
    priceinfant: " 0",
    ratings: "4.89 ",
    rating: "(  125)",
    place: "  Miami, Florida, United States  ",
    place2: "   Florida   ",

    host: "  Kat ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/11b82a0c-ee36-4314-9cd1-b04ef6e5df54.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-3076506-media_library/original/5f0a977a-ebc0-4f82-b2a5-08e00a5a72a4.jpg?im_w=1440  ",
      },
      {
        id: 2,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-3076506-active_media/original/52ef7248-6b7c-4dfe-8858-f94f84cdc4a5.jpg?im_w=480",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-3076506-active_media/original/f41915a1-e446-4c7e-b778-21826aee2079.jpg?im_w=240 ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-3076506-active_media/original/6fcf4b94-16a6-48c9-a96b-9f8632ab76a8.jpg?im_w=240 ",
      },
      {
        id: 5,
        URL: "  https://a0.muscache.com/im/pictures/lombard/MtTemplate-3076506-active_media/original/e44350e5-744f-4e80-a457-296e30ed29d5.jpg?im_w=480",
      },
    ],
    title2: "  Online experience hosted by Kat ",
    time: " 60  ",
    language: " English   ",
  
    what1:
      "  We will greet you and learn about your life, where you’re from, and why you’re interested in visiting Florida. Sara knows where the best spots are enjoyed by locals all over town and where you can even get special VIP discounts. We’ll share fun facts about Miami and the best-kept secrets that involve local culture, art, history, shopping, where the locals go, and food. We will share our favorite food and entertainment suggestions for boating enthusiasts as well.",
    what2:
      "Want to know the scoop on anything from celebrity mansions to local lore and more? We’ll help you plan a special trip to Miami and perhaps beyond in Florida. ",
  
    what3:
      " So slap on your sunscreen, pour your favorite orange juice or adult beverage, and sport your fancy sunglasses as you relax in this all-inclusive mental getaway to last you until it’s time to pack your bags for your trip!  ",
  
    bring1:
      " questions about Miami ",
    bring2:
      " laptop with internet connection ",
  
    hostsince: "2015 ",
    host2:
      " Originally from Colombia, Lina has served as a brand ambassador at countless Miami boat shows, festivals, and other events in the experiential marketing industry for over seven years. She has represented brands from Facebook to Toyota and everything in between. She loves yoga, paddle boarding, and roller blading and is a world traveler. She knows Miami extremely well and is eager to help you plan your trip to Florida! ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "Ivonne   ",
        date: " June 2022",
        comment:
          " It’s great information about Miami, love the idea of sometime soon. Thanks Lina !!! It was nice talking to you. ",
        URL: "  https://a0.muscache.com/im/pictures/user/e013b06b-7c89-4c37-9c9d-dfa0fe31fec5.jpg?im_w=240",
      },
      {
        id: 2,
        name: " Arpitha ",
        date: "June 2022 ",
        comment: " Lina was absolutely amazing. Her presentation is truly a treasure trove of information on EVERYTHING you need to know about Miami. Every little detail she shared was narrated beautifully and was so thoughtful. I haven’t been more excited. Thank you, Lina and Alley Kat Adventures for this amazing experience! ",
        URL: " https://a0.muscache.com/im/pictures/user/9c67f4b5-3f49-4422-a3a8-3401b6fd3843.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: " Nicole ",
        date: " August 2022",
        comment: " Kat and Sara answered all of my questions and offered suggestions on some unique experiences in Miami. I’m looking forward to checking out Miami! ",
        URL: "https://a0.muscache.com/im/pictures/user/eaa3c70a-11f2-4ed2-b986-6c28925b1aac.jpg?im_w=240  ",
      },
      {
        id: 4,
        name: "  Verónica   ",
        date: "  June 2022",
        comment:
          " Brandi is lovely, it will be our first trip to Miami and thanks to her we are prepared with ideas of activities for the whole family. She gave me several tips that will surely save us a lot of time and money. valuable information, do not hesitate to booking with her. ",
        URL: "https://a0.muscache.com/im/pictures/user/fd32f3bd-35e8-4dd7-99a3-8b9850200a3e.jpg?im_w=240  ",
      },
      {
        id: 5,
        name: " Robin",
        date: "June 2022",
        comment:"    What a wonderful experience! I felt absolutely renewed afterward. It was so wonderful to be able to vocalize / hum / follow the tones while listening to the beautiful cello music and the chanting of sutras. I felt my whole being was vibrating to the pure tones!",
        URL: " https://a0.muscache.com/im/pictures/user/5ef86a3c-53dd-44a2-9d9c-b00994c16b69.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Derek ",
        date: "June 2022",
        comment:" The music is soothing, it brings calmness to the participants. I was breathing with the healing music, I enjoyed the heart and soul of this concert.  ",
        URL: " https://a0.muscache.com/im/users/14499432/profile_pic/1400699116/original.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 36,
    title: " Dive Under the Sea with a Shark Expert ",
    type: "popular",
    groupprice: "552  ",
    priceadult: " 125 ",
    pricechildren: " 78 ",
    priceinfant: " 0",
    ratings: "4.98 ",
    rating: "(850)",
    place: " Cape Town, South Africa   ",
    place2: " Cape Town   ",

    host: "Lesley   ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/f392d52c-72e8-42ee-8bf3-a13731fcf8f3.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1682332-active_media/original/ca6451b8-bc13-48a7-86e5-ff527afb0d7b.jpg?im_w=480  ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1682332-active_media/original/16b1983f-ff65-453e-ad50-7fd2751df4d7.jpg?im_w=480 ",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1682332-media_library/original/de234941-85ec-41f2-ac78-3b3e5f8c9423.jpeg?im_w=480 ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1682332-active_media/original/daa60bde-28c1-48a9-ae90-c7b4e42f3ff3.jpg?im_w=480  ",
      },
      {
        id: 5,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1682332-media_library/original/5179b6af-e5bb-43ca-b084-97bf59362771.jpeg?im_w=1440  ",
      },
    ],
    title2: "  Online experience hosted by Lesley ",
    time: " 60  ",
    language: " English   ",
  
    what1:
      "  A Best Selling Online Experience that supports our conservation work in South Africa!  “Very entertaining, the pace and information flowed!”  My interactive, fun-filled experience is rated 5 stars by individuals of all ages, and by teams from Facebook, Apple, Microsoft, Paypal, and so many more!  I host anything from 1 to 500 guests and willing to personalize the session or create a time that suits you – just let me know!  ",
    what2:
      " Expect to dive in with me as I share my 21-year career in shark conservation, shark research and campaigning in this story-telling, Shark Smart quiz, creative drawing and fact-filled experience. And I’ll give you a gift, my book called 'SHARKS' for free! ",
  
    what3:
      "  You’ll find out how I went from being called Shark Bait to the Shark Warrior, and how an extraordinary shark, Maxine, changed my life. She’s sure to swim into your heart as you follow her incredible journey from captivity to freedom.  ",
  
    bring1:
      " A smartphone, laptop, or tablet with stable internet connection to watch the live stream ",
    bring2:
      "An inquiring mind",
  
    hostsince: "2015 ",
    host2:
      " I love the ocean and sharks! I'm an award-winning conservationist, best known as the Shark Warrior because of my passionate efforts in shark conservation. Because I wanted to help save the oceans I founded a nonprofit organisation, AfriOceans, which focuses on ocean conservation. I'm also an author of children's books and educational books, an underwater and wildlife photographer, and a dive travel and expedition leader.   I love freediving with sharks! ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Allison  ",
        date: " June 2022",
        comment:
          "  My team booked a session with Lesley as a virtual bonding exercise and we couldn't have been more pleased! Her passion and enthusiasm for the subject matter bounced off the screen",
        URL: " https://a0.muscache.com/im/pictures/user/8d0138e5-a0c5-40e0-a686-3680492b1aa1.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: "Jennifer  ",
        date: "June 2022 ",
        comment: "  This was a fun event for our team at work. We’re exploring different ways to virtually connect and learn something new. We learned more about sharks, and it was a bonus we scheduled this during Shark Week.",
        URL: "https://a0.muscache.com/im/users/28397050/profile_pic/1424969820/original.jpg?im_w=240  ",
      },
      {
        id: 3,
        name: "  Laura",
        date: " August 2022",
        comment: " I did this experience as a team building activity for work. It was a great educational one, on a topic a lot of us were curious about. At the end I think we all thought about sharks a bit differently, helping to destigmatize them a bit. ",
        URL: " https://a0.muscache.com/im/pictures/user/3a8abf5c-eaa8-469a-b770-18b7dc30a4d4.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "  Danica   ",
        date: "  June 2022",
        comment:
          "  ",
        URL: " https://a0.muscache.com/im/pictures/user/6e6f87f0-958d-4f9c-974b-e63879fce855.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: "  Chelsea",
        date: "June 2022",
        comment:"  Lesley was a great story-teller! We joined Lesley for a corporate team event, and our entire team was enraptured by her stories and experiences. 10/10, would recommend! ",
        URL: " https://a0.muscache.com/im/pictures/user/a11648e4-9fc9-42d4-a6ad-c6c2bbb7e26f.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Miranda ",
        date: "June 2022",
        comment:" Wow what a great experience! Definitely one of my favorite workshops that I've ever had. The storytelling from Lesley and activities were so much fun. Sometimes it's hard to navigate virtual activities and they can feel a little long but not for this one. The hour went by fast, and everyone took so much away from it. I hope to bring another group to do one in the future! ",
        URL: "https://a0.muscache.com/im/pictures/user/c9fbe599-30f1-4f69-b2b0-04699098fe3d.jpg?im_w=240  ",
      },
    ],
  }, 
  {
    id1: 37,
    title: " Worlds Top Coffee Masterclass  ",
    type: "popular",
    groupprice: " 486 ",
    priceadult: "65  ",
    pricechildren: "60  ",
    priceinfant: " 0",
    ratings: " 4.89",
    rating: "(556)",
    place: "  Mexico City, Mexico ",
    place2: "Mexico City",

    host: "   Ricardo",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/af735a7d-2485-4722-9a78-66da24e3d8ad.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1655017-active_media/original/36cd73c3-bbe3-4952-86be-d6bfd5ba403f.jpg?im_w=480  ",
      },
      {
        id: 2,
        URL: " https://a0.muscache.com/im/pictures/aa717451-dbe6-44cc-bcbf-33694e17be43.jpg?im_w=1440",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1655017-active_media/original/a70d69cd-5101-4c93-8b4f-383ab5191759.jpg?im_w=240 ",
      },
      {
        id: 4,
        URL: "  https://a0.muscache.com/im/pictures/lombard/MtTemplate-1655017-active_media/original/8f76d8b9-a55c-48e7-a52a-6e89c0b10c6f.jpg?im_w=480",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1655017-active_media/original/8f76d8b9-a55c-48e7-a52a-6e89c0b10c6f.jpg?im_w=480 ",
      },
    ],
    title2: " Online experience hosted by Ricardo  ",
    time: " 60  ",
    language: "   English and Spanish  ",
  
    what1:
      " We are a great option for big groups and team buildings, some of our guests have been: Amazon, Google, Facebook. Very few people understand why they like what they like. We think most of us tend to eat and drink out of necessity, doing so in a hurry. We would like to fix that. ",
    what2:
      "  We will discuss what's considered a great cup of coffee and why. We will do this by covering some basic concepts about the neuroscience of flavor. Then, we will go through the different processes and ideas on how to brew the best cup of coffee. ",
  
    what3:
      "  Also we believe that coffee is about connection, inspiration, and drive. Some of the biggest changes of humanity have been inspired and fueled by coffee. We strongly believe that now is the perfect time to share a cup of coffee. ",
  
    bring1:
      " 1 piece of any other fruit that you love—if possible, mandarin or pear (if not, don't worry) ",
    bring2:
      " ingredents list  ",
  
    hostsince: "2015 ",
    host2:
      " Christian: I'm from Venezuela, I love coffee and I'm chemical engineer, specialized in food, barista trainer for the coffee national competitions in Borola Café and currently training for Q-grader and coffee taster. Owner of Privilegium brand, a company focused on expressing emotions and sensations through flavor. (Located in CDMX) Ricardo I'm a judge in Mexico's national coffee competitions and the founder and CEO of Borola Café, one of the most emblematic specialty coffee shops in Mexico City. In other words, I'm a professional coffee taster!  ",
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "  Lisa ",
        date: " June 2022",
        comment:
          " This coffee masterclass is amazing! Ricardo's knowledge and passion come through and I learned so much about how to shop for and prepare the perfect cup. I highly recommend this class to anyone that loves coffee. I am so glad I took the class. ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 2,
        name: " Kayla ",
        date: "June 2022 ",
        comment: " Christian was an excellent host! Our team had a great time learning and bonding over the experience. We learned a lot about coffee and each other’s preferences. ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 3,
        name: " Nychole ",
        date: " August 2022",
        comment: " I didn't know what I didn't know until I met Ricardo. I can't wait to use this new knowledge to grow my love of coffee. ",
        URL: " https://a0.muscache.com/im/pictures/user/580c6e34-a7a7-41ad-9347-95e17adf6877.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "   Pete  ",
        date: "  June 2022",
        comment:
          "  Ricardo is so amazing! He had our group on the edge of our seats! He has so much passion and technical knowledge! He has such a gift for explaining sensory experiences! Our group had a ball! We can't wait to start brewing our how coffee! Thank you so much Ricardo!",
        URL: "  https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
      {
        id: 5,
        name: "  Kathryn",
        date: "June 2022",
        comment:"  Christian was an excellent host! Our team had a great time learning and bonding over the experience. We learned a lot about coffee and each other’s preferences. ",
        URL: " https://a0.muscache.com/im/pictures/user/5b1d7cc1-c0b4-41b9-a693-de6856c0d86c.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Shilpa ",
        date: "June 2022",
        comment:" Christian was an excellent host! Our team had a great time learning and bonding over the experience. We learned a lot about coffee and each other’s preferences. ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
    ],
  },
  {
    id1: 38,
    title: " Discover Buenos Aires' Street Art & Sketch ",
    type: "popular",
    groupprice: " 280 ",
    priceadult: " 56 ",
    pricechildren: " 50 ",
    priceinfant: " 0",
    ratings: "4.87 ",
    rating: "(998)",
    place: "  Buenos Aires, Argentina ",
    place2: "Argentina",

    host: "  Flor ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/89155a51-987a-436b-852e-b1263118bf1c.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: "  https://a0.muscache.com/im/pictures/lombard/MtTemplate-1672202-media_library/original/46699233-8060-4cd9-989e-6af489c4673f.jpeg?im_w=480 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1672202-media_library/original/21486d3c-facd-4ed0-8abf-6887b77f6ed5.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1672202-media_library/original/b3035426-c8c7-497d-9111-ad6b5f147184.jpeg?im_w=480  ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1672202-media_library/original/bfba3d5c-dde0-43ee-9f3e-ebe94850709d.jpeg?im_w=480 ",
      },
      {
        id: 5,
        URL: "  https://a0.muscache.com/im/pictures/lombard/MtTemplate-1672202-media_library/original/b117fd84-256c-49b1-83e8-69bead8353ac.jpeg?im_w=480",
      },
    ],
    title2: " Online experience hosted by Flor  ",
    time: "  60 ",
    language: " English and Spanish   ",
  
    what1:
      "  Discover Buenos Aires' Street Art from the comfort of your home guided by a contemporary art curator, photographer and designer and connect with your inner artist!",
    what2:
      " This experience is great for large groups, team-building and schools (it's suitable for kids). It's been rated 5 stars by Google, Apple, Facebook, Amazon, Microsoft, Netflix, Uber, Spotify and many others! Recommended for connecting and celebrating online with colleagues and friends. ",
  
    what3:
      " During the first 45 minutes of the experience, you'll virtually travel to Buenos Aires to see a curated selection of murals placed in 5 neighborhoods: Palermo, La Boca, Puerto Madero, Chacarita and Banfield. This will be experienced through an interactive presentation with professional recorded videos and you'll be invited to play some games with polls. ",
  
    bring1:
      " Sheet of paper: letter or similar size (8.5 x 11 inches-21.59 x 27.9 cm) ",
    bring2:
      " stationary item",
  
    hostsince: "2015 ",
    host2:
      " I'm an art curator, professional photographer, artist & fashion designer who lives and works in Palermo, an artsy neighborhood in Buenos Aires. I've been documenting street art since 2011 when I fell in love with this art form and started researching this movement. In 2021 I won the Usina del Arte photography Award and “Vivamos Cultura” from the Ministry of Culture. Last May I exhibited my photography show “Ways of seeing” and in 2018 I was selected to participate in the collective art show 'Eternity' by Maurizio Cattelan in Art Basel Cities BA. ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
    comments: [
      {
        id: 1,
        name: " Jeffrey  ",
        date: " June 2022",
        comment:
          " Flor was fantastic! We did a tour for a coworkers birthday and we all had a blast. It was informative, interactive, fun, and very inspiring ",
        URL: " https://a0.muscache.com/im/pictures/user/87ef987a-ed5f-4a58-a326-3b51f5de18fd.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: " Tom ",
        date: "June 2022 ",
        comment: " My company did this as a team-building option for our dispersed team and everyone loved it! Flor's knowledge of the city and its art were impressive, and the polls were a great way to keep the team engaged. Everyone loved having time at the end to get a little creative and apply some of what we learned. Definitely recommend! ",
        URL: " https://a0.muscache.com/im/pictures/user/bdad2625-c7ca-4f2f-a2b1-d8db2e8e55c5.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: " Alisa ",
        date: " August 2022",
        comment: "We brought a small group of employees to Flor's wonderful experience and had the most wonderful time. Flor was creative, engaging, informative, and took the time to connect with our whole group.  ",
        URL: " https://a0.muscache.com/im/pictures/user/641ad317-2d39-4a20-b114-16b7fbaacd0c.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "    Ninad ",
        date: "  June 2022",
        comment:
          "  Booked this experience in the last minute for my 10 y/o son, who was graciously hosted by Flor. She is quite knowledgeable about street art in general, and most especially about the beautiful works on the streets of Buenos Aires. Highly recommended for all ages!",
        URL: " https://a0.muscache.com/im/pictures/user/91e04788-3ee6-4287-b221-f7444158dd5e.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: " Kelsey ",
        date: "June 2022",
        comment:"I highly recommend the virtual tour with Flor. It was very interesting, fun, and a casual atmosphere. We got a great impression of Buenos Aires and the artists. Great gift for friends or family!   ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 6,
        name: "  Elizabeth",
        date: "June 2022",
        comment:" We attended this experience as part of our team gathering and it was perfect team activity. I liked the drawing your art at the end, it was a good way to end the experience. Host Flor was amazing, accommodative and lot of passion for the topic. Its definitely a good experience, I recommend it. ",
        URL: " https://a0.muscache.com/im/pictures/user/01772dfe-dee7-49e2-9f2a-0d1a12816ff3.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 39,
    title: " Drink and Draw, blind contour art fun ",
    type: "popular",
    groupprice: " 256 ",
    priceadult: "  110",
    pricechildren: "  80",
    priceinfant: " 0",
    ratings: " 4.87",
    rating: "(155)",
    place: "  Gulfport, Florida, United States  ",
    place2: "   Florida   ",

    host: "  Angela ",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/8e6c6441-3e43-41a5-b631-00472ab5c025.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: "  https://a0.muscache.com/im/pictures/lombard/MtTemplate-2354288-media_library/original/4f991a88-11dd-4c41-9d72-35704afa2f96.jpeg?im_w=1440 ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-2354288-media_library/original/66fd958d-a21b-4345-9cb1-2487a26e3494.jpeg?im_w=480 ",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2354288-media_library/original/52962d55-ffa4-49bb-9b99-d5276226dabc.jpeg?im_w=240 ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2354288-media_library/original/55850f88-0a02-46e8-bad3-5573fdee5715.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: "  https://a0.muscache.com/im/pictures/lombard/MtTemplate-2354288-media_library/original/3d92794b-734b-4505-96e0-119534c2db62.jpeg?im_w=480",
      },
    ],
    title2: "  Online experience hosted by Angela ",
    time: " 60  ",
    language: " English   ",
  
    what1:
      " A perfect art activity and icebreaker for work teams. It’s a great and engaging way for teams to bond and let loose while still relaxing. Plus, it's encouraged to have your favorite beverages on hand during this experience. Drawing can be more fun when it includes adult beverages, but it is not at all required to have fun. ",
    what2:
      " In this 60 minute class, we'll learn how to make fast, abstract blind contour drawings. Blind contour is when you look at your object without looking down at the paper.  We'll warm up with quick activities like shading and cross-hatching. This practice warms up your hand-eye coordination and gets your mind and body for the next sections.  Then we'll spend 10 mins drawing any household object you want. Some common objects that guests love to draw are plants, shoes, or your cup. Then we'll share our drawings together.",
  
    what3:
      " Next we move onto portraits. While looking in the camera, guests will draw what they see without looking, or picking their pencils off the paper. As a fun side, whenever someone looks at their paper, we all have to take a drink! ",
  
    bring1:
      " Drawing tools: pencil and black sharpie or dark colored marker ",
    bring2:
      " Charged laptop or phone with zoom installed",
  
    hostsince: "2015 ",
    host2:
      " I am a professional artist with over 16 years of experience in painting and teaching to all ages and levels. I work in my art studio full time and create abstract paintings inspired by nature, landscape, and light in Florida.   St. Pete is my permanent home and I absolutely love living here. Prior to living in St. Pete, I lived in St. John, US Virgin Islands where I created, hosted, and led paint and sip events with locals and visitors coming to the island. ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
    comments: [
      {
        id: 1,
        name: "  Sara ",
        date: " June 2022",
        comment:
          "  Angela was engaging and a great host. We did the class as a teambuilding event and everyone had a good time. As a bunch of software engineers I loved how approachable the class was for a variety of skill levels.",
        URL: "https://a0.muscache.com/im/pictures/user/06d2e355-c469-495b-938c-dc09820b3be9.jpg?im_w=240  ",
      },
      {
        id: 2,
        name: " Liliana ",
        date: "June 2022 ",
        comment: "Angela was a friendly and knowledgeable host for this drawing experience. She made it fun for our group with her approach to this 'not experienced' group. We laughed, we attempted to draw and the idea of drawing objects and each other without looking at the paper ended up being just funny!   ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240  ",
      },
      {
        id: 3,
        name: " Keely ",
        date: " August 2022",
        comment: " My work team had a great time learning blind contour drawing! We had a mix of experienced artists and haven't done anything since middle school artists and everyone loved it! Would highly recommend, Angela made it so much fun! ",
        URL: " https://a0.muscache.com/im/users/6937471/profile_pic/1424259567/original.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "   Samantha  ",
        date: "  June 2022",
        comment:
          " This was so much fun! We joined Angela as a work group for a team building activity and I think everyone really enjoyed it. The drawing was accessible for all skill levels and Angela was a great host. ",
        URL: " https://a0.muscache.com/im/users/6494145/profile_pic/1370492536/original.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: " Sarah ",
        date: "June 2022",
        comment:"  We did this event for some virtual work team bonding, and it was so much fun and better than expected! The activities and prompts were great. Blind contour makes it accessible for all and evens out the activity even though we had a few skilled artists on our team. Very fun ",
        URL: " https://a0.muscache.com/im/pictures/user/45447786-6f1a-4f47-81b6-66a91f6f1b9a.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Ali ",
        date: "June 2022",
        comment:"  Angela was the sweetest and most fun host and teacher! She wove in a good balance of teaching and socialization; it was perfect for our work happy hour!",
        URL: " https://a0.muscache.com/im/pictures/user/59e881e0-7ec0-40af-93f4-cc8b938c30e9.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 40,
    title: " Spannendes Murder Mystery Spiel mit interaktiver Zaubershow  ",
    type: "popular",
    groupprice: " 150 ",
    priceadult: " 80 ",
    pricechildren: "50  ",
    priceinfant: " 0",
    ratings: "4.57 ",
    rating: "( 2560 )",
    place: "    London, United Kingdom  ",
    place2: "  London  ",
    host: "  Molim ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/12e91b57-d79f-44ca-98ee-ddfde0e7f8e3.jpg?im_w=240",
    images: [
      {
        id: 1,
        URL: "  https://a0.muscache.com/im/pictures/lombard/MtTemplate-2460171-active_media/original/772bcd78-45ff-4b49-89da-76826ffb194b.jpeg?im_w=1440 ",
      },
      {
        id: 2,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2460171-active_media/original/30a91a7b-f6f8-4308-855e-037b0e5f14df.jpeg?im_w=480",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2460171-poster/original/6e06f5ab-e6a2-4bdd-b267-c789e14fcc4c.jpeg?im_w=240 ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2460171-media_library/original/24a83614-4f1c-4f89-adc2-3dd9c374e53a.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-2460171-media_library/original/4eecdad3-d8ed-4de1-9d19-a471df054912.jpeg?im_w=480 ",
      },
    ],
    title2: "  Online experience hosted by Molim ",
    time: " 90  ",
    language: " English and German   ",
  
    what1:
      "  You may have been to an online escape room before, but have you ever attended an exciting murder mystery that is combined with real actors that you have to interact with? Or did you ever took part in a magic show? While you and your team are solving the case about a series of murders in Berlin of 1902, you will attend a live magic show of a mysterious magician. Is he the serial killer? Find out by interrogating him, live! ",
    what2:
      " Be amazed by the magic you see, puzzle as a team to solve thrilling riddles and mysteries, while interacting with snippets of Berlins history.  Whether you are team building, celebrating an event or just want to be entertained, this fun event will neatly fit the niche. ",
  
    what3:
      "  How it works: You receive a ZOOM link, there you will be greeted by Molim, your host:-) After a quick introduction and a briefing of what will transpire in the next ca. 1.5 hours, the game begins! ",
  
    bring1:
      "  ",
    bring2:
      " ",
  
    hostsince: "2015 ",
    host2:
      " Hi! Ich bin Molim El Barch, auch 'bekannt' durch Social Media als TheMagicMan, ein 36-jähriger professioneller Zauberer und Gedankenleser aus Deutschland. Ich begann im Alter von 21 Jahren mit Auftritten auf Partys und in Bars. Heute bin ich in ganz Deutschland auf Hochzeiten, Firmenevents, Varieté und auch online engagiert, um den Leuten ein Lächeln ins Gesicht zu zaubern :-) ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: " Shweta  ",
        date: " June 2022",
        comment:
          " We chose this as a teambuilding event and it's safe to say the entire team had a spectacular time. Molim allowed us to customise certain details which made the event more fun. He was funny and engaging, and had humorous responses to the moments where we put him on the spot or gave him unexpected answers. ",
        URL: "  https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240",
      },
      {
        id: 2,
        name: " Kristy ",
        date: "June 2022 ",
        comment: "  This was really nice to do as a virtual date night, and I enjoyed myself. Molim is a great host and a pretty cool magician - it was interactive, there were elements of surprise and I'm still wondering how he did that trick! Tickets were well worth the price and Molim was a thoughtful, accommodating organiser. Thank you for putting so much love into this!",
        URL: " https://a0.muscache.com/im/pictures/user/11cbf115-b7ba-43ab-b133-4f4f4933ef6b.jpg?im_w=240 ",
      },
      {
        id: 3,
        name: "  Katherine",
        date: " August 2022",
        comment: "Thank you Molim for a fun event! We had a great time and it was fun to combine the murder mystery with a magic show!  ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 4,
        name: "  Matthew   ",
        date: "  June 2022",
        comment:
          "10/10 Great time! My girlfriend and I decided to try a murder mystery for date night and Molim really facilitated an awesome experience for us. We had a great time all the way through, and Molim let us go over on time and really get into the roleplay/acting part of it all. Cannot recommend this experience enough--if you're on the fence about it, take that leap!  ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 5,
        name: " Damarie ",
        date: "June 2022",
        comment:"  Molim and Reiner have put together a wonderful experience that I am happy to have shared with my coworkers. It brought our our funny side and encouraged all of us to use our brains to be both smart and creative. Thank you! ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 6,
        name: "Yuri  ",
        date: "June 2022",
        comment:" A very fun experience for a team event. Molim was a very entertaining and personable host that made the event a lot of fun. Lots of laughs and just a good time. ",
        URL: " https://a0.muscache.com/im/pictures/user/e748756c-8e90-4270-b48a-86120caad320.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 41,
    title: "Cocktails Masterclass With Uk Champion  ",
    type: "popular",
    groupprice: " 256 ",
    priceadult: " 80 ",
    pricechildren: "70  ",
    priceinfant: " 0",
    ratings: " 4.97",
    rating: "(539)",
    place: "    London, United Kingdom  ",
    place2: "    London  ",

    host: " Pedro  ",
    hostimg:
      "https://a0.muscache.com/im/pictures/user/b6adcbbf-2edf-4a91-aa5b-5040dd4601a1.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1690740-media_library/original/7590ee27-de12-495f-8408-59ce8c81ba9d.jpeg?im_w=1440  ",
      },
      {
        id: 2,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1690740-media_library/original/bafebca7-f95d-4bbc-aa03-5e341b6e22f9.jpg?im_w=1440 ",
      },
      {
        id: 3,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1690740-media_library/original/9bed8ddb-dab8-460d-b7ac-04f9f7264624.jpg?im_w=240 ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1690740-media_library/original/6cd8665d-a512-4963-a05f-766914325a5a.jpeg?im_w=240 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1690740-media_library/original/1b00cd78-1494-42f1-b663-713825fbc887.jpeg?im_w=480 ",
      },
    ],
    title2: "   ",
    time: "   ",
    language: "    ",
  
    what1:
      " A rare opportunity to learn the fundamentals of Cocktail making with the best bartender in the UK in 2013.  This is great for groups and team buiding.  We will be making a Cosmopolitan, a Moscow Mule and one of my signature cocktails.  In this interactive online experience you will learn how to make world class drinks at home using readily available ingredients. ",
    what2:
      "   Cocktails are all about mixing great ingredients with passion, balance and present them in an outstanding way, they are also a celebration drink and a reason to bring people together and have fun. ",
  
    what3:
      " We will start with an introduction to the basics and do’s and dont’s when mixing drinks together, shortly after we will understand the importance of classic cocktails and the main families of classic cocktails. We will then prepare a refreshing classic cocktail together followed by a Journey over the most recent years and discuss the evolution of classic cocktails into the Neo Classic era and prepare a Neo Classic cocktail together.  ",
  
    bring1:
      " 4 OZ/ 120 ml of Crystal Head Vodka preferably, Beefeater Gin Works too! ",
    bring2:
      " 2 OZ/ 60 ml of Triple Sec/Cointreau ",
  
    hostsince: "2015 ",
    host2:
      " Pedro Paulo (@ppauloldn) is a leading figure in the Drinks Industry World Wide and the Beverage Manager at London luxury hotel One Aldwych including managing its spectacular Lobby Bar, and is an award-winning freelance consultant for prestigious cocktail bars across the globe. His accolades include Best International Bartender at the Lisbon Bar Show 2015, Best International Bartender 2017 by Drinks Diary Magazine, United Kingdom Bartenders Guild National Competition Winner 2013 and Galvin Cup winner 2012.  ",
  
      date: [
        { date: "25 Aug", time: "3:30" , id:1 },
        { date: "24 Aug", time: "3:30" , id:2  },
        { date: "24 Aug", time: "4:30" , id:3  },
        { date: "24 Aug", time: "5:30" , id:4  },
        { date: "25 Aug", time: "6:30" , id:5  },
        { date: "25 Aug", time: "7:30"  , id:6 },
        { date: "25 Aug", time: "8:30" , id:7 },
        { date: "26 Aug", time: "5:30"  , id:8 },
        { date: "26 Aug", time: "10:30" , id:9  },
        { date: "26 Aug", time: "3:30" , id:10 },
        { date: "27 Aug", time: "9:30" , id:11 },
        { date: "27 Aug", time: "6:30" , id:12 },
        { date: "27 Aug", time: "1:30" , id:13  },
        { date: "28 Aug", time: "3:30" , id:14  },
        { date: "28 Aug", time: "11:30" , id:15  },
        { date: "29 Aug", time: "12:30"  , id:16 },
        { date: "29 Aug", time: "9:30" , id:17  },
      ],
  
    comments: [
      {
        id: 1,
        name: "Sonja   ",
        date: " June 2022",
        comment:
          " This was such a fun team building event! Highly recommend and was so excited to have the recipes at the end. Thank you Pedro! ",
        URL: " https://a0.muscache.com/im/pictures/user/bd95b7b5-7076-4035-b26f-1ae89ade9e36.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: " Nathalie ",
        date: "June 2022 ",
        comment: " Pedro is not only a cocktail master, he is a knowledge expert in the history of cocktail making, which he shared while we were making cocktails. We learned a lot more than just making drinks! Great event! ",
        URL: "https://a0.muscache.com/im/pictures/user/4b7dfbe2-e753-49b4-a436-86163bc01ede.jpg?im_w=240  ",
      },
      {
        id: 3,
        name: "Kate Grumme  ",
        date: " August 2022",
        comment: " Pedro did an awesome job at telling interesting, relevant stories, letting our group chat and bond, and helped us create 3 delicious cocktails! His award winning cocktail was especially unique and yummy. I did this with a work team and it was perfect! ",
        URL: " https://a0.muscache.com/im/pictures/user/4b7dfbe2-e753-49b4-a436-86163bc01ede.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: "  Nicolas   ",
        date: "  June 2022",
        comment:
          " Great Session with Pedro! very nice, good cocktail-making walk through and stories! We would have loved to be able to stay connected after the session to finish our drinks (we do understand Pedro had to leave)... Great Experience though ",
        URL: " https://a0.muscache.com/im/pictures/user/ee1d2c9f-6477-4e6e-b4f6-4e3733ce1cfc.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: " Alison ",
        date: "June 2022",
        comment:"  I scheduled this class for my colleagues and everyone loved it! The class was fun, informative and the cocktails were delicious. Pedro also provided sub recommendations for mocktails and vegans. Highly recommend! ",
        URL: " https://a0.muscache.com/im/pictures/user/ad0b2d72-277e-47f5-8f0f-37055ad7ec3e.jpg?im_w=240 ",
      },
      {
        id: 6,
        name: " Marina ",
        date: "June 2022",
        comment:" Pedro was extremely knowledgeable and personable and did a great job breaking the ice and getting each participant engaged. Plus the cocktails were delicious! ",
        URL: " https://a0.muscache.com/im/pictures/user/9069860d-cc24-4823-8e9c-ec0a83baa558.jpg?im_w=240 ",
      },
    ],
  },
  {
    id1: 42,
    title: " Astrology Workshop, Birth Chart Reading ",
    type: "popular",
    groupprice: " 550 ",
    priceadult: " 110 ",
    pricechildren: " 100 ",
    priceinfant: " 0",
    ratings: "4.87 ",
    rating: "( 550 )",
    place: "  Lisboa, Portugal  ",
    place2: "  Lisboa ",

    host: " Andrada   ",
    hostimg:
      " https://a0.muscache.com/im/pictures/user/733fe8d2-820e-49f4-8ba0-4fc235984fed.jpg?im_w=240 ",
    images: [
      {
        id: 1,
        URL: "  https://a0.muscache.com/im/pictures/lombard/MtTemplate-1654052-active_media/original/61a87f4d-52f8-4e33-af15-f14a8adf4f3e.jpeg?im_w=1440 ",
      },
      {
        id: 2,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1654052-active_media/original/e9181d70-8f5f-41a8-b502-969f36187b09.jpeg?im_w=1440",
      },
      {
        id: 3,
        URL: "https://a0.muscache.com/im/pictures/lombard/MtTemplate-1654052-active_media/original/8d88f028-3d49-4be3-8cdc-12f59c7e1d28.jpeg?im_w=1440  ",
      },
      {
        id: 4,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1654052-active_media/original/d40713ec-7498-4b34-a819-04b36513d2cb.jpeg?im_w=1440 ",
      },
      {
        id: 5,
        URL: " https://a0.muscache.com/im/pictures/lombard/MtTemplate-1654052-active_media/original/c6a59a8b-6b95-4396-82ac-1600b85d565a.jpeg?im_w=1440 ",
      },
    ],
    title2: "Online experience hosted by Andrada   ",
    time: " 60  ",
    language: "  English  ",
  
    what1:
      " We will meet online from the comfort of our homes and we will have a unique approach for learning the symbols in your birth chart maps and understanding yourself and your loved ones a little better. ",
    what2:
      " I will bring insights into your Numerological profile, Human Design, Psychological, Traditional and Vedic Astrology.  We will look at the structure of your natal chart and I will explain how to understand your birth chart in simple easy-to-learn steps, and how it relates to your life patterns and the inherent energies you can tap int ",
  
    what3:
      "  * This is an interactive Experience great for a PRIVATE session but also wonderful for FAMILY members, couples, married couples, groups of FRIENDS, birthday celebrations, weekends, GIFTS, and wedding celebrations.",
  
    bring1:
      " Desktop, mobile, stable internet , a notebook ",
    bring2:
      "Please write to me after booking your birthday details ( year, month, day, hour, location ) to have time to prepare your map. ",
  
    hostsince: "2015 ",
    host2:
      " Hello, dear ones! I am a passionate professional Astrologer with over 10 years of expertise, gaining after studying 4 years a Diploma in Astrological Psychology and self-educated in traditional, Vedic astrology, numerology, esoteric astrology and Human Design. I love sharing my knowledge with others because I believe that we really can become the best version of ourselves as long as we are aware of our qualities and potential!  During these times, I will offer the astrology session online, giving you access after our meeting to your birth map  ",
  
    date: [
      { date: "25 Aug", time: "3:30" , id:1 },
      { date: "24 Aug", time: "3:30" , id:2  },
      { date: "24 Aug", time: "4:30" , id:3  },
      { date: "24 Aug", time: "5:30" , id:4  },
      { date: "25 Aug", time: "6:30" , id:5  },
      { date: "25 Aug", time: "7:30"  , id:6 },
      { date: "25 Aug", time: "8:30" , id:7 },
      { date: "26 Aug", time: "5:30"  , id:8 },
      { date: "26 Aug", time: "10:30" , id:9  },
      { date: "26 Aug", time: "3:30" , id:10 },
      { date: "27 Aug", time: "9:30" , id:11 },
      { date: "27 Aug", time: "6:30" , id:12 },
      { date: "27 Aug", time: "1:30" , id:13  },
      { date: "28 Aug", time: "3:30" , id:14  },
      { date: "28 Aug", time: "11:30" , id:15  },
      { date: "29 Aug", time: "12:30"  , id:16 },
      { date: "29 Aug", time: "9:30" , id:17  },
    ],
  
    comments: [
      {
        id: 1,
        name: "  Amy ",
        date: " June 2022",
        comment:
          " This was my second session with Andrada and she remembered things from my first session over a year ago and added more on top. She’s fun, engaging, personable and knowledgeable. She’s great for first timers or those experienced in astrology (and everything in between).  ",
        URL: " https://a0.muscache.com/im/pictures/user/74b2b1cb-e6c7-422b-89b5-af2b36603c20.jpg?im_w=240 ",
      },
      {
        id: 2,
        name: " Robin ",
        date: "June 2022 ",
        comment: "  Hosted for a work team event and we all enjoyed it. Andrada kept it professional and fun - which is hard to do in a group setting. Thanks so much! ",
        URL: " https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240 ",
      },
      {
        id: 3,
        name: " Veronica ",
        date: " August 2022",
        comment: "  This is my second time getting a birth chart reading from Andrada and it left me with a lot of clarity and peace. I highly recommend this experience!!!",
        URL: " https://a0.muscache.com/im/pictures/user/5cc6483c-00a8-4014-8da5-ff823942f227.jpg?im_w=240 ",
      },
      {
        id: 4,
        name: " Heidi    ",
        date: "  June 2022",
        comment:
          " Andrada was amazing. We booked her for our one year anniversary and she delivered! She has a great way of storytelling and explaining your birth chart and your human design. We had a hiccup on our wifi but she was so helpful and gave us extra time :) We will recommend this service to all our friends! ",
        URL: " https://a0.muscache.com/im/pictures/user/7ef29da0-5d1a-48d8-b51a-43a2a61d3051.jpg?im_w=240 ",
      },
      {
        id: 5,
        name: " Tara ",
        date: "June 2022",
        comment:" Andrada was an incredible host! She was able to navigate different circumstances for our Team. She had great communication from the beginning correspondence to the very end of our session. It was great for our Team and we received great feedback after out event  ",
        URL: "https://a0.muscache.com/defaults/user_pic-225x225.png?im_w=240  ",
      },
      {
        id: 6,
        name: "Marquita  ",
        date: "June 2022",
        comment:" My reading with Andrada was lovely. This is a great virtual experience for anyone with a desire to delve deeper into the connections between astrology, your human design map and numerology. It's also great for those with little to no experience with these tools. ",
        URL: "  https://a0.muscache.com/im/pictures/user/0b014913-d823-41fb-b05b-c24dfdfb2408.jpg?im_w=240",
      },
    ],
  },

  ]
  
  export default data;
  

  